module.exports = {
  "FoodB_backend_JOOu_ODDV": "ID do signatário",
  "Gattaran_optimization_yGvp_jOAe": "Confirmar",
  "Gattaran_form_tLLN_yhWQ": "As informações sobre uma pessoa para contato frequentemente usada serão preenchidas automaticamente. Você pode tocar para editar as informações.",
  "Gattaran_V1__YaIb": "Conectado",
  "FoodB_management_ncmO_lEBH": "Falha na emissão",
  "FoodB_2_Please_select_Mixz": "Selecione",
  "FoodOpB_Translation_Maestra_Accounts_ktyA": "Conta mestra",
  "FoodOpB_management_Special_rules_PdhA": "Regras especiais",
  "FoodB_up20241218_aEPD_NaLf": "Selecionar item(ns)",
  "FoodB_Commision_Add_MPEf": "Adicionar",
  "FoodC_202408_wten_GUVt": "Selecione o endereço de entrega",
  "FoodB_calculator_CXvv_RJgQ": "Valor a receber antes de impostos e comissão",
  "FoodB_tagging_You_chose_OMGB": "Você optou por invalidar este lead pelo seguinte motivo: “O estabelecimento não existe”. Para fazer isso, você deve enviar uma foto.",
  "FoodB_calculator_gRHL_Sgok": "Margem de lucro",
  "FoodB_collection_11_digits_QhYs": "Precisa conter 11 dígitos sem espaço",
  "FoodOpB_management104_Coordinator_endx": "Coordenador",
  "Help_V4_Enter_the_xqlm": "Insira um número de telefone válido",
  "Internal_Tools_CRM_afvI_xcXS": "Tamanho necessário da imagem: 750 x 360 px",
  "Gattaran_transformation__TnQQ": "Associar novo signatário",
  "Gattaran_merchantfee2_sTmZ_koaw": "O valor inserido não pode ser menor que {{min}}",
  "FoodB_0_Please_upload_ziBz": "Envie uma captura de tela do histórico de chamadas",
  "FoodB_phrase__NpWx": "Mostrando ofertas encerradas nos últimos {{number}} meses",
  "FoodOpB_1_Expired_rTXx": "Expirado",
  "FoodB_202303_YWUL_hwNF": "OK",
  "FoodB_page_aMFR_fMYY": "Falha no envio da gravação",
  "FoodC_Storefront_iOFy_aaef": "Este estabelecimento não está participando desta oferta",
  "Gattaran_0_Clerk_tends_QpMA": "Forma de contato preferida do funcionário",
  "FoodB_Show_Store_Direct_GuJM": "Contrato do aplicativo B",
  "FoodOpB_Management_Appeals_foxk": "Contestar",
  "FoodB_optimization__bdZL": "A imagem deve estar no formato JPG ou PNG, ter menos de 5 MB e ter pelo menos 200 x 200 pixels.",
  "Gattaran_management_NjMN_zyWQ": "Planejado · {{date}}",
  "soda-c-i18n---个人中心的“优惠券”": " Conta > Cupons.",
  "FoodB_1106_FGdT_UxXY": "Gerando resumo por IA",
  "Gattaran_opt_swMT_sNcV": "Combo da oferta",
  "Gattaran_20240401_rbqe_PoaI": "Esta pesquisa é obrigatória",
  "FoodC_sales_Confirmation_mTGd": "Entendi",
  "FoodOpB_v2_Data_update_YmPK": "Tempo de atualização dos dados",
  "FoodB_v1_Sources_of_DsXR": "Fonte de informação",
  "Gattaran_transformation__LMJQ": "Seu contrato foi assinado pelo signatário. Adicione o estabelecimento no Gattaran.",
  "soda-c-i18n---现金": "Em dinheiro",
  "FoodB_202502_ldlj_sqzT": "Enviar",
  "Internal_Tools_App2_HwDq_KOci": "Ter",
  "Gattaran_account_yBHw_QhdL": "Horário de funcionamento",
  "Internal_Tools_App_Bruh_XLwk": "Semana a semana",
  "Internal_Tools_App2_wNPW_VZxE": "Preço de mercado na bomba",
  "FoodB_1__gcdX": "Dados do evento",
  "Gattaran_statusbar2_eoSG_yEDD": "Aprovado",
  "Gattaran_record_IcKI_Jklz": "Editar visita",
  "FoodB_email_CBNM_cSdr": "E-mail",
  "FoodB_V2_Illegal_companies_pXwb": "Não registrado legalmente",
  "FoodOpB_1_New_visits_HXsz": "Criar visita",
  "FoodB_opencheck_LMsZ_xcHH": "Concluído",
  "FoodB_accompanyvisit_WSQI_ySkV": "O BD entendeu claramente as metas semanais e as prioridades de trabalho?",
  "FoodC_sidebar_Use_the_huoZ": "Instale o app para pedir quando quiser",
  "CS_Aftersale_Wrong_meal_gNCe": "Itens incorretos",
  "FoodB_management_Automatic_Switching_ghJS": "Fechar ou abrir o estabelecimento automaticamente",
  "FoodC_education_3_If_wduh": "3. Se um conflito relacionado à entrega não for causado pelo(a) entregador(a) parceiro(a), como um problema do produto ou o mau tempo, assumiremos a responsabilidade",
  "FoodB_opencheck_RrIx_AlOc": "Confira se a foto de capa é apropriada e exibida corretamente no aplicativo do cliente",
  "FoodB_scenario_UTGm_CSqz": "Entrega da loja atrasada",
  "Gattaran_202406_eUIt_lfFS": "Concluído",
  "Gattaran_feedback_pIVP_WMGv": "Enviado com sucesso",
  "Gattaran_0__Yqcw": "Não há estabelecimentos nesta área",
  "Gattaran_new_GrSG_JNHc": "Nível",
  "FoodB_communications_nVMa_oikA": "Incentivo de novo estabelecimento",
  "FoodB_opencheck_elIB_jhlk": "Certifique-se de que as informações do endereço e localização correspondem à localização real do estabelecimento",
  "FoodB_audit_Store_Information_ryuV": "Análise das informações editadas do estabelecimento",
  "Gattaran_form_xrZg_zpSi": "Resultado",
  "FoodC_202410_ZHQi_kNsP": "Editar",
  "FoodC_c_Completed_djPp": "Finalizado",
  "Gattaran_0516_AZMU_LSZh": "Lojas com assinatura",
  "FoodB_page_Zytk_sRrm": "Enviando gravação",
  "FoodB_list_Recently_launched_IWDa": "Última vez online",
  "Gattaran_add_vitO_CCPh": "Cobertura de imagem >= 60%",
  "FoodOpB_1_Seven_days'_LZwW": "Nos próximos 7 dias",
  "FoodC_202408_qXNe_iBNs": "Não foi possível obter a localização atual",
  "FoodB_optimization_TjHf_zaEo": "Não concluído",
  "更多": "More",
  "FoodB_APP_cmsF_AWtY": "Próximas ofertas",
  "Gattaran_202406_lujp_fWRq": "Descrição da tarefa",
  "FoodB_1__IhgO": "Última atualização: {{time}}",
  "FoodB_management_vyNi_SrTR": "Gerenciamento de suprimentos",
  "Gattaran_0__VRqN": "Todos os estabelecimentos foram carregados",
  "FoodOpB_1_Close_visit_ttxh": "Encerrar confirmação de visita",
  "Gattaran_Onboarding_VhSv_kUGS": "Informações do representante do estabelecimento",
  "Gattaran_side__MIpl": "Sexta-feira",
  "FSaaSB_app_kuws_Kquy": "Tipo de empresa",
  "FoodC_Website_From_shop_Jatv": "Faça um pedido no [nome do estabelecimento] | 99Food",
  "Gattaran_optimization_oRge_RkDM": "Tarefas concluídas da visita - {{month}}",
  "Gattaran_Optimization_zZhD_VHmE": "Toque para ver o endereço e permitir navegação",
  "FoodB_SMS__promotion_EKZy": "Promoção de entrega gratuita",
  "FoodB_pt1_pppx_zdcg": "Nº do cartão do banco",
  "FoodB_V1_oOpd_aRtv": "Não concluído",
  "FoodB_up250108_BLxC_rIzf": "Verificar depois",
  "Internal_Tools_App_CwAV_dUXQ": "Comentários",
  "FoodC_202412_DMKw_kWMA": "Pesquise por rua e número da casa ou CEP",
  "FoodB_1106_fJJY_Hpvo": "Gravar novamente",
  "FoodB_statistics__lkdP": "Minuto",
  "Gattaran_visit_zdKK_wwRk": "Resultado da visita",
  "Gattaran_opt_cWad_xQOF": "Pedidos imperfeitos",
  "FoodB_audit_Review_process_vGtV": "processo de análise. Você tem certeza que quer continuar?",
  "FoodB_page_hrsd_hBdh": "Tem certeza de que deseja sair? Se você sair, seu envio não será salvo.",
  "FoodB_page_bkdh_cEvr": "Gravar",
  "FoodB_in_WoaK_VhQt": "Confirmar",
  "FoodB_management_tchR_fhJi": "A ser emitido",
  "FoodC_20240607_ffiX_wNQG": "WhatsApp",
  "FoodB_20250122_FReB_KjrR": "Concluidor da tarefa",
  "Gattaran_Gattaran__OuWt": "Total de horas conectado",
  "Gattaran_20250610_NTRi_nVIB": "Concluir RTBO",
  "FoodB_collection_idCIF_qqcc": "idCIF",
  "FoodB_IGV_iopU_urly": "Taxa de IGV",
  "FoodB_calculator_vEpj_lLGl": "Desconto total",
  "FoodB_feedback_mdHs_sFsm": "Detalhes do feedback",
  "FoodB_0_WhatsApp_dmMD": "WhatsApp",
  "FoodD_Name_October_WGkU": "Out",
  "FoodC_202412_QJMa_Qkwg": "Insira um novo endereço de entrega",
  "Gattaran_opt_RltV_fDyM": "Item promocional (não combo)",
  "Internal_Tools_App_wlIb_LduM": "Telefone do posto",
  "FoodB_UI_RToR_WdHq": "Fechar",
  "FoodB_Show_Tax_payment_xfxh": "Impostos nacionais por transação",
  "Gattaran_Visit_Visiting_Process_KFJZ": "AVALIAÇÃO DA VISITA",
  "FoodB_V1_uXrr_bWox": "Você pode gerenciar ou redefinir os filtros aqui",
  "FoodB_opencheck_gjbJ_NUmG": "Horário de funcionamento",
  "FoodB_indicator_jKXT_ctMP": "Definição de métrica",
  "FoodB_2_VcBR_ZXSJ": "Nome do representante legal",
  "确认": "Avançar",
  "FoodB_communications_HAnw_bYAw": "Estabelecimento(s) tem(têm) tarefas incompletas",
  "FoodC_education_3_Customers_Zoec": "3. Mantenha seu telefone acessível durante a entrega para garantir que o(a) entregador(a) parceiro(a) consiga entrar em contato se necessário.",
  "Gattaran_KPI4_Sjnd_VzaZ": "Alerta do estabelecimento",
  "FoodB_1106_tawV_utGy": "Próximos passos",
  "Gattaran_function__iTSm": "Versão",
  "FoodB_list_B_Burn_LIiU": "B2C burn / GMV",
  "FoodC_202412_kamX_bNUi": "Selecione um endereço para adicioná-lo",
  "FoodC_20240607_fIqe_iMtS": "Aceitar",
  "FoodB_questionnaire_gISQ_iumh": "Tarefas de vendas",
  "FoodB_boarding_Name_of_ofQq": "Nome da pessoa jurídica",
  "FoodB_2_Store_XkLQ": "Estabelecimento",
  "FoodB_progress_eMmv_RfMT": "ID do loja",
  "FoodB_0622_Select_up_QXDl": "Selecione até 2 estabelecimentos",
  "FoodB_revamp_PrgK_BFoj": "Para as etapas específicas, consulte:",
  "FoodB_1106_isfE_qwXl": "Enviando arquivo de voz. Não saia desta página",
  "Gattaran_promo_MrxG_Yufr": "Orçamento da oferta inteligente",
  "FoodC_edit_NDmM_lEJY": "Encontrar o entregador",
  "FoodC_202408_HfXO_xbcw": "Ver",
  "Gattaran_202406_jhpc_QSnv": "Informações de referência",
  "FoodD_Questionnaire_Postal_KeGa": "",
  "FoodB_tagging_You_chose_aZCG": "Você optou por invalidar este lead pelo seguinte motivo: “Operação interrompida”. Para fazer isso, você deve estar a {{distance}} de distância do estabelecimento. Verifique e tente novamente.",
  "soda-m-i18n---押金$0": "Depositar R$ 0",
  "Internal_Tools_App_zuDQ_HAZF": "Insira um número (com até duas casas decimais)",
  "FoodB_in_RMIn_GztT": "Falha ao finalizar compra",
  "FoodB_accompanyvisit_xZuc_foEH": "Descreva como o BD se posicionou durante o engajamento: ele demonstrou empatia, praticou escuta ativa e construiu conexões genuínas com o cliente?",
  "FoodC_education__1_vwgm": "(1) Entregar na porta",
  "Gattaran_management_sGBh_ExWD": "Horário de funcionamento",
  "FoodB_resivion_Feedback_to_QmQU": "Informe ao seu supervisor para atualizar",
  "FoodB_0926__Jfhv": "Nenhuma oferta com este status",
  "FoodB_supplement3_Delivery_costs_HbwR": "Taxa de entrega feita pela loja",
  "Internal_Tools_App_vLxA_pkbn": "Adicionar imagem",
  "FoodB_2_PNEX_yvxA": "Informações sobre taxas",
  "FoodC_perception_Tips_hZWk": "Gorjeta",
  "Gattaran_0410_hDTJ_vhKk": "Clique aqui para ver informações de desempenho detalhadas.",
  "FoodB_0907__jtsj": "Sem dados de diagnóstico",
  "Gattaran_status_jQaO_nxvn": "Status do acompanhamento",
  "FoodB_20250122_IbZs_wRcg": "Reenviar a tarefa se ela não for concluída após X dias desde a criação",
  "Gattaran_0_Need_to_uMbb": "Verificará com o DM",
  "Gattaran_Visit_Evaluation_eRDU": "Autoavaliação",
  "Gattaran_V2_TPLj_miRJ": "Lista de lojas",
  "FoodC_optimization_rmLx_bSmk": "Pesquise o endereço de encontro para adicioná-lo",
  "Gattaran_optimization_mtXy_iWsc": "Selecione pelo menos 2 opções",
  "Internal_Tools_App_qYbb_MgvG": "Erro de sistema. Tente mais tarde",
  "Gattaran_0_Salesmen_tend_hFQf": "Melhor horário para contato do funcionário",
  "FoodB_Show_Foreign_DIMEX_LKxF": "DIMEX",
  "FoodC_education_Meal_picking_ziun": "Regras de entrega",
  "FoodB_management_sgrl_Drgj": "Outros",
  "soda-m-i18n---三个月试用期": "Período de teste de 3 meses",
  "Gattaran_0_Agree_gCQO": "Acordado",
  "FoodB_addon_MnfP_VIKl": "Recompensas da Tarifa 99",
  "FoodB_2_FSbr_muxp": "Tipo de documento",
  "FoodC_revision_Contact_customer_XbFk": "Fale conosco",
  "Gattaran_visit_jZLe_BSqN": "Volume de pedidos/7 dias",
  "Internal_Tools_App_mZpF_DDAl": "Tendência de preço",
  "FoodB_in_zsVG_TNBT": "Esta loja já fez check-in hoje. Fazer check-in assim mesmo?",
  "FoodB_1106_UJYm_mRFD": "Você pode editar o conteúdo gerado por IA e enviar a gravação final após a confirmação.",
  "FoodC_shop__hSnf": "Só resta(m) {{num}}",
  "Internal_Tools_App_vFxG_UzcO": "Status do lead",
  "FoodOpB_Management_High_similarity_lnFn": "Já existe um estabelecimento semelhante",
  "Gattaran_Visit_Change_1_LYvR": "TURNO 1",
  "FoodC_202410_mjfG_DDhf": "Adicionar",
  "FoodB_opencheck_hHbN_hIdN": "Confirme se o cardápio do comerciante está completo: as categorias estão corretas, os preços estão alinhados com os padrões da plataforma e a exibição no aplicativo do cliente é precisa.",
  "FoodC_page_AAmU_wxJS": "Avaliações",
  "FoodB_0905__yxOa": "Sem alteração em relação ao período anterior",
  "FoodC_improvement_Rgol_abYw": "Sua solicitação de cancelamento foi enviada e será processada pelo estabelecimento em {{XminYs}}. Agradecemos sua paciência.",
  "Gattaran_v1_Whrf_ZdCg": "Não inscrito. Inscreva no aplicativo do lojista.",
  "Gattaran_0_Is_the_dYmK": "Experiência do cardápio",
  "FoodB_feedback_LZDo_DoVn": "Feedback",
  "Internal_Tools_App_qWbF_LiGR": "Calibrar coordenadas",
  "Internal_Tools_App_kqPi_MVIx": "Atenção",
  "Gattaran_Homepage__bYLT": "Início",
  "Gattaran_0_The_end_KvBf": "A hora de término deve ser posterior à hora de início",
  "Gattaran_visit_Wpaf_mvuG": "O BD chegou a um acordo com sucesso",
  "Gattaran_Top_Qwud_sgUf": "2. A tag DiDi Top do estabelecimento é atualizada no 2º e 17º dia de cada mês",
  "Internal_Tools_App2_VFPY_BWgZ": "Dom",
  "Groceries_shop2_Fwyu_yymq": "Você só pode adicionar até {{num}} itens ao seu carrinho",
  "FoodB_page_kKLt_Kkxo": "Método de visita",
  "FoodB_1106_vPRw_ajcX": "Tem certeza de que deseja remover a gravação?",
  "Gattaran_AlertV1_ADYi_okAH": "Entendi",
  "Gattaran_V1_DJia_IZfI": "Conclusão",
  "FoodB_202309_timO_PnMJ": "Avaliações",
  "FoodB_in_pytn_Fsdo": "{{storename}} está a mais de {{distance}} metros de você, por isso, não é possível fazer o check-out. Tire uma foto com a placa do estabelecimento para concluir.",
  "FoodB_indicator_tnUG_juLY": "Taxa de pedidos com itens incorretos/faltando",
  "FoodB_indicator_WkbT_GJnu": "Regras de pontuação",
  "FoodB_scenario_ShEY_kNaS": "A loja está passando por dificuldades internas",
  "FoodB_0_SMS_yOMB": "SMS",
  "Gattaran_0_KP_Tendency_hgOB": "Melhor horário de contato do representante do estabelecimento",
  "FoodB_opencheck_jhOc_eZOf": "Esse estabelecimento tem horário de funcionamento inferior a 2 horas por dia. Confirme se isso está correto para prosseguir com o envio.",
  "FoodB_opencheck_TrQs_xHIv": "Você concluiu todas as confirmações de verificação em aberto para este estabelecimento. Todas as informações passarão por análise manual. Qualquer atividade fraudulenta encontrada afetará seu desempenho.",
  "FoodC_payment_eCqh_ogxh": "O pagamento on-line ainda não está disponível. Aguarde!",
  "FoodD_Name_February_bMVM": "Fev",
  "Gattaran_addded_wrMT_Smyq": "Desistir da oferta",
  "FoodC_202410_Ejdi_makf": "Selecione uma loja",
  "FoodB_list_Name_of_dxYm": "Nome do representante 99",
  "Internal_Tools_App_wjZO_XKBK": "Últimas {{week}} semanas",
  "Gattaran_REGULAR_UodO_bJVP": "O valor não pode exceder 100",
  "FoodC_202408_Jvou_Cqor": "Lugares próximos",
  "Internal_Tools_App_OMWw_QlWM": "Engajamento",
  "Gattaran_V1__ZtqD": "Ver tutorial de oferta",
  "soda-c-i18n---送您1张%s优惠券；": "daremos a você 1 cupom de %s de desconto.",
  "Gattaran_202406_WOhb_WMrp": "Você recebeu uma tarefa de alta prioridade. Veja a tarefa agora.",
  "FoodB_20250122_aETX_fsRi": "dia(s)",
  "Internal_Tools_App_MIpi_aqcx": "Meus postos de gasolina",
  "Gattaran_opt_ZoVs_IpEA": "Inicie a assinatura do contrato, veja o status da assinatura e os motivos da falha e muito mais aqui",
  "FoodOpB_management_Indicators_BzjD": "KPI",
  "Gattaran_visit_CRcg_FwpW": "Não",
  "Gattaran_management_wjiE_tOBX": "Olá, {{name}}. Em anexo estão os resumos dos contratos firmados durante a visita:",
  "FoodB_process_FzSw_LUcq": "Progresso do RTBO",
  "Internal_Tools_App_cuEn_PzWj": "Editar endereço de navegação",
  "Gattaran_Insights_QaTJ_hsGX": "Tipo de contrato",
  "FoodB_accompanyvisit_yiVS_jbCk": "Descreva a atitude do BD durante a visita de acompanhamento: ele permaneceu focado, proativo e profissional mesmo diante dos desafios?",
  "Gattaran_visit_jFvy_brWz": "Tarefas incompletas ({{uncompleted_tasks_number}}/{{tasks_number}})",
  "Gattaran_Visit_Formula_pre_iaaI": "Fórmula = (Pontuação do início do dia + Pontuação da reunião com o cliente + Pontuação do final do dia) / 3 * 100%",
  "FoodB_Dimension_UVvy_UnnT": "Valor médio dos pedidos",
  "Gattaran_Top_pXow_LHcq": "1. Quando os “Pedidos concluídos”, a “Taxa de cancelamento B” e a “Avaliação do cliente” de um estabelecimento atendem a certos padrões, que dependem da cidade e são detalhados na página Detalhes do estabelecimento, o estabelecimento será identificado como DiDi Top",
  "Gattaran_Optimization_WwkH_amBP": "Toque para ver mais contatos e fazer chamadas",
  "FoodC_optimization_GUGp_fDxe": "Voltar à página anterior",
  "FoodB_0830__BIGT": "Visitas ao estabelecimento este mês",
  "FoodB_time_No_permission_Xxyy": "Sem permissões",
  "Internal_Tools_App_Rmvn_wSCd": "ID do posto",
  "Gattaran_task_OkJn_sQyn": "Grupo de lojas",
  "FoodC_remark_Thank_you_ENoY": "Obrigada por escolher a {{brand_name}}",
  "FoodOpB_1_Information_gathering_pIHo": "Coleta de informações",
  "Gattaran_V2_mEQa_FFuE": "Detalhes da tarefa",
  "FoodC_dish_Current_activity_Iyrv": "Esta promoção termina em {{arrived_time}}. Depois disso, as ofertas para novos usuários estarão indisponíveis",
  "FoodB_in_Nxye_qBAZ": "Voltar",
  "FoodB_boarding_Store_logo_vzJz": "Logotipo do estabelecimento",
  "FoodB_email_mlcn_NvDS": "Forma de contato preferida",
  "soda-c-i18n---晚间：%s-%s": "Noite: %s-%s",
  "FoodB_2_Online_visit_OLuR": "Pessoalmente",
  "FoodC_202410_YFVb_hzJK": "Adicione um endereço",
  "Gattaran_V1__WcTv": "Índice de item qualificado",
  "FoodB_model20250116_iVfy_zMbV": "Check-in concluído",
  "FoodOpB_1_Visit_Details_fMYD": "Detalhes da visita",
  "FoodOpB_results_No_key_kUbv": "Nenhum contato de KP",
  "Gattaran_opt_ybdn_zFnD": "Preencha as informações de telefone que faltam",
  "FoodB_0919__flip": "Itens disponíveis",
  "FoodB_audit_Audit_process_asoS": "processo de análise. Você não poderá solicitar uma assinatura até que a análise seja concluída. Você tem certeza que quer continuar?",
  "FoodB_accompanyvisit_KOZp_Nkwc": "O BD conseguiu identificar os principais pontos problemáticos e orientar a proposta adequadamente?",
  "FoodB_calculator_dsiQ_vhFJ": "Valor a receber",
  "Internal_Tools_App_pFzG_uAQv": "Este lead expirou",
  "FoodC_202409_dTTH_bjFQ": "Este pedido foi concluído ou não existe e não pode ser visualizado",
  "FoodB_V1_tdXj_tAvG": "Tarefas do estabelecimento",
  "FoodB_CO_Bank_flow_KoLX": "Foto do extrato bancário",
  "FoodOpB_optimization_Store_Head_doOE": "Foto da capa",
  "Gattaran_202406_JcEF_NsbI": "Nome do estabelecimento",
  "FoodB_1106_qUmr_XNmN": "Falha no envio da gravação",
  "Gattaran_visit_PQZP_gcOK": "Sim",
  "Internal_Tools_App2_xWJN_ZxWx": "O plano de visita não pode ser recuperado após deletado",
  "Gattaran_Collection__cRDE": "Buscas recentes",
  "FoodC_Website_At_present_XpFw": "Não foi possível resgatar via web neste momento. Resgate o código da oferta no aplicativo",
  "FoodB_202204_Number_of_yYUn": "Pedidos avaliados negativamente",
  "Gattaran_0_Add_Image_xyvl": "Aumentar cobertura de fotos",
  "Gattaran_MSGCenter__JYjL": "Insira",
  "FoodC_edit_bZFb_ghVG": "Encontrar o(a) entregador(a) parceiro(a) fora do hotel",
  "FoodB_email_KYaO_tHVJ": "Operador de aplicativo",
  "FoodB_Show_Savings_uvSS": "Conta-poupança",
  "FoodB_wording_abRG_GdGn": "Responsabilidades, status e atributos",
  "Gattaran_opt_aDBh_QgeX": "RTBO",
  "FoodB_Sales_NPeL_QUgG": "Mostrar menos",
  "Gattaran_form_hRvn_xomV": "O número de telefone é obrigatório",
  "FoodOpB_1_Visiting_hours_yAJS": "Dia da visita",
  "FoodB_leads_Artificial_labcategory_UNzu": "Categoria da tag manual",
  "FoodD_supplement_Small_time_ycjv": "hora(s)",
  "Internal_Tools_App_csEG_rLit": "CNPJ do posto",
  "FoodB_management_BWhh_FPtG": "Sim",
  "FoodB_opencheck_LSiU_XQss": "Tempo de preparo do estabelecimento",
  "FoodB_list_Store_ID_GNUR": "ID do loja",
  "Gattaran_0__EDtg": "Ativar agora",
  "Internal_Tools_App2_PcSB_DsIH": "Qua",
  "Gattaran_0_App_Opertends_voML": "Forma de contato preferida do operador de aplicativo",
  "FoodB_system_offline_revV": "Offline",
  "FoodB_address_Submission_cfyI": "Enviar",
  "Gattaran_promo_UFOX_VCXc": "Itens promocionais",
  "FoodOpC_Notifications_Are_you_DIlk": "Deseja realmente remover?",
  "FoodOpB_manage_Details_IfVh": "Detalhes",
  "FoodB_0926__bEjZ": "Nenhuma oferta não iniciada",
  "FoodB_Side_HjnR_pape": "Vendas",
  "FoodB_CL_Individuals_VUHt": "Individual",
  "FoodB_reason_Contact_Courier_Fqog": "Entrar em contato com o(a) entregador(a) parceiro(a)",
  "Gattaran_202406_REeT_tgTh": "Tarefa",
  "FoodB_list_Brand_Name_pGTc": "Nome da marca",
  "Gattaran_transformation__IetC": "Criar novo signatário",
  "Gattaran_optimization_dYfW_WtFS": "Conclusão",
  "Gattaran_management_LaXK_Gsyq": "Minhas visitas",
  "FoodB_1106_LrXH_ibej": "Seu resumo com IA está sendo gerado. Isso pode levar de 1 a 5 minutos. Fechar esta janela não interromperá o processo. Assim que estiver concluído, você poderá visualizá-lo em Informações de Acompanhamento, na página Detalhes do Lead.",
  "FoodOpB_management_Actual_integral_xbDD": "Pontos reais",
  "FoodB_revamp_ILMa_lOnw": "Definição de métrica:",
  "Gattaran_optimation_Gchd_SmWz": "Pular",
  "FoodB_process_xaxm_WPYE": "RTBO pendente",
  "Gattaran_opt_dswD_GkVn": "Informações da visita",
  "FoodB_statistics_Heaven_fdUv": "Dia",
  "Gattaran_Optimization_Gbsd_oiSb": "PK da loja",
  "FoodC_202408_SXSA_LasS": "Adicione um número de celular para aproveitar mais vantagens",
  "FoodB_Explorer_First_completed_vwFM": "Horário de conclusão da verificação do primeiro estabelecimento",
  "FoodB_0905__qppX": "{{number}} pedidos a menos do que no período anterior",
  "Gattaran_management_yrfV_Wxnn": "Visitas expiradas · {{num}}",
  "FoodB_2_SApx_IEJM": "Endereço do titular do cartão",
  "FoodD_Name_December_Ykas": "Dez",
  "Gattaran_REGULAR_bTIM_MAXe": "O valor não pode exceder 1000",
  "Internal_Tools_App2_ZJkV_KWsU": "Visita(s) expirada(s) · {{num}}",
  "FoodB_opencheck_lCvT_CpyN": "Configuração de aceitação de pedidos em vários estabelecimentos",
  "FoodB_score_dGue_AVfi": "Sem alterações em relação ao período anterior",
  "Gattaran_jumpnewstore_mLmx_PSph": "Complete as tarefas de novo incentivo do estabelecimento para receber tráfego extra",
  "Gattaran_0516_bxzD_gtXp": "Lojas associadas",
  "FoodD_Compliance_About_to_fTcV": "Expira logo",
  "FoodD_Name_June_sECU": "Jun",
  "FoodB_in_sHcD_gWZN": "Tirar foto",
  "Gattaran_opt_hEOr_vnKB": "Clique aqui para editar informações básicas do lead",
  "FoodB_in_gwvR_PqVc": "Acesse o aplicativo do celular para tirar uma foto e enviá-la.",
  "FoodB_in_TaxL_JViY": "Sem registro de check-in. O horário da visita deve ser vinculado a um registro de check-in.",
  "FoodB_revamp_ibxC_nLBc": "Filtrar por “tempo real”: exibe o valor médio estimado do pedido em tempo real",
  "soda-m-i18n---入库未配置": "Check-in efetuado; não configurado",
  "FoodB_opencheck_LMWw_Ntdr": "Não concluído",
  "Gattaran_check_yZoX_KqZx": "Tem certeza de que deseja enviar esta foto? Se não for aprovada, o check-in falhará e poderá afetar seu desempenho",
  "FoodB_model20250116_dVSj_sFUN": "Aguardando análise",
  "Gattaran_side__EEqj": "Sábado",
  "FSaaSB_app_yRmt_ofDT": "Link do menu online da loja na {{brand_name}}",
  "FoodB_page_FeSg_DGnj": "Transcrição",
  "FoodB_opencheck_LuWf_IQwZ": "Conclua a chamada antes de confirmar",
  "FoodB_page_DaRX_EbCh": "Formulário de preenchimento automático",
  "Gattaran_Visit_jKcM_bAxG": "Fechamento de negócios",
  "Gattaran_Process20250815_FAmy_CJIx": "A solicitação da Tarifa 99 não foi aprovada. Você pode editar e enviar novamente",
  "Gattaran_0_Name_of_ZnnR": "Nome do funcionário",
  "Gattaran_form_AEYH_GXlL": "Confirmar informações do concorrente",
  "Gattaran_management_pWnp_hrQt": "Resumo",
  "FoodB_V1_DoLm_HYBb": "Não iniciado",
  "FoodB_opencheck_MGuv_oPMp": "Verifique se a configuração da impressora da {{99store}} está correta, se os recibos podem ser impressos e se as observações do pedido estão claras",
  "FoodB_V1_FPpu_unON": "Enviar cardápio físico/PDF",
  "Gattaran_20240401_CGBK_NFyI": "Pesquisa obrigatória",
  "FoodOpB_Translation_Foreigner_hMcE": "CE-Carnet Extranjeria",
  "Gattaran_0_App_operators_aRSs": "Melhor horário para contato do operador de aplicativo",
  "FoodB_1106_XQNm_orQN": "Quais são as principais atualizações, necessidades dos clientes ou problemas críticos?",
  "帮助中心": "Help Center",
  "Internal_Tools_App_ttnY_JnyP": "O contato principal foi atualizado",
  "Gattaran_optimization_TyQA_JkkG": "Atualizar",
  "FoodB_0919__RZJo": "Pedidos finalizados",
  "FoodB_Fields_HLXT_aPou": "Fotos do cardápio",
  "Gattaran_form_JZlB_BGSo": "Inserir motivo real",
  "Gattaran_feedback_IzpJ_EtUe": "Selecione o motivo da tarefa incompleta (obrigatório)",
  "FoodC_web_Only_1_ZddK": "Limite de 1 item",
  "FoodB_Optimization_YGkX_JqvJ": "A avaliação de desempenho do mês ainda não foi configurada no sistema. Entre em contato com a equipe de planejamento comercial para saber os resultados da avaliação",
  "FoodB_202502_FEyX_TQNW": "Logotipo do estabelecimento",
  "Gattaran_management_SBaW_IDnY": "Detalhes de e-mail",
  "soda-c-i18n---将赔付给您%s张免配送费券": "Você recebe %s cupom de entrega gratuita",
  "FoodB_accompanyvisit_IwGb_xDta": "O BD conduziu pesquisas de mercado suficientes e fez perguntas exploratórias direcionadas com base na situação real do parceiro?",
  "FoodB_1106_vAhW_qNLK": "Gravar novamente",
  "Gattaran_opt_SrLe_Wnrt": "{{change}} menos do que o último período",
  "Gattaran_V2_aXUA_FYif": "Insira o nome da tarefa",
  "FoodB_opencheck_zmzr_ekYy": "Foto de capa da loja",
  "Gattaran_202311_qwtt_tkJb": "Os estabelecimentos da hotlist são mostrados. Priorize esses estabelecimentos para acompanhamento.",
  "Gattaran_address_WKng_Kgqu": "Estabelecimentos no mesmo endereço",
  "Gattaran_management_iAiq_CSuB": "Já existe um plano de visita para este período. Edite e tente novamente",
  "FoodD_Name_March_cqIc": "Mar",
  "Gattaran_form_UTaZ_WTAv": "Você tem informações não salvas. Quer mesmo sair?",
  "FoodB_opencheck_qYIq_JnQa": "Nome do estabelecimento",
  "FoodOpB_Translation_Store_Delivery_Kaxq": "Área e horário de entrega da loja",
  "FoodC_education_2_If_SoSk": "2. Se um conflito relacionado à entrega ocorrer porque o(a) entregador(a) parceiro(a) não seguiu nossas regras, poderemos responsabilizá-lo(a)",
  "FoodC_education__unk_aOCD": "{{delivery_type}} Regras do aplicativo",
  "Gattaran_Visit_Please_choose_kUmR": "Selecione as pessoas acompanhadas",
  "FoodOpB_app_Need_for_inMl": "Reunião adicional agendada",
  "FoodB_calculator_UUgW_xBLd": "Contagem de itens",
  "soda-m-i18n---校验失败": "Não foi possível verificar",
  "小费": "Gorjeta",
  "Gattaran_V1__ccGl": "Últimos 30 dias",
  "FoodB_end_OHsS_OQva": "Informações básicas",
  "FoodB_Part1_Store_Name_jrHD": "Nome do estabelecimento",
  "Internal_Tools_App_rdCa_GHLw": "Latitude: {{lat}}",
  "sailing.crm-intl.普通": "Geral",
  "Gattaran_202412_lIzZ_rTMN": "Método de entrega",
  "FoodC_education__2_jwSo": "(2) Deixar na porta (com uma mensagem)",
  "FoodD_page_Manual_Accept_jCTW": "Aceitar manualmente",
  "Internal_Tools_App2_VhOQ_uUiq": "Objetivo: {{objective}}",
  "Internal_Tools_CRM_hPLY_Zkpg": "Rede",
  "FoodB_1106_EwXU_HfGg": "Que trabalho foi concluído?",
  "FoodB_Show_Subject_Information_RFOj": "Informações do representante legal/proprietário",
  "FoodB_indicator_vrlT_COvu": "Intervalo de dados",
  "Gattaran_0__dPUc": "É possível carregar até {{amount}} estabelecimentos. Clique para ver mais",
  "FoodB_SupportforweeklydimensionindicatorsinKPIspecialrules_ZxHy_LGCx": "Esta semana",
  "FoodB_v4_QCuD_iNCy": "Preencha corretamente os dados da pessoa visitada após a visita",
  "Gattaran_opt2_aPIx_GJQw": "Plataforma de operação",
  "FoodB_accompanyvisit_nTXs_ubxz": "Comente como o BD se preparou para a visita de acompanhamento: os objetivos estavam claramente definidos? O sistema de CRM foi usado de forma eficaz? O foco estratégico foi mantido durante a visita?",
  "Gattaran_0_Remind_store_lgTS": "Lembre o restaurante de se conectar",
  "FoodB_0920__QnBO": "Regras de diagnóstico não atendidas",
  "Gattaran_transformation__LRHh": "Associar signatário existente",
  "Gattaran_opt_XUCE_CQDw": "Editar informações de operações offline",
  "FoodOpB_10_Order_volume_WNmq": "Pedidos",
  "FoodB_resivion_Skip_qpSD": "Pular",
  "Internal_Tools_App2_aAXv_aRlS": "Sub-região {{number}}",
  "Internal_Tools_CRM_NNrK_cPfT": "Horário de funcionamento",
  "FoodB_model20250116_IADF_eXfa": "Check-out",
  "Gattaran_0_Promotional_materials_vvdT": "Materiais de marketing",
  "FoodOpB_CRM_Card_holder_NfIL": "Número do ID do beneficiário",
  "Internal_Tools_App_enKj_BRtS": "Preço",
  "FoodB_sob_tNpJ_cGze": "Dica: depois que esse número de telefone for vinculado à/ao {{shopname}}, os estabelecimentos podem usá-lo para acessar o site oficial do SOB, encontrar o estabelecimento e continuar o processo de associação. Após vinculado, o número de telefone não pode ser editado",
  "FoodB_email_Lqnd_eyfn": "Acordos e comentários",
  "Internal_Tools_App_oOXF_fLkh": "Confirmar",
  "FoodC_202410_SiDC_Empm": "Peça agora",
  "FoodB_process_URNV_nSAi": "Aprovada",
  "FoodB_pt1_jkHO_eZrn": "Fotos do cardápio",
  "Gattaran_status_nmHO_eiGS": "Visitado – Nenhum resultado positivo",
  "FoodB_I_UlHM_KKLT": "Pedidos",
  "FoodC_optimization_RLDn_cLAQ": "Adicionar o endereço de encontro",
  "Gattaran_change_vHTo_vLlI": "Nomes que começam com “Teste-” serão automaticamente reconhecidos como dados de teste. Altere o nome se forem dados reais",
  "FoodB_page_bAZB_UbSa": "Enviar arquivo de áudio",
  "FoodB_sob_ywDb_qwVV": "Após vincular o perfil, informe o estabelecimento para usar este número de celular para assinar o contrato no site oficial do SOB",
  "Gattaran_0__sGZg": "Fique à vontade para enviar seu feedback sobre o Explorador.",
  "Internal_Tools_App2_TIxP_DqBp": "Observações",
  "FoodB_Show_Aliens_Residence_creU": "Cédula de Residencia",
  "FoodC_sales_Condition_of_lnwg": "A embalagem estava lacrada? (opcional)",
  "Gattaran_Optimization_PLZM_XBgE": "Toque para ver a página da loja no 99Food",
  "Internal_Tools_App_Mldc_EJhb": "Mais",
  "分钟": "min",
  "Internal_Tools_App_mKHz_CpID": "Ver coordenadas",
  "FoodB_Show_Do_you_Tuop": "É obrigatório ter dispositivo eletrônico?",
  "FoodB_2_R_Burn_AyGL": "R burn/GMV",
  "Gattaran_V1_MQcd_ixfe": "Ver todos os estabelecimentos qualificados",
  "FoodOpB_app_Need_to_eGSb": "Requer mais marketing",
  "FoodB_202204_Online_Rate_EQQU": "Taxa online",
  "FoodB_accompanyvisit_YSoL_pTLj": "Planejamento e preparação",
  "FoodB_accompanyvisit_oTmI_wmHE": "O BD foi capaz de construir confiança genuína com base na situação do restaurante e no perfil do tomador de decisão?",
  "FoodC_202412_SxTA_sqKU": "Locais próximos",
  "Gattaran_task_SMaI_vDbo": "Número de tarefas concluídas / Número total de tarefas (dentro do período da tarefa)",
  "Gattaran_REGULAR_luKX_QwKw": "Informações de imposto do México",
  "FoodB_0905__ccXH": "Período de diagnóstico",
  "FoodC_remark_Enjoy_your_OvmD": "Bom apetite!",
  "Gattaran_0__XIOS": "Inserir número de estabelecimentos",
  "FoodB_score_DchG_OdBM": "Classificações da loja",
  "Gattaran_form_zKmF_tGJc": "Confirmar",
  "FoodB_opencheck_KYqZ_ipBk": "Confirme se o horário de funcionamento do estabelecimento é razoável e preciso. Se o horário parecer incorreto, confirme com o estabelecimento. Exemplos incorretos: funcionamento não superior a 2 horas por dia ou apenas durante a madrugada (1h às 4h)",
  "Gattaran_cancelation_CSTW_mefB": "Tarefa executada",
  "Gattaran_jumpnewstore_UjqV_XVxm": "Novo incentivo do estabelecimento",
  "Gattaran_202311_NpGG_CLsO": "Mostrar resultados a até {{distance}} do estabelecimento",
  "FoodC_reasons_Enter_a_Pnzg": "Descreva o problema em detalhes",
  "FoodB_V1_Yqgj_TuBe": "Expirado",
  "Gattaran_optimation_shNo_Pflo": "A página de formulário de visita fechou inesperadamente. Toque em “Reabrir” para voltar à última página em que você estava.",
  "FoodB_calculator_hmWL_DEwB": "Não",
  "FoodC_20240607_IbZr_cIyA": "Verifique o link do estabelecimento e tente novamente",
  "Internal_Tools_App_vOMm_KIrz": "Sair",
  "Gattaran_function__Comd": "Observações de lançamento",
  "Groceries_calculation_btkC_kGie": "QR Code",
  "FoodB_Upload_qSTm_LkAc": "Cardápio de balcão (físico)",
  "FoodC_education__4_QYXm": "(4) Você optou por dinheiro como forma de pagamento e se recusa a pagar na hora de retirar o pedido",
  "FoodB_V2_No_bank_plEI": "Não há dados bancários",
  "FoodB_Show_Final_Tax_XQQi": "Definitivo",
  "FoodB_opencheck_PWFs_yYqE": "Conectar-se e aceitar pedidos",
  "FoodC_education__3_ltNM": "(3) Outros fatores fora do seu controle que causam o cancelamento do pedido, como quando não conseguimos encontrar um(a) entregador(a) parceiro(a) para entregá-lo ou outro problema da nossa parte.",
  "FoodB_model20250116_QHad_xAWm": "Tipo de visita",
  "Gattaran_jumpnewstore_WVcO_LmBU": "Ver detalhes",
  "Gattaran_add_XrAW_datb": "Pratos disponíveis >= 5",
  "FoodB_up20241218_ZADd_MrpU": "Selecione entre um e cinco itens. Produtos alcoólicos e bebidas não podem ser selecionados.",
  "Gattaran_management_DvoF_BCCh": "Tarefas de visita",
  "FoodB_revamp_fDsZ_yTgh": "Concluir agora",
  "FoodOpB_CRM_Type_of_fbmW": "Tipo de ID do beneficiário",
  "soda-m-i18n---试用时间3个月": "Período de teste de 3 meses",
  "Gattaran_status_NNzP_nKcZ": "Assinado",
  "Gattaran_Collection__YHYF": "Recomendado",
  "FoodB_V2_Failure_to_sQaD": "Não atende aos requisitos",
  "FoodC_edit_fOqC_upyr": "Encontrar o(a) entregador(a) parceiro(a) na portaria",
  "FoodB_accompanyvisit_ucKi_dFmF": "Descreva a atitude do BD durante a visita de acompanhamento: ele permaneceu focado, proativo e profissional mesmo diante dos desafios?",
  "FoodOpB_management_Indicator_description_kePF": "Descrição do KPI",
  "FoodB_Show_Party_B_aVTH": "Informações da outra parte",
  "FoodB_Show_Tax_payment_Dbuz": "Impostos locais por transações",
  "Gattaran_transformation__PgJQ": "Informações do representante legal/proprietário",
  "FoodC_202410_KMCG_kJBn": "Alterar",
  "FoodB_calculator_pQIn_LdhF": "RFC válido?",
  "Gattaran_check_PQrg_hgsK": "Enviar foto de check-in",
  "Internal_Tools_App_AsKa_smrq": "Selecione o tipo",
  "FoodOpB_Translation_BD_with_Jqpl": "Foto do BD com a fachada da loja",
  "Gattaran_20240902_AmRI_DoWJ": "Motivo da recusa",
  "Internal_Tools_App_TwQH_yOgX": "Agência",
  "FoodC_all_No_reward_ocGJ": "Não há recompensas",
  "FoodB_0622_Contrast_jVys": "Comparar",
  "FoodOpB_Translation_Enter_CCI_YyDK": "Insira a conta CCI",
  "FoodOpB_CRM_Taxpayer_full_tMpR": "Nome completo do contribuinte local",
  "Internal_Tools_App2_GYGq_FzxS": "Há mais de {{number}} visitas offline planejadas para o dia. Os {{number}} primeiros planos de visitas pendentes serão selecionados para gerar uma rota.",
  "FoodB_communications_BCnM_evHy": "Estabelecimento(s) tem(têm) tarefas de incentivo de novo estabelecimento que expiram esta semana",
  "FoodB_APP_rOdA_ZxIz": "Oferta Inteligente",
  "Gattaran_v1_HLQw_cJDz": "Toque para mostrar detalhes sobre o horário de funcionamento do estabelecimento",
  "FoodB_supplement_No_data_jUGB": "Sem dados",
  "Gattaran_limit_NvlC_czdh": "Apenas o BD do estabelecimento pode executar esta ação",
  "soda-c-i18n---联系商家": "Falar com a loja",
  "Gattaran_transformation__pglh": "Salvar e voltar",
  "soda-m-i18n---信息变更协议": "Contrato de alteração de informações",
  "Gattaran_management_dWbz_DrVf": "Visitas presenciais concluídas · {{month}}",
  "FoodOpB_SIDE_Duration_GFHL": "Tempo de preparo",
  "Internal_Tools_App_IadN_oKZj": "Número da conta",
  "FoodOpB_management_Weight_sGBg": "Peso",
  "FoodB_V1_pmrO_ZtzK": "Concluído",
  "FoodB_2_mmEx_SkyZ": "Taxa de ativação",
  "FoodC_edit_cKhP_xcTQ": "Encontrar o(a) entregador(a) parceiro(a) na porta de casa",
  "Internal_Tools_App2_ZTtV_pIEN": "Gerar rota",
  "FoodC_202410_FxEp_LCxL": "Pagando",
  "FoodOpB_CO_Provisional_Tax_ZpCx": "Provisório",
  "FoodC_edit_DOXu_EYnd": "Exemplo: bata na porta, não toque a campainha. Você também pode carregar fotos dos arredores para ajudar o(a) entregador(a) parceiro(a) a entregar seu pedido no local correto.",
  "FoodB_accompanyvisit_hlno_QKSm": "O BD aceitou ativamente o feedback durante a visita de acompanhamento e demonstrou uma clara vontade de melhorar?",
  "Internal_Tools_App_uXeN_VtKY": "Cidade",
  "FoodB_Side_cJSW_giyr": "Pedidos imperfeitos",
  "Gattaran_V1__SttS": "Ofertas",
  "Gattaran_V1_qsGI_Ulsk": "Carregando dados, aguarde",
  "Gattaran_schedule_ajzu_twuj": "Limite atingido",
  "FoodB_opencheck_tUFp_hKlC": "Não há itens de verificação em aberto concluídos",
  "Internal_Tools_App2_yIFi_UEbZ": "Seg",
  "FoodB_0926__pZyK": "Nenhuma oferta em andamento",
  "FoodB_Show_ID_Card_BrxO": "Cédula de Identidad",
  "FoodB_Tracking_IRTU_sjuT": "Tipo de contrato",
  "FoodB_030_zOTR_tsWu": "Minha região-alvo",
  "FoodB_manager_sgsH_EpiM": "dia",
  "FoodB_1106_tybs_uREn": "Falha no envio do arquivo de áudio",
  "Gattaran_withdraw_Ofwd_NgCY": "Tenha cuidado: depois que esse processo de solicitação for cancelado, ele será encerrado e qualquer solicitação de assinatura subsequente precisará ser reenviada.",
  "Gattaran_merchantfee_Pqxr_WLCJ": "O valor inserido não pode exceder {{max}}",
  "Gattaran_pickup_Kxke_AjEr": "Aceita modo de retirada automática?",
  "Internal_Tools_App_SKgO_wHcV": "Número de telefone do contato financeiro",
  "Gattaran_V1_YDbp_akEe": "Todas as ofertas válidas",
  "FoodB_0706_Supplementary_photos_UKYQ": "Adicionar fotos",
  "Internal_Tools_CRM_CJvi_BeaN": "Sistema ERP",
  "Gattaran_status_ojzr_GNwA": "Visitado – Resultado positivo",
  "FoodB_revamp_rWFU_qICy": "Filtrar por “mês do calendário”: exibe a pontuação de integridade da loja no último dia do mês do calendário",
  "Internal_Tools_App_SvGD_UfGw": "Dados operacionais",
  "FoodB_2_dPdw_iWMi": "Anexo(s)",
  "FoodB_indicator_lunF_LWgo": "Cálculo",
  "FoodOpB_1_Visiting_Status_rbMX": "Status da visita",
  "FoodB_audit_Distance_between_BRSw": "Distância entre estabelecimentos novos e antigos",
  "FoodD_2_Income_Vqfp": "Ganhos",
  "Gattaran_visit_hVDr_ZoMA": "Ver visitas recomendadas",
  "FoodB_record_HWEd_dEzy": "Tudo",
  "FoodC_notice_fOyQ_lqIn": "O pagamento em dinheiro está indisponível. Verifique se o valor do pedido excede seu limite ou se você tem outro pedido pago em dinheiro em andamento e tente novamente.",
  "FSaaSB_4_PPOG_xnOl": "Informações {{brand_name}}",
  "Gattaran_0__uLBv": "Inserir número de pedidos",
  "FoodB_210811_No_tax_QkcN": "Documento fiscal ausente",
  "Internal_Tools_CRM_RyhE_fFHt": "E-mail do contato principal",
  "Internal_Tools_App_ujvr_QghX": "Imagens do posto de gasolina (limite de envio: {{amount}})",
  "Gattaran_V11_fscy_YDKX": "Requisitos",
  "FoodC_20240607_wfRH_rTAa": "Informações do estabelecimento",
  "Gattaran_form_rnAn_flyZ": "O número de telefone ou as fotos do representante do estabelecimento precisam ser inseridos",
  "FoodB_collection_Taxpayer_Postal_guUo": "CEP do contribuinte (nacional)",
  "FoodB_1106_foqL_RTHY": "Descreva o conteúdo a seguir por meio de gravação de voz, envio de áudio ou entrada de texto:",
  "FoodOpB_Translation_Start_withholding_vzAG": "Quando iniciar cobrança",
  "FoodC_202412_nXPk_kwtQ": "Endereço não encontrado? Tente pesquisar por rua e número da casa ou CEP",
  "Gattaran_20240401_LMVL_IKxX": "Sair do aplicativo",
  "FoodB_1106_AyGO_yZLr": "Verifique se sua conexão está estável e toque em “Analisar novamente” para gerarmos o resumo por IA de novo.",
  "FoodOpB_tagging_You_chose_obli": "Você optou por invalidar este lead pelo seguinte motivo: “Operação interrompida”. Para fazer isso, você deve estar a {{distance}} de distância do estabelecimento. Verifique e tente novamente.",
  "FoodB_management_Business_hours_VLnY": "Horário de funcionamento normal",
  "FoodB_2_pQiY_xzxv": "Taxa de cobrança",
  "FoodB_scenario_LpfM_MGER": "Outros problemas",
  "FoodC_edit_hDGv_arOT": "Encontrar o(a) entregador(a) parceiro(a) na recepção no térreo",
  "Gattaran_Visit_Personal_Goals_FDcw": "Objetivo pessoal / aprendizado",
  "Internal_Tools_App_Hrci_mwCF": "Endereço do posto de gasolina",
  "Gattaran_mgt_Search_Results_pFNV": "Resultados de pesquisa",
  "FoodB_420241024_mWia_Agjc": "Não alcançado",
  "FoodC_education__1_mJTG": "(1) Se o estabelecimento já tiver confirmado e aceitado o pedido, você poderá usar o recurso “Cancelar pedido” para entrar em contato com o estabelecimento e solicitar o cancelamento. Se a loja não aceitar a solicitação porque já preparou o pedido ou por outro motivo razoável, você não poderá cancelar o pedido gratuitamente. Caso insista em cancelar ou se recuse a aceitar o pedido, no todo ou em parte, você deverá pagar todas as taxas pertinentes ao pedido.",
  "Gattaran_mgt_Indicates_that_nHWP": "indica “Não atingido”",
  "Gattaran_V1__hUDQ": "Serviço",
  "FoodB_0_Please_upload_BZIQ": "Envie uma captura de tela do histórico do chat",
  "FoodB_Show_Current_NJqK": "Conta-corrente",
  "Gattaran_0_Clerk_nZnx": "Funcionário",
  "FoodB_CL_power_of_KgHH": "Procuração",
  "FoodB_2_CIUw_hBMd": "Pessoa de contato da outra parte",
  "FoodC_edit_iuIV_BOva": "10 minutos",
  "Gattaran_mgt_Sort_QiOq": "Ordenar",
  "FoodB_list_KP_Phone_qQCQ": "Telefone do representante do estabelecimento",
  "FoodB_feedback_LxAh_DNGY": "Histórico",
  "Gattaran_AlertV1_CYCs_NjzG": "Toque aqui para ver os estabelecimentos que exigem sua atenção",
  "Gattaran_jumpnewstore_lspf_nNoN": "Toque aqui para abrir o módulo de novo incentivo do estabelecimento e ver os detalhes da tarefa para ajudar a loja a concluir as tarefas relevantes",
  "FoodB_V2_dLkl_pbiF": "Para executar essa ação, atualize para a versão mais recente do aplicativo",
  "FoodB_1106_QRoy_iWHx": "Iniciar gravação",
  "FoodB_opencheck_zqHl_BKuO": "Tem certeza de que deseja marcar este item de verificação em aberto como incompleto?",
  "FoodB_model20250116_innF_fIuu": "Checkout concluído",
  "FoodB_management_Store_association_coYB": "Afiliação do estabelecimento",
  "FoodC_202408_ksyj_sXlp": "Sobre o estabelecimento",
  "Internal_Tools_App2_tYvt_cIHY": "Hoje",
  "Gattaran_store_ylep_UGpm": "Assinatura completa de contratos através do portal oficial",
  "FoodC_202412_dCuL_VUFU": "Atualizar",
  "Gattaran_0_Are_there_ouHJ": "Tem mais restaurantes",
  "FoodC_202412_bolI_YXBT": "Endereços salvos",
  "FoodD_Storefront_YFcS_cnUy": "Seu Negócio na 99",
  "Internal_Tools_App_WpuB_Tmys": "Sim",
  "FoodC_202412_Oant_EESB": "Avançar",
  "Gattaran_0_Edit_contacts_nCLZ": "Editar pessoa para contato",
  "Gattaran_20250610_qChL_aFTc": "Entre em contato com o estabelecimento para confirmar o contrato e concluir o RTBO",
  "Gattaran_function__fALF": "Cancelar",
  "FoodB_method_hwZM_aUnb": "Baixar o Explorer",
  "Gattaran_Feedback__urHD": "Baixo",
  "Internal_Tools_App2_NTbv_hmkk": "Nenhuma informação da visita",
  "FoodB_management_Automatic_closing_xRSd": "Fechar estabelecimento automaticamente",
  "Gattaran_opt2_UTsL_QVlH": "Outros",
  "Gattaran_Visit_Total_score_iZIW": "AVALIAÇÃO TOTAL",
  "Gattaran_202406_xlNL_HNSV": "Recomendamos fazer upload das informações de tipo de arquivo no GTR > página Gestão de tarefas de venda",
  "FoodB_2_RroD_vqJk": "Banco emissor",
  "FoodC_202408_RRtT_ZjIG": "Adicionar endereço de entrega",
  "FoodC_20240607_hhNB_mCBD": "Número de celular",
  "FoodB_2_AOP_VVZV": "AOP",
  "FoodB_email_QTTk_ZllR": "Enviar contratos para a marca",
  "FoodB_V1_raHO_jXSF": "R burn/GMV este mês",
  "FoodB_20231012_GZve_uPZM": "Foram definidas regras de cálculo de prazo para esse tipo de tarefa. Não as insira novamente.",
  "FoodB_2_WdmF_TVYJ": "Tipo de signatário",
  "FoodB_diagnosis_Items_qQOR": "Item(s)",
  "FoodB_accompanyvisit_WLlY_tKoQ": "Plano, sistema e objetivos da visita de acompanhamento",
  "FoodB_field_No_need_hToz": "Não obrigatório",
  "FoodB_2__YqWB": "Motivo da recusa",
  "Gattaran_management_KxhN_ECCi": "Tablet obrigatório?",
  "FoodC_edit_Fyzp_tERt": "O(A) entregador(a) parceiro(a) entrará em contato com você quando chegar e aguardará no local combinado por {{time}}. Prepare-se para atender ligações",
  "Internal_Tools_CRM_nTMX_ElyI": "Localização exata do posto de gasolina",
  "FoodOpB_Translation_Passport_jpaq": "Passaporte",
  "Gattaran_Visit_Pre_visit_NLpf": "AVALIAÇÃO PELA PREPARAÇÃO",
  "FoodB_opencheck_qJag_QHzZ": "Configurações de aceitação e entrega de pedidos",
  "FoodB_2_btuN_DvIR": "Informações do dispositivo",
  "FoodB_requirement_uBiP_YocR": "Taxa de pedidos não preparados no prazo",
  "Internal_Tools_App_RxZj_EZmI": "Esta semana",
  "Gattaran_Visit_Tracking_KfAS": "Acompanhamento",
  "FoodB_calculator_CcKA_weRh": "Apenas para referência: o pagamento final às lojas pode ser deduzido devido a cancelamentos, após emissões de vendas ou outros motivos.",
  "FoodC_202408_qGSr_IQoW": "Editar",
  "FoodB_SupportforweeklydimensionindicatorsinKPIspecialrules_jzvk_uOqN": "Acumulado do mês (MTD)",
  "Internal_Tools_App_QNzF_fvmK": "Status do contrato",
  "Gattaran_add_MyGp_GdUb": "avatar",
  "FoodOpB_1_Visit_today_hLhX": "Hoje",
  "soda-c-i18n---提交申请": "Solicitar cancelamento",
  "FoodB_sob_FZWe_QYdT": "O número de celular {{num}} está vinculado. Oriente o estabelecimento a usar esse número para acessar o site oficial do SOB e assinar o contrato.",
  "Gattaran_function__PRSL": "Baixar",
  "Internal_Tools_App2_drNi_CAgA": "Qui",
  "FoodB_page_ErfH_yeAb": "Envie um comprovante da visita, como capturas de tela de conversas, reuniões online ou e-mails.",
  "Gattaran_0_Consistent_with_CiFN": "O mesmo que cardápio",
  "FoodOpB_v2_Type_BpqS": "Tipo",
  "FoodB_1106_zLsQ_PVUN": "Método de acompanhamento",
  "FoodB_1106_UWHB_lYiW": "Transcrição da gravação",
  "FoodB_1106_oEsa_BYuK": "Quais são os próximos passos?",
  "Gattaran_visit_uIke_aoLu": "Descrição da métrica",
  "FoodC_202408_cjXm_VVcd": "Se sair, você não poderá ver seu pedido",
  "Gattaran_0_Buy_gifts_dbKh": "2x1, 3x2, 4x3, 5x4",
  "Gattaran_statusbar2_QzkZ_tHWY": "Rascunho",
  "FoodB_clockin_NbrI_oMtd": "Horário de check-in",
  "FoodB_2_dfjc_UyDL": "Valor",
  "FSaaSB_app_dLDp_hbhH": "Cobertura do serviço",
  "FoodB_opencheck_UtkB_sIJi": "Checagem aberta concluída ou não",
  "Gattaran_0_No_match_Tgve": "Entrega gratuita",
  "Gattaran_Onboarding_qcvM_eKJN": "Informações fiscais",
  "Internal_Tools_App_UIXX_nKyD": "Filtre os dados de até 360 dias",
  "Gattaran_visit_nNId_fOhX": "O BD teve uma visita válida",
  "Gattaran_REGULAR_irYR_Bntt": "Se você não sabe se o RFC é válido, copie o ID fiscal e verifique-o no site oficial abaixo:",
  "FoodOpB_Tool_Telephone_dAiP": "Telefone",
  "FoodOpB_Tool_Delivery_DVnd": "Entrega",
  "Gattaran_opt_ikuS_aRyl": "Resultado da visita",
  "Gattaran_check_MOTH_SWGd": "Você fez check-in às {{time}} hoje. Menos de 10 minutos se passaram desde então. Tem certeza de que deseja fazer check-out? Isso pode afetar seu desempenho.",
  "FoodC_revision_Less_meal_pHwq": "Pedido incompleto",
  "FoodB_2_JpQk_PLSh": "Informações do representante legal",
  "FoodB_page_gpRd_UWVk": "Falha na geração do resumo",
  "Gattaran_Visit_Rating_after_lruO": "AVALIAÇÃO DO FIM DO DIA",
  "FoodB_1106_uIrJ_FVVL": "Quais são as principais atualizações, necessidades dos clientes ou problemas críticos?",
  "FoodB_communications_UOIk_QdZg": "Conclua as tarefas de incentivo de novo estabelecimento para obter vantagens extras. As tarefas expiram em {{task_left_days}} dia(s)",
  "FoodOpB_Translation_Please_add_mxTD": "Envie um dos seguintes documentos: carta de autorização do representante legal, certificado de registro da empresa, certificado de atualização de status",
  "FoodB_page_NuZX_bcTU": "Processo de visita e principais atualizações para gravação",
  "FoodB_revamp_rHuI_wbds": "Filtrar por “ontem”, “últimos 7 dias” e “mês do calendário”: exibe o número de pedidos finalizados pela loja durante o período selecionado",
  "FoodB_2_mfKY_fvJg": "Entrega da loja",
  "FoodB_Show_Delivery_commission_mVxE": "Entrega direta pela taxa para entregas feitas pelo estabelecimento",
  "FoodB_Fields_CnCd_RzYS": "Em análise",
  "FoodB_optimization_Needs_IovK": "Obrigatório",
  "FoodC_method_Wait_keAM": "Aguardar",
  "FoodOpB_management_Corresponding_fractions_QlGf": "Pontos",
  "Gattaran_2022P1_Subject_Name_viNV": "Nome do signatário",
  "FoodB_boarding_Name_of_QuHz": "Nome do titular do cartão",
  "FoodB_CL_Simple_company_JBRG": "Empresa (Simples)",
  "FoodC_edit_bxpb_udFq": "Exemplo: Edifício Central, Avenida Central nº 88",
  "FoodB_IV_Open_shop_xlhI": "Abrir estabelecimento automaticamente",
  "Gattaran_visit_xnVQ_bENu": "Áreas para melhoria",
  "Gattaran_0_Package_fweo": "Combos",
  "FoodB_2_IJZE_PnUS": "Aceita modo de retirada automática?",
  "Internal_Tools_App_SruZ_Bhfa": "Localização exata",
  "FoodB_1106_eUGB_DZjs": "Principais atualizações",
  "Internal_Tools_Ops_ouPX_WYmu": "ID do posto de gasolina",
  "FoodB_1106_oWun_aWqC": "Sem atualizações importantes no momento",
  "Internal_Tools_App2_laAj_weWi": "Continuar",
  "Gattaran_Visit_After_a_ILbF": "Final do dia",
  "Gattaran_20240902_ahLx_jQSe": "A tarefa {{tasktype}} criada para {{shopname}} foi recusada. Preencha as informações de referência da tarefa de acordo com o motivo da recusa.",
  "FoodB_page_YAuh_BBZp": "Resultados da análise",
  "FoodB_0622_Store_management_ztNB": "Operações do estabelecimento",
  "FoodB_202402_TFYh_dasm": "Outros",
  "FoodB_revamp_yOZl_Jyez": "Valor médio dos pedidos",
  "FoodB_optimization_Business_Properties_tURJ": "Propriedades comerciais",
  "FoodB_2_phDI_Aept": "Enviar mensagem comprovatória",
  "Gattaran_202406_SQiw_AXZW": "Gestão de tarefas de venda",
  "Gattaran_tag_mnOh_LlIQ": "Oferta expirando",
  "Gattaran_V1__zewR": "Menu",
  "Gattaran_store_HrLF_aQuF": "Cadastro",
  "Gattaran_Collection__twwL": "Você pode ver o registro de visitas completo aqui",
  "FoodC_202408_tlOV_uOmJ": "Adicione seu número de celular para aproveitar mais descontos em pedidos",
  "FoodB_1106_grLB_GkRM": "Se você sair da página durante o envio, o resultado atual não será salvo.",
  "FoodB_communications_hhCR_kEAh": "Estabelecimento(s) tem tarefas que expiram esta semana",
  "FoodB_FAQ_RQfm_qTIo": "Em comparação com ontem:",
  "Gattaran_page_DWAi_yiXk": "Assinatura de contrato do estabelecimento",
  "Internal_Tools_App_pynL_unFB": "Tipo de comerciante",
  "Gattaran_V11_DQdi_QRqK": "Não alcançado",
  "Gattaran_mgt_Performance_data_ymwM": "Dados de desempenho",
  "FoodB_field_Needs_IbzB": "Obrigatório",
  "Internal_Tools_CRM_APZA_BShD": "Informações básicas",
  "Internal_Tools_App_NkMV_mnZQ": "Localizar no mapa",
  "FoodB_management_pBMo_Pdsx": "Copiado para a área de transferência",
  "FoodB_Side_Etep_PIxp": "Atraso no tempo de preparo",
  "FoodB_1106_ACTr_mhVt": "Confirmar",
  "Gattaran_0_Visit_Information_hzgb": "Informações da visita",
  "Gattaran_opt_KdGX_oUmM": "Assinar contrato",
  "FoodB_executors20241225_bYiY_UfOD": "Lógica de atribuição automática",
  "Gattaran_center__TkvV": "Nenhuma mensagem",
  "soda-b-homepage-i18n---首位必须是1，必须输入11位": "O primeiro dígito da senha deve ser 1, e devem ser introduzidos 11 dígitos",
  "Gattaran_Visit_APP_Review_nbGn": "Análise do aplicativo",
  "FoodOpB_Org_Add_at_nQez": "Deve ser adicionado pelo menos um KPI. Verifique e tente novamente.",
  "soda-m-i18n---自动下线": "Desconectar automaticamente",
  "Gattaran_form_nFaJ_bcHw": "Pessoa para contato",
  "soda-m-i18n---自动上下线": "Iniciar e desativar automaticamente",
  "FoodB_1106_jqDc_LmDv": "Falha ao enviar a gravação. Verifique se sua conexão está estável e tente gravar novamente.",
  "Groceries_1_MhVY_Etfm": "Item alterado",
  "Internal_Tools_App_AFZd_haQA": "Grupo",
  "FoodB_collection_Enter_idCIF_NeUD": "Insira o idCIF",
  "Internal_Tools_App_XqPY_lOag": "Métodos de pagamento",
  "FoodB_accompanyvisit_tcgk_TvAZ": "O BD utilizou o sistema de CRM com habilidade para organizar visitas e planejar tarefas de acompanhamento?",
  "FoodB_Show_Provisional_Tax_xJRc": "Provisório",
  "Gattaran_side__sOcs": "Terça-feira",
  "Gattaran_REGULAR_OPsx_JMnf": "Calcular",
  "FoodB_202402_RxAj_UFpT": "Usuários",
  "FoodB_opencheck_EdLx_RFyR": "Verifique as configurações de conexão e aceitação de pedidos na {{99store}}",
  "soda-m-i18n---自动上线": "Ficar online automaticamente",
  "FoodB_scenario_YcnE_hnLK": "Endereço em área de risco",
  "FoodB_up20241218_VRuL_OZqJ": "Pré-cadastro da campanha",
  "FoodB_audit_The_strings_NPFx": "Clicar em “confirmar” iniciará o processo de análise “{{strings}}”. Não é permitido solicitar assinatura de contrato até que a análise seja concluída. Continuar?",
  "Gattaran_cancelation_divJ_nbOW": "Tarefa não executada",
  "Gattaran_Mode_DJzU_JeyE": "Modo de empresa",
  "FoodB_revamp_tOYW_dwAT": "Filtrar por “tempo real”: exibe a receita estimada da loja em tempo real",
  "FoodB_feedback_PCwL_NbGi": "Não foi possível enviar o feedback",
  "FoodC_1_dXUH_ThDd": "Ver mais",
  "Gattaran_Visit_View_Visit_eZdF": "Ver planos de visita",
  "FoodB_revamp_jEtx_GUqT": "Pontuação de integridade",
  "Gattaran_Process20250815_EISY_wPEZ": "A solicitação da Tarifa 99 está em análise",
  "GDriver_B_apbe_dntZ": "Nome do posto de gasolina",
  "Internal_Tools_App_lbMG_ilBX": "Serviços adicionais",
  "Gattaran_v1_guwq_yflY": "Toque para mostrar os detalhes da oferta de campanha",
  "FoodB_Show_Settlement_Information_rcRc": "Informações de pagamento",
  "FoodB_2_TDdO_bwkd": "Foto do contrato",
  "FoodC_edit_oOAR_FExH": "Edifício comercial",
  "FoodC_202412_MrwA_fRUi": "Este estabelecimento está fechado no momento. Volte mais tarde",
  "FoodB_0707_Lifted_off_tnXl": "Indisponível",
  "Gattaran_ProgressManagement_ArNE_PsZi": "Responsável",
  "FoodB_email_qdfP_heFs": "Olá! Visitamos seu estabelecimento {{store_name}} e fizemos a seguinte avaliação junto com {{person_to_be_visited}}:",
  "FoodB_management_osog_jVEE": "Amigo/Familiar do proprietário da loja",
  "FoodB_0113_ZcCF_NbjE": "Você pode adicionar um plano de visitas aqui",
  "Gattaran_0__VQyB": "Meus estabelecimentos",
  "FoodB_Show_Special_residence_ezfV": "Permissão especial de permanência",
  "FoodC_202408_ajMC_lsta": "Loja fechada",
  "Gattaran_visit_Oqpo_usBg": "Recebeu uma visita nos últimos 8 a 14 dias",
  "FoodB_audit_Review_Opportunity_ZQHk": "Análise de informações básicas do lead editado",
  "FoodC_202408_RTrU_hOhN": "Ative as permissões de localização. Para fazer isso, acesse as configurações do seu telefone, selecione o aplicativo, ative as permissões de localização do aplicativo",
  "FoodB_audit_Click_OK_Zfsf": "Clicar em “Confirmar” para adicionar o",
  "Gattaran_V2_xKud_MVWh": "O BD não pode se registrar para lojas",
  "FoodB_time_All_day_TIsU": "Fechado o dia todo",
  "FoodC_page__iyoe": "Mostrar menos",
  "FoodB_accompanyvisit_DoUc_ZSSY": "O BD conseguiu explicar os próximos passos aos tomadores de decisão e registrar com precisão as tarefas e os planos de acompanhamento?",
  "FoodB_1106_PVUq_gUVg": "Entrada de voz",
  "soda-c-i18n---将赔付给您1张%s折扣券": "Você recebe um cupom de %s de desconto",
  "FoodB_0622_Sales_KRCg": "Volume de vendas",
  "FoodB_page_gnPj_beOZ": "Fale em voz alta claramente o seguinte:",
  "Internal_Tools_CRM_MKcO_yldx": "Fonte de leads",
  "Gattaran_opt_JcLo_plhe": "Horas online",
  "FoodOpB_1_Fill_in_QvuH": "Criar plano de visitação",
  "Internal_Tools_CRM_fHSX_VjzW": "Localização exata incorreta. Selecione novamente",
  "FoodB_Fields_xUKf_huqZ": "Nome do estabelecimento",
  "Gattaran_0_Increase_in_yvaq": "Aumentar horário de funcionamento",
  "Gattaran_202406_wmja_Unkw": "Executor da tarefa",
  "FoodB_score_Klld_iIZA": "Novo",
  "FoodB_page_zXlL_VKXp": "Criar gravação",
  "Internal_Tools_App_sOCx_HZNJ": "Horário comercial hoje",
  "FoodC_202412_PwIG_QPFY": "Insira um endereço",
  "Gattaran_opt_jfHC_vGTC": "Pedido no mês até o momento",
  "Internal_Tools_CRM_eqgV_MrAE": "Insira longitude e latitude válidas",
  "FoodC_202408_PJcq_SjqG": "Opa! Não há informações de contato disponíveis para este estabelecimento",
  "Internal_Tools_App2_oKVZ_QNJf": "Plano de visita criado com sucesso",
  "FoodB_infomation_braW_sRbm": "Tipo",
  "FoodB_0322_gUpY_CIHG": "Nenhuma loja corresponde aos seus filtros",
  "FoodB_Show_Companies_Limited_xsLB": "Empresa - Sociedade anônima",
  "FoodB_list_Apply_for_RxQn": "Solicitar assinatura",
  "FoodB_field_Is_you_uNye": "Sujeito ao pagamento de IVA nacional?",
  "soda-c-i18n---延迟送达%s分钟以上": "Atraso superior a %s minutos",
  "Gattaran_invalid_Itxj_ruEf": "Os leads inválidos foram removidos. Aplique um filtro ou use o recurso de pesquisa se quiser encontrá-los.",
  "Internal_Tools_App_ROpA_rFNd": "E-mail do contato financeiro",
  "Gattaran_0_Using_Store_khfo": "Dispositivo para APP B",
  "FoodB_calculator_hPAw_BZlP": "Valor do imposto cedular de Guanajuato",
  "Gattaran_202406_rpdn_vXVr": "Observações",
  "FoodB_clockin_guJt_eDVT": "Expirado",
  "FoodB_accompanyvisit_YOaS_TWOq": "O BD entendeu claramente os objetivos da visita de acompanhamento (metas e prioridades semanais) antes de começar o trabalho todos os dias? A visita foi planejada de forma estratégica (por exemplo, área, perfil de restaurante)?",
  "FoodC_homepage_Search_for_CiMZ": "Encontrar refeições",
  "FoodB_task_ROBF_tTxm": "Categoria da empresa/das vendas",
  "FoodB_model20250116_wlQy_yyEp": "Hora da visita",
  "FoodB_Fields_ecRi_VRjb": "Foto da fachada da loja",
  "Internal_Tools_CRM_hQxQ_PeNI": "Tipo de posto",
  "Gattaran_0_Full_gift_nhuV": "Compre X leve Y",
  "FoodB_b_Source_of_qGPd": "Origem da campanha",
  "FoodB_0_Please_upload_roTo": "Envie uma captura de tela do histórico de e-mails",
  "Gattaran_status_Gnih_zZzX": "RTBO",
  "FoodB_2_uPrf_VINK": "Nome da outra parte",
  "FoodB_opencheck_BcIJ_lgZH": "Pedido de teste",
  "FoodB_email_NJBQ_LwUX": "Não é possível enviar e-mails para este contato porque ele não contém um endereço de e-mail. Adicione um endereço de e-mail e selecione o contato novamente.",
  "Gattaran_0_App_Operator_HJuu": "Número do operador de aplicativo",
  "FoodB_202202_Minutes_tWiN": "min",
  "Gattaran_V2_XvaI_scMD": "Última atualização: {{update_time}}",
  "FoodB_revamp_VnXr_HYcX": "Filtrar por “tempo real (hoje)”, “ontem” e “últimos 7 dias”: exibe os dados mais recentes da pontuação de integridade da loja obtidos em tempo real para o período selecionado",
  "FoodB_calculator_WFgZ_JmvX": "Calculadora de pagamento",
  "FoodC_education_Principles_of_RKEk": "Regras para resolver conflitos relacionados à entrega",
  "Gattaran_mgt_Search_History_DIkw": "Histórico de pesquisa",
  "Gattaran_check_vGAi_DEkA": "Lembrete de check-in",
  "Gattaran_center__IJmL": "Mensagens",
  "Gattaran_schedule_eLPM_Vdmp": "Continuar",
  "Gattaran_visit_Zykg_WdpB": "O BD foi preparado para a visita",
  "Gattaran_Feedback__QIxb": "Outros",
  "FoodB_2_Vbaq_cSPK": "Cargo da pessoa de contato da outra parte",
  "FoodB_up20241218_WbCj_pCMp": "Pré-cadastro para a campanha de item promocional do novo estabelecimento",
  "Internal_Tools_App_xIAG_xcRt": "O filtro mínimo é de 30 dias",
  "Gattaran_form_HAwV_aOvm": "Resultado da visita",
  "FoodB_opencheck_BEkt_nVNw": "Confirme se o tempo de preparo do estabelecimento é razoável, pois isso afeta o prazo de entrega",
  "FoodB_process_PFDy_CuVh": "Em análise",
  "soda-m-i18n---已签收电子回执": "Recibo eletrônico foi assinado",
  "FoodOpB_Translation_General_accounts_NeVu": "Conta-poupança",
  "FoodB_accompanyvisit_lehr_PbIH": "O plano da visita de acompanhamento considerou critérios estratégicos, como perfis de vendedores, características regionais e oportunidades de evolução?",
  "FoodB_in_pQps_Boqn": "Tirar outra foto",
  "soda-m-i18n---暂无": "Nenhum",
  "FoodB_CL_Store_Subject_RHFT": "Tipo de signatário",
  "FoodC_MVP_ASpO_MFfF": "Detalhes do pedido",
  "Internal_Tools_App_wStM_yTkP": "Localização do posto de gasolina: {{Address}}",
  "Gattaran_side__EgXn": "Segunda-feira",
  "FoodC_details_Refund_Details_sGIk": "Detalhes do reembolso",
  "Internal_Tools_App2_evQx_VnhU": "Nome/CNPJ do posto de gasolina",
  "FoodB_250430_GwJd_SQQB": "Nível do estabelecimento",
  "FoodOpB_CRM_Taxpayer_Address_ptqR": "Endereço do contribuinte local",
  "Gattaran_Visit_Management_and_JkoC": "Gerenciamento e próximas etapas",
  "Gattaran_Visit_Select_a_YAtw": "Selecione uma data para a visita de acompanhamento",
  "Gattaran_center__vsus": "Clique para ver detalhes",
  "Gattaran_management_cYvq_XraB": "Nenhuma informação de visita",
  "Gattaran_transformation__njrW": "Nome do signatário",
  "FoodB_Rebuild_Start_up_uSAL": "Taxa de implementação",
  "Gattaran_Visit_New_escort_zHov": "Criar uma visita de acompanhamento",
  "FoodB_calculator_tLev_cAgO": "Pagamento eletrônico",
  "Gattaran_uikey_qCBF_mlck": "Oferta comercial",
  "FoodB_new1_Name_similarity_gepH": "Nomes muito parecidos",
  "Gattaran_V1_JVoT_DmFC": "Ver",
  "Gattaran_opt_qiBN_MCGQ": "Retirar",
  "FoodB_page_tFIa_cbzN": "Grave ou envie um clipe de áudio. Após o envio, um resumo da visita será gerado automaticamente. Limitações: a gravação pode ter até 120 segundos e o arquivo de áudio enviado não pode exceder 50 MB.",
  "Gattaran_202311_xiHr_yFIi": "Recomendado",
  "Gattaran_optimization_Tore_pnsp": "Sua localização parece ter mudado. Quer atualizar esta página?",
  "Gattaran_form_hGfR_KtSN": "Adicionar resultado da visita",
  "Gattaran_management_gqoK_XBEn": "Hoje",
  "Gattaran_page_tcVj_BzPA": "Ajude o estabelecimento a entrar no aplicativo 99Food Admin. para concluir a assinatura do contrato e o RTBO",
  "FoodC_202408_sbmp_YFyl": "Localização atual",
  "Gattaran_check_GECm_BKRI": "Sua localização atual está a mais de {{distance}} metros da loja. Se a foto for rejeitada, o check-in falhará e pode afetar seu desempenho.",
  "Gattaran_202406_TbgT_vOga": "Quer mesmo enviar? Depois de enviar, não será possível fazer modificações.",
  "FoodB_Show_Not_applicable_jXBz": "Não aplicável",
  "FoodB_accompanyvisit_TVci_lcvJ": "O BD administrou adequadamente as tarefas de acompanhamento, incluindo coleta de documentos, assinatura, downloads, pedidos de teste e o processo de associação do restaurante?",
  "FoodB_management_XyCn_tCtF": "Emitido",
  "FoodB_Side_ZUeL_zYXD": "Pedidos cancelados",
  "Gattaran_20240902_KYYY_BwXS": "Descreva o motivo para recusar a tarefa",
  "FoodB_opencheck_XJFL_avly": "Confirmar",
  "Gattaran_V1_IUgS_cyMV": "estabelecimento(s) podem se registrar",
  "FoodD_problem_I_see_NhGG": "OK",
  "FoodB_optimization_Contract_No_GvBj": "ID do contrato",
  "FoodB_list_Online_Inspection_rExT": "Inspeção do estabelecimento",
  "FoodB_20250122_WEun_Whes": "Pré-requisito para atribuição de tarefa",
  "Gattaran_202406_lKot_vsVa": "Baixe o arquivo do sistema GTR > módulo de gestão de tarefas de venda",
  "FoodB_v12_iuCB_kwbr": "Existe algum integrador logístico?",
  "Gattaran_function__DqfF": "Atualização da versão",
  "FoodB_switch_yJQj_DSir": "Participação nas ofertas 100% patrocinadas",
  "FoodB_Show_Colombia_ID_igRe": "Cédula de ciudadanía",
  "Groceries_brand_bqwY_mhhq": "Criado com sucesso",
  "FoodC_sales_Supplementary_information_ihyk": "Detalhes adicionais",
  "FoodB_revamp_bLmK_xXBk": "Conversão do pedido",
  "FoodB_accompanyvisit_wPYQ_hebq": "Orientação para processos de negócios e resultados",
  "FoodB_2_Planned_bPON": "Em planejamento",
  "Internal_Tools_App_dIhB_OKLN": "Definir como contato principal?",
  "FoodB_2_fGxM_YHeU": "Ciclo de Recompensa da Tarifa 99",
  "FoodB_accompanyvisit_QWRh_eKLI": "O BD tem a prática de registrar automaticamente visitas e coletar dados RTBO para inserção imediata no sistema?",
  "FoodB_1106_jWEH_dYMs": "Analisar novamente",
  "FoodB_opencheck_ybHy_nAdV": "Telefone do estabelecimento",
  "FoodB_Wordings_iyFv_fDmW": "Observações adicionais",
  "FoodC_education_In_the_nIgD": "Você será responsabilizado por um cancelamento nas seguintes situações:",
  "FoodB_Show_Companies_Limited_hFAJ": "Empresa - Sociedade de responsabilidade limitada",
  "Gattaran_schedule_yPeR_CtMc": "Há mais de {{number}} planos de visitas presenciais para o dia selecionado. Os primeiros {{number}} planos de visitas serão selecionados automaticamente para gerar uma rota para você",
  "FSaaSB_app_sPPX_wsmO": "Plataforma de aceitação de pedidos utilizada",
  "FoodC_202412_SJdc_Bwta": "Não é um local próximo? Toque no botão à direita para atualizar sua localização.",
  "FoodC_dish_New_guest_bkGC": "No primeiro pedido",
  "FoodC_202408_WiRK_SITI": "Adicionar endereço",
  "FoodB_in_kJaI_fOxY": "Você tem check-in(s) em aberto. Faça o check-out primeiro para vincular o horário do check-in.",
  "FoodB_GTR_rBBn_RmKL": "Padrão",
  "FoodOpB_Home_Mandate_vafk": "Tarefas",
  "FoodC_education__2_KHhl": "(2) Se você não chegar ao local da entrega dentro do prazo especificado, informar incorretamente o endereço de entrega ou o número de telefone, recusar uma ligação do(a) entregador(a) parceiro(a) ou, ainda, recusar a entrega, no todo ou em parte, sem um motivo válido, será necessário pagar o pedido.",
  "FoodB_management_Queries_dawh": "Pesquisar",
  "Gattaran_V2_Vqiq_pMHI": "Descrição da tarefa",
  "Gattaran_V2_Sjdp_HgTP": "ID da oferta",
  "FoodB_calculator_giVW_AULQ": "Preço da unidade da plataforma",
  "FoodC_education_If_you_RTIV": "Se você pagar por um pedido e depois tiver que cancelar, serão aplicadas as regras a seguir:",
  "FoodB_1106_xaYu_lPMa": "Acompanhamento rápido",
  "FoodB_calculator_EeIc_TwiG": "Outra parte",
  "FoodB_optimization_Stimulate_contact_xSSH": "Forma de contato preferida",
  "Gattaran_20240918supplement_ISmP_qTmN": "Editar tarefa",
  "FSaaSB_Tool_qKkB_Pdhu": "Crie um conta",
  "FoodB_202410_CHeZ_bExg": "Horário de funcionamento",
  "FoodB_0919__mVqa": "Atrasos no tempo de preparo",
  "FoodB_opencheck_aDuZ_bepq": "Baixar aplicativo do estabelecimento",
  "FoodC_receive__UdqW": "dia(s)",
  "Gattaran_check_rVeA_xCvB": "Tirar outra foto",
  "FoodB_boarding_Platform_Delivery_KXsV": "Entregas da plataforma",
  "FoodB_420241024_FldG_feZL": "Valor alvo",
  "Internal_Tools_CRM_pWry_BgtM": "Selecione",
  "soda-m-i18n---追加门店协议": "adicionar contrato do estabelecimento",
  "Gattaran_202406_NcUB_dVhS": "Horário de criação da tarefa",
  "FoodOpB_center_Action_MexV": "Ações",
  "Internal_Tools_App_fTOH_ETfJ": "Especifique",
  "FoodB_Analysis_Decline_gSax": "Para baixo",
  "Gattaran_opt2_egxV_xfoW": "Taxa de pedidos imperfeitos",
  "Gattaran_mgt_Display_content_IlcO": "Mostrar conteúdo",
  "Gattaran_0__BHKX": "Mapa",
  "Gattaran_tools_IbIT_QTXz": "Insira um número de telefone válido",
  "Gattaran_management_IDJi_lZyx": "{{amount}} visita(s) planejadas hoje. Veja sua agenda",
  "Internal_Tools_CRM_bNjK_DISV": "Forma preferida de visita",
  "FoodB_Show_Company_Registration_VcVV": "Cédula Jurídica",
  "FoodB_scenario_FmAJ_xFEY": "Suspeita de golpe ou trote",
  "FoodB_2_jsYT_EcaJ": "Foto das informações de pagamento",
  "FoodB_management_dlEy_pgrv": "Responsável pela liberação",
  "FoodC_202408_cktm_HTVV": "Entendi",
  "FoodOpB_OpsTasks_Off_GCPV": "Fechar",
  "Gattaran_mgt_Gap_BnAE": "Lacuna",
  "Gattaran_20230803_WsGI_IIwM": "Meta",
  "FoodB_SimbaSignup0331_qKdR_ELgg": "Origem do lead",
  "Gattaran_20240401_LxEe_Ydha": "Pesquisa",
  "soda-m-i18n---不需要": "Não obrigatório",
  "Gattaran_0__tYzF": "Não há estabelecimentos nesta área. Arraste o mapa para carregar mais",
  "FoodB_scenario_tTcW_glIK": "Item esgotado",
  "Gattaran_Visit_Objection_management_WIuV": "Gestão de objeções",
  "Gattaran_cancelation_TYFD_JQzM": "{{N}} tarefa(s) não executada(s)",
  "优惠券": "Voucher",
  "FoodB_250430_YTkG_lNTj": "Nível de marca",
  "Gattaran_check_MHKY_pOic": "1. Mostre completamente a fachada da loja. Se houver uma placa, certifique-se de que ela esteja totalmente visível. 2. A foto deve incluir o rosto do BD. 3. Sempre que possível, o rosto não deve obstruir a placa",
  "FoodB_2_Kxtu_brJB": "Nome completo do contribuinte (nacional)",
  "FoodC_optimization_hksX_yevn": "Adicione o endereço de encontro para que possamos entregar seu pedido",
  "FoodOpC_jiatalan_Deleted_successfully_GeGq": "Removido com sucesso",
  "FoodB_1106_XZeN_ahHQ": "Assim que você terminar de inserir o conteúdo, um resumo por IA será gerado automaticamente",
  "FoodB_calculator_cctL_sltb": "Total do pedido",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上、%s分钟以下，": "Se o seu pedido for entregue de %s a %s minutos após o horário estimado,",
  "FoodB_collection_5_6_hFrc": "Precisa conter 5 ou 6 dígitos sem espaço",
  "Gattaran_opt_lDge_zZTn": "Clique aqui para usar a navegação do mapa. Clique no ícone de telefone para KP e informações de contato do estabelecimento",
  "Gattaran_management_icdH_hGfu": "Detalhes",
  "Gattaran_0_Training_DM_ozrH": "Treinar DM ou operador de aplicativo",
  "FoodB_email_WcaT_rLqN": "O resultado da visita está incompleto. Insira o resultado da visita antes de prosseguir com a otimização.",
  "FoodB_accompanyvisit_ugDE_XHAA": "Descreva como o BD se posicionou durante o engajamento: ele demonstrou confiança e empatia e construiu uma conexão genuína com o cliente?",
  "Internal_Tools_App_sfLV_YhZV": "Sim, quero sair",
  "FoodB_communications_udno_SENU": "Oferta(s) aguardando aceitação. Participar de ofertas pode ajudar a impulsionar as vendas",
  "Gattaran_0_Maximum_number_pgYM": "Apenas uma pessoa pode ser criada por função",
  "FoodB_Show_Start_up_nLqS": "Taxa de ativação",
  "FoodB_opencheck_IVoR_xnHT": "Itens da lista de verificação aberta",
  "FoodB_CL_Letter_of_EmKs": "Foto da procuração",
  "FoodB_0113_ELbg_zfBg": "Verifique info. sobre o representante da loja aqui",
  "FoodB_Analysis_Old_people_fwCy": "Clientes recorrentes",
  "Gattaran_0__iUtr": "E-mail",
  "FoodOpB_Translation_Natural_persons_fVFa": "Pessoa física",
  "FoodB_0905__wwdP": "Peso do subitem",
  "FoodC_edit_ldOR_SyHv": "Exemplo: estou usando uma camisa estampada e esperando na rua. Você também pode carregar fotos dos arredores para ajudar o(a) entregador(a) parceiro(a) a entregar seu pedido no local correto.",
  "FoodC_improve__ByLg": "Diferente do esperado",
  "FoodOpB_Tool_Set_FrCO": "Não configurado",
  "FoodB_revamp_ifYi_sNyq": "Receita real da loja",
  "Gattaran_v1_fltf_eBMP": "Inscrito. Veja detalhes no aplicativo do lojista.",
  "Gattaran_0_Purpose_of_COzp": "Objetivo da visita",
  "soda-c-i18n---超时赔付规则说明": "Compensação por atraso na entrega",
  "FoodB_2_nybf_BGif": "Taxa para entregas feitas pela 99Food",
  "Gattaran_visit_MZio_RDBO": "Recebeu uma visita nos últimos 7 dias",
  "FoodB_page_SFRj_eGOy": "Resultado da visita",
  "FoodC_education__1_IIfh": "(1) Você cancela antes de o estabelecimento ter aceitado o pedido usando o recurso “Cancelar pedido”, na página Detalhes do pedido.",
  "FoodB_0905__vMsv": "{{number}} pedidos a mais do que no período anterior",
  "FoodB_pt3_RLJb_yjel": "Endereço do estabelecimento",
  "FoodB_accompanyvisit_yIeT_NmXn": "O BD demonstrou habilidades de negociação confiantes e decisivas, enquanto enfatizava claramente os benefícios e a visibilidade que os planos de ofertas trariam ao restaurante?",
  "FSaaSB_app_dPcJ_PvSf": "Software SaaS utilizado",
  "FoodD_messagemanagement_Mail_UMqH": "E-mail",
  "Gattaran_selection_TfHc_eCVN": "Itens da lista de verificação de RTBO não concluídos",
  "FoodOpB_Tool_Completed_MjfD": "Concluída",
  "FoodOpB_1_Visit_tomorrow_ptjT": "Amanhã",
  "FoodOpB_system_DiDi_ALAy": "Parceria da equipe 99",
  "FoodB_revamp_JpMI_mEoP": "Filtrar por “ontem”, “últimos 7 dias” e “mês do calendário”: exibe a receita real da loja para o período selecionado",
  "Gattaran_202406_hoAo_HpXw": "Recebidas ({{N}})",
  "Gattaran_0_KP_tendency_YwDf": "Forma de contato preferida do representante do estabelecimento",
  "Gattaran_form_kNYI_bDuc": "Este campo precisa ser confirmado",
  "FoodB_collection_Taxpayer_ID_zntM": "Documento do contribuinte (CPF)",
  "soda-m-i18n---商户自有设备": "O estabelecimento possui um dispositivo próprio",
  "FoodB_V2_No_store_ahBo": "Não há CNPJ",
  "FoodC_202412_QwDD_sIOi": "Fora da área de entrega",
  "FoodB_tagging_You_have_ssrJ": "Você optou por invalidar este lead pelo seguinte motivo: “Não é um estabelecimento de varejo”. Para fazer isso, você deve enviar uma foto ou o número de contato do representante do estabelecimento.",
  "Gattaran_schedule_qPDb_CTYm": "Gerar rota",
  "Gattaran_202311_JOTQ_efhW": "Nenhuma visita recomendada",
  "Gattaran_0_App_Operator_PFUQ": "Nome do operador de aplicativo",
  "FoodC_202410_UazG_LTwS": "Nenhuma loja disponível",
  "FoodB_ss_Other_WeRp": "Outros",
  "FoodB_statistics_hour_MNdW": "Hora",
  "FoodC_202410_hAya_NcZF": "Confirmar ({{countdown}}s)",
  "FoodB_Show_Special_Tax_Eidl": "NITE (Identificação tributária especial)",
  "FoodB_accompanyvisit_zjgE_DCvu": "Profissionalismo, adaptabilidade e comprometimento",
  "Internal_Tools_App_SHoN_atyR": "Postos",
  "Internal_Tools_App2_gcDq_GLYj": "Detalhes do preço de custo",
  "Gattaran_0_Self_marketing_BQlO": "Autopromoção",
  "FoodC_education__2_KZTZ": "(2) O(A) entregador(a) parceiro(a) não consegue entrar em contato com você",
  "Gattaran_Optimization_VLZp_WhPs": "Ver endereço do estabelecimento",
  "FoodB_leads_KP_Phone_hCUe": "Telefone do representante do estabelecimento 2",
  "FoodOpB_APP_Visit_vdze": "Visitar",
  "FoodB_Wordings_DKwT_wbfI": "Especifique por que você selecionou esta opção. Seu feedback é muito importante e nos ajudará a melhorar.",
  "FoodB_new1_Similarity_ItET": "Muito parecidos",
  "FoodB_V2_iZpC_KKcK": "Compartilhe o relatório de diagnóstico com o estabelecimento",
  "FoodD_h5_Single_quantity_lrNq": "Pedidos finalizados",
  "FoodOpB_1_New_Visiting_tIni": "Criar plano de visitação",
  "Internal_Tools_App_HdHN_rUqy": "Serviços do posto",
  "Gattaran_statusbar2_HKvC_dhsJ": "Assinado",
  "Internal_Tools_App_yiaL_Hsph": "Recomendamos carregar fotos do posto de gasolina",
  "FoodC_20240607_qihL_obWb": "Estabelecimento não encontrado",
  "Gattaran_form_Iqrg_LVTe": "Insira um número",
  "FoodC_202409_rOOL_Peyp": "Inserir número de telefone",
  "Internal_Tools_App_zYXv_Uwsb": "Status da operação",
  "FoodB_in_PTBa_SlOx": "Preencha o formulário de visita",
  "FoodB_1106_rrpW_kMlP": "Resumo de IA",
  "FoodD_Name_July_RJXL": "Jul",
  "FoodB_email_Bwgs_muyN": "Funcionário",
  "FoodD_Dapp_gKJv_HIwo": "Outros",
  "FoodOpB_bill_Status_doqj": "Status",
  "FoodOpB_1_Closed_ieMb": "Encerrado",
  "Internal_Tools_CRM_uCms_fFPv": "Número de telefone do contato principal",
  "FoodB_holidays_wyHK_pzLy": "Aberto",
  "FoodC_check_HTib_sWqA": "Enviando pedido",
  "FoodB_2_BPsf_FCjH": "CEP do contribuinte (nacional)",
  "Gattaran_V1__xaNO": "Taxa de cancelamento",
  "FoodC_intostore_Store_Coupon_kHwh": "Cupons do estabelecimento",
  "soda-m-i18n---押金收取周期5周": "O depósito é cobrado por 5 semanas.",
  "Gattaran_mgt_Filter_WuXS": "Filtrar",
  "Gattaran_REGULAR_xhms_NLbn": "Redefinir",
  "Internal_Tools_App2_TpmY_bfhb": "Visita",
  "soda-m-i18n---手动上下线": "Login automático",
  "Internal_Tools_App2_wcQW_nFJu": "A data selecionada está em conflito com um plano de visita existente. Depois do envio, o plano de visita anterior será substituído.",
  "FoodD_Gattaran_Basic_information_pRPb": "Informações básicas",
  "Gattaran_promo_zwtN_ucNY": "Esta loja não suporta a configuração de Oferta Inteligente",
  "FoodC_homepage_Enter_delivery_IZAu": "Insira o endereço de entrega",
  "Gattaran_opt_nyES_OcBw": "Pedido",
  "FoodC_Card2_When_the_sFOa": "Abre às",
  "FoodB_score_GUVa_rRtD": "Loja com entrega própria não usa o DAPP",
  "Gattaran_opt_slKF_FRuu": "cancelamento por tempo esgotado",
  "Gattaran_visit_XnzA_QVSa": "Visitas recomendadas",
  "FoodB_0905__dSOH": "Diagnóstico do loja",
  "Gattaran_opt_xozr_fXeD": "R Burn no mês até o momento",
  "FoodB_collection_12_or_woYo": "Precisa conter 12 ou 13 caracteres alfanuméricos, todos em maiúsculas e sem espaço",
  "GRider_dlp_Mjnq_pnxH": "Mais informações",
  "Internal_Tools_App_BBZi_lqDC": "Salvar",
  "FoodOpB_CO_Store_official_VsRU": "Site oficial do estabelecimento",
  "soda-m-i18n---此店领用PAD": "Tablet recebido por esso estabelecimento",
  "FoodB_Explorer_First_order_WqxA": "Horário da conclusão do primeiro pedido",
  "FoodC_202408_HkLu_Mwgv": "Nenhuma permissão de localização",
  "FoodB_SupportforweeklydimensionindicatorsinKPIspecialrules_aoYB_elnn": "Detalhes do resultado",
  "FoodC_202408_QAer_OYaB": "Boas-vindas!",
  "Gattaran_V2_JYDK_jtcb": "Horário do cadastro da oferta",
  "soda-c-i18n---1、超时赔付服务是%s为您免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在中查看。": "1. A compensação por uma entrega atrasada é nossa maneira de pedir desculpas. Caso seu pedido não seja entregue até o horário estimado (exceto por pedidos cancelados), a %s dará a você um ou mais cupons gratuitos. Você pode vê-los após a conclusão do pedido, acessando",
  "FoodC_edit_SkdG_WQKu": "Encontrar o(a) entregador(a) parceiro(a) no saguão do hotel",
  "Gattaran_tag1114_lMTl_ieqI": "Observações",
  "Gattaran_display_gAVa_nBnn": "Vários estabelecimentos por local",
  "Gattaran_change_eYBz_btlu": "Loja de teste",
  "FoodC_education_1_Customers_Gpbb": "1. O(a) entregador(a) parceiro(a) entregará seu pedido com base na opção selecionada:",
  "Gattaran_Collection__oNFU": "Navegar com o Google Maps",
  "Gattaran_20240401_iGPg_djYX": "Responder agora",
  "Gattaran_0__eeft": "Todos os estabelecimentos",
  "FoodB_1106_uAeK_oOBq": "Descreva o trabalho que você realizou. Quais são as principais atualizações, necessidades dos clientes ou problemas críticos? Quais são os próximos passos?",
  "FoodD_Name_April_UHuR": "Abr",
  "FoodC_20240607_STdK_ZTMu": "Serviço técnico fornecido pela {{brand_name}}",
  "FoodB_opencheck_sdms_sZcq": "Todos os itens de verificação em aberto foram concluídos",
  "Gattaran_opt2_mgat_VXCg": "Funil de conversão",
  "soda-c-i18n---将赔付给您1张%s优惠券": "Você recebe um cupom de %s de desconto",
  "FoodB_page_hqXm_mrng": "Resumo",
  "FoodC_20240607_Olbe_DAqS": "Não foi possível carregar",
  "FoodB_requirement_aEIJ_Ryni": "Período atual",
  "FoodOpB_system_offline_ersI": "Offline",
  "FoodB_V1_pVrj_FQgt": "ID do projeto",
  "Internal_Tools_App_xBYh_JJGr": "Distância",
  "Gattaran_Grocery__pKzk": "Mercado",
  "FoodB_scenario_psNp_kSMI": "Nenhum entregador disponível na loja",
  "FoodC_sidebar_Scan_QR_ONzJ": "Digitalize com a câmera",
  "FoodB_in_qxwR_OBuC": "A localização do estabelecimento está incorreta. Informe a localização correta.",
  "FoodB_sob_ixDC_aXor": "Insira o número de telefone do estabelecimento",
  "Gattaran_task_sagM_RqPE": "Número de tarefas concluídas",
  "FoodB_page_oZob_DASd": "Certifique-se de ter uma conexão de internet estável e grave novamente",
  "FoodB_status2_NytC_XUXP": "segundos",
  "FoodOpB_systemV2_Corresponding_coefficient_nVdO": "Coeficiente",
  "FoodD_Name_January_lhYr": "Jan",
  "FoodB_1106_wohA_bqJX": "A IA está analisando e resumindo. Volte mais tarde.",
  "FoodB_1106_tdLw_uSLP": "Tudo",
  "FoodB_score_lThf_wlQT": "Pontuação de integridade",
  "Gattaran_opt_oUrr_YTIV": "Barra de status de assinatura",
  "FoodOpB_tool_Category_main_aHZl": "Categorias de itens principais",
  "FoodB_email_CuqE_WLmP": "Olá! Visitamos sua marca {{brand_name}} e avaliamos o seguinte em conjunto com {{person_to_be_visited}}:",
  "Internal_Tools_App_YNFM_WUWd": "Filtros",
  "FoodB_20250122_yAtY_FAOX": "Executores da tarefa",
  "Internal_Tools_App_EMFl_vDCu": "Número de registro estadual",
  "Gattaran_0_Role_QDBu": "Função",
  "Gattaran_V20__THMR": "Desempenho do R",
  "Gattaran_form_xJkV_MADh": "Observações",
  "FoodB_in_JvQz_jMAb": "Relatar erro",
  "FoodB_scenario_tWmb_Krny": "Não aceito pela loja no prazo",
  "Gattaran_0__ypdc": "Carregar nesta área",
  "FoodB_up20241218_Btbi_AOsy": "Enviado",
  "Gattaran_Gattaran_tXqW_GKCv": "Em andamento",
  "Gattaran_REGULAR_TWeg_lFbm": "Este campo é obrigatório",
  "Gattaran_task_XEml_usSi": "Grupo de KPI",
  "FoodB_indicator_IPAg_AyWR": "Período de cálculo de dados",
  "Gattaran_management_adiS_UvoW": "Nenhuma tarefa de visita",
  "Gattaran_material_fvgd_sjhQ": "Rejeitado: atualize o formulário de acordo com o motivo da recusa e reenvie para análise",
  "FoodB_V1_hSCx_tzLn": "Nome do projeto",
  "FoodB_2_ntnh_vUsC": "E-mail da outra parte",
  "Gattaran_Page_Distance_jPzG": "Distância",
  "Gattaran_0_Menu_optimization_hWWT": "Desenvolvimento de cardápio",
  "FoodC_202408_uMeD_ECQU": "Ocorreu um erro. Tente novamente",
  "Gattaran_form_MLcA_tPgo": "Este campo é obrigatório",
  "FoodB_requirement_puhp_VPIQ": "Pedidos não preparados no prazo",
  "FoodB_revamp_hvPo_TJaN": "Otimizar agora",
  "Gattaran_202406_wGfZ_ewxp": "Equipe de execução da tarefa",
  "FoodB_scenario_Essn_oVjW": "Perguntas sobre taxas e ofertas",
  "Internal_Tools_CRM_MiAT_UkNG": "Cancelar",
  "FoodB_0905__zFVs": "Peso total",
  "FoodC_education_Platform_Delivery_MJPQ": "Entrega da plataforma",
  "FoodB_management_Name_of_EjQd": "Nome do supervisor",
  "FoodB_accompanyvisit_JkOw_BlRX": "O BD conseguiu analisar e discutir os KPIs de serviço (como “horas conectado” e “taxa de cancelamento”) com os clientes e propor soluções práticas?",
  "Gattaran_mgt_Check_the_Zyhr": "Ver lista de estabelecimentos avaliados",
  "FoodC_202408_HNlI_lTpJ": "Você não adicionou uma gorjeta ainda",
  "soda-m-i18n---无上线记录": "Nenhum registro online",
  "FoodC_dish_Look_again_fJrp": "Agora não",
  "Gattaran_KPI_System_performance_cQiV": "Conclusão",
  "Gattaran_Visit_Change_2_mNNS": "TURNO 2",
  "FoodB_accompanyvisit_dHvL_iRUP": "Antes e durante a visita de acompanhamento, o BD usou o sistema de CRM com habilidade?",
  "FoodC_nonaffiliate_Courier_is_iunG": "O entregador parceiro está a caminho do estabelecimento para atender seu pedido",
  "FoodB_page_UURy_Lqdt": "Um novo resumo da visita foi gerado",
  "Gattaran_Optimization_AFCF_zMMS": "Pessoas para contato de chamadas",
  "FoodC_202408_IBpM_TxlD": "Outros",
  "必选": "Não pode ser desabilitado",
  "FoodB_0707_High_prices_fBsL": "Maior",
  "Gattaran_0_Select_Contact_UrRS": "Selecionar pessoa para contato",
  "Groceries_calculation_LoxD_wbPj": "Cartão pré-pago",
  "Internal_Tools_App_oLpX_dbCU": "Hoje",
  "FoodB_0921__isZD": "Índice de item qualificado",
  "Internal_Tools_CRM_yMUu_NPxu": "Insira",
  "FoodB_fininfo_rljL_FPkz": "",
  "FoodB_1106_LmPI_RZuR": "A permissão de gravação está desativada. Ative nas Configurações.",
  "FoodB_revamp_WRGU_uLfD": "Visão geral da empresa",
  "FoodC_202409_yzRW_xKLM": "Este pedido está fechado. Para ver os detalhes, insira seu número de telefone",
  "FoodC_text_WMkV_qNzN": "Permitir",
  "Gattaran_feedback_Bkis_KqHN": "Feedback enviado",
  "Gattaran_transformation__zjbG": "ID do signatário",
  "FoodB_pt1_MJlX_mhMH": "Pessoa para contato",
  "Internal_Tools_CRM_roQc_QSuD": "Número de telefone",
  "FoodC_web_Application_Progress_UYtG": "Status da solicitação",
  "Gattaran_202311_XTsd_OBZL": "{{distance}} do estabelecimento",
  "FoodB_1106_qhrP_Bevz": "Que trabalho foi realizado?",
  "FoodB_pt1_qHPJ_nTdz": "Foto da fachada da loja",
  "Internal_Tools_App_OKLc_fuyL": "Últimos {{day}} dias",
  "Gattaran_202406_PESn_Wyzj": "Informações de referência",
  "FoodB_accompanyvisit_BDpV_dijH": "O BD apresentou claramente a proposta de negócios, enfatizou as vantagens diferenciadoras da {{99}} em comparação aos concorrentes e comunicou efetivamente nossa proposta de valor?",
  "Gattaran_display_SDiW_jcDc": "Os outros comerciantes registrados nesse local são os seguintes",
  "FoodB_in_hlDP_KYHy": "Não foi possível obter a localização. Ative os serviços de localização em Configurações e dê acesso à {{appname}}.",
  "FoodC_edit_GeFS_ZPLW": "Nome do edifício",
  "FoodB_feedback_KSnE_LLPJ": "Recebemos seu feedback. Acompanhe as mensagens no D-Chat e no seu e-mail para ver as últimas atualizações.",
  "soda-m-i18n---出库已交付": "Entrega de saída",
  "Gattaran_form_wrkw_ybam": "Objetivo",
  "FoodB_audit_Similarity_check_cQEP": "Verificação de similaridade",
  "FoodC_202408_zoCD_Pszh": "Continuar",
  "FoodC_supplement_Return_wVpv": "Voltar",
  "FoodOpB_CRM_Taxpayer_full_fzhk": "Nome completo do contribuinte nacional",
  "FoodB_management_mULu_sEtq": "Não há suprimentos a serem emitidos para esta loja",
  "FoodB_Website_tNXH_hTaL": "Insira um número de telefone válido",
  "FoodB_calculator_yiXt_NkiM": "Tarifa 99 da plataforma",
  "Internal_Tools_App_pdgP_UCoK": "Inserir manualmente",
  "soda-m-i18n---需要": "Obrigatório",
  "FoodB_management_OqJO_eKyB": "Insira o nome",
  "FoodB_20231012_Usvn_HuCU": "Tarefa criada com sucesso. Você pode acompanhar o progresso no módulo Minhas tarefas",
  "Gattaran_task_JPdq_bAwy": "E (todos os grupos de KPI devem ser concluídos)",
  "FoodB_feedback_aPoO_fIUh": "Seu feedback não foi enviado devido a um erro no sistema. Fale conosco pelo e-mail fornecido abaixo ou pelo D-Chat.",
  "FoodB_20250122_cjEP_PzzB": "Equipe de criação da tarefa",
  "FoodB_Show_Colombia_Aliens_xrvS": "Cédula de extranjería",
  "FoodB_page_TMuL_Jndl": "Propósito da visita",
  "FoodB_5_Store_Delivery_PIyN": "Entrega feita pela loja",
  "FoodB_calculator_JGZb_tQiY": "Preço pago",
  "FoodB_indicators_DXHY_dobu": "Métricas da empresa",
  "FoodB_field_Do_you_mhOz": "Sujeito ao pagamento de IVA local?",
  "FoodB_menu_ezpD_HgJQ": "Entrega",
  "Internal_Tools_App2_WfdX_XUIO": "Concluída",
  "FoodB_calculator_pEyx_wJvY": "Sim",
  "FoodB_0820__bVDh": "Estabelecimentos de alta prioridade",
  "Gattaran_page_jeoa_zoNR": "O estabelecimento ainda não foi visitado e não pode solicitar assinatura de contrato. Se foi visitado, insira as informações da visita",
  "FoodB_in_hnnz_miyT": "Falha no check-in",
  "FoodC_education_5_Cash_zBuY": "5. Ao fazer um pedido pago em dinheiro, verifique se você tem a quantia necessária para fazer o pagamento.",
  "Gattaran_0__ztLy": "Feedback",
  "soda-m-i18n---校验成功": "Verificado",
  "FoodB_management_Role_yLYi": "Função",
  "FoodB_revamp_ivPr_tnHT": "Ontem",
  "FoodB_CL_Traditional_companies_cQhK": "Empresa (Tradicional)",
  "Internal_Tools_App_sneY_mCvo": "Nome do contato financeiro",
  "FoodB_accompanyvisit_PTCc_aqRn": "Ao enfrentar objeções de clientes, o BD demonstrou controle emocional, habilidade de raciocínio e capacidade de persuasão?",
  "Gattaran_0__Auzn": "Arraste o mapa para carregar mais estabelecimentos",
  "Internal_Tools_App_cbRv_idqO": "Info. do lead",
  "FoodOpB_CRM_Taxpayer_Tax_xOmZ": "Número do documento fiscal local",
  "FoodC_202408_PvIX_VPCT": "Entre para ver as ofertas e acompanhar o status do pedido",
  "FoodB_revamp_mlff_lGsn": "Filtrar por “ontem”, “últimos 7 dias” e “mês do calendário”: exibe o valor médio dos pedidos feitos durante o período selecionado",
  "Gattaran_Process20250815_RJzh_SzcB": "Solicitar novamente",
  "FoodOpB_Tool_Supplies_Vptd": "Suprimentos",
  "FoodB_1106_zQzq_GRVj": "O recurso de gravação não é compatível com este dispositivo",
  "FoodB_Tracking_EhUy_AsTJ": "ID do contrato",
  "FoodB_accompanyvisit_tKym_AVNz": "Feedback geral",
  "FoodD_Name_August_cjQS": "Ago",
  "FoodOpB_system_DiDi_XcUY": "Operações da equipe 99",
  "Internal_Tools_App2_fjLr_RvMk": "Limite atingido",
  "FoodB_calculator_VFoE_zsGK": "Custo do item",
  "FoodB_v12_EuTn_cOWR": "Informações do integrador",
  "Gattaran_management_WjPM_jAvI": "Enviar contratos ao estabelecimento",
  "Internal_Tools_App2_QhIO_MwdW": "Procurar por nome/CNPJ do posto",
  "FoodOpB_2_Activity_status_hKFd": "Status da campanha",
  "FoodB_V1_daZW_gxxe": "Tipo de projeto",
  "Gattaran_opt_klQH_BPVb": "Informações do lead",
  "Groceries_calculation_UadY_RROs": "Os QR codes podem ser reduzidos a cartões pré-pagos",
  "FoodB_accompanyvisit_JAMs_lVxa": "O BD demonstrou habilidades essenciais de vendas, como controle emocional, raciocínio, capacidade de persuasão e articulação precisa de soluções ao enfrentar objeções?",
  "Gattaran_REGULAR_JVAQ_pbxi": "Informações básicas",
  "Gattaran_statusbar2_HSiT_INfG": "Verificado",
  "Gattaran_v2_meyK_ACyX": "Aberto no {{DiDi_Top}}",
  "Internal_Tools_App2_FAVe_GEuM": "Editar plano",
  "Gattaran_20240902_XVee_UUPM": "Esta tarefa foi recusada por {{account}}. Motivo: {{reason}}. Entre no módulo de Gerenciamento de tarefas de venda do GTR para preencher as informações de referência novamente. Em seguida, envie-as.",
  "FoodB_list_Store_Type_BWbl": "Tipo de estabelecimento",
  "FoodB_in_jXCJ_piNt": "Enviar foto?",
  "Gattaran_202406_lNdD_KvZI": "Tarefas do estabelecimento ({{N}})",
  "Gattaran_V1_HNYI_VwLG": "estabelecimento(s) que não fizeram o registro",
  "FoodB_collection_Tax_Classification_uJHT": "Regime tributário (nacional)",
  "Gattaran_202406_FRwK_cCbx": "Minha tarefa",
  "FoodB_in_jecP_aEPa": "Não fez o check-in",
  "FoodB_accompanyvisit_whTV_IRlg": "Durante a visita de acompanhamento, o BD manteve uma atitude de trabalho proativa e demonstrou fortes habilidades de organização e coordenação, além de agilidade (mantendo o foco e a orientação para resultados)?",
  "Gattaran_20250610_cwrB_uBlH": "Adicione as informações de associação e conclua o RTBO",
  "Internal_Tools_App_FCxp_ADxG": "Horário de funcionamento",
  "FoodB_calculator_AioF_coBc": "Valor do IVA individual",
  "Internal_Tools_App2_kfaK_CNAM": "Mostrando todos os preços de custo registrados no ano passado",
  "Gattaran_0_Marketing_activities_qANU": "Ofertas",
  "FoodB_up20241218_hGVF_hBSj": "Este estabelecimento não tem itens que atendam aos requisitos. Sugerimos entrar em contato com o estabelecimento para enviar os itens em breve.",
  "FoodC_dish_Leaving_LwWJ": "Sair",
  "FoodB_CL_RUT_roUA": "RUT",
  "FoodC_202408_IfNx_VyNu": "Endereços salvos",
  "FoodB_optimization_Full_reduction_NlOa": "Gaste X, Poupe Y",
  "FoodC_dish_You_will_AXAT": "Você só receberá ofertas dos restaurantes indicados abaixo.",
  "Gattaran_add_WtmN_hzJP": "Conectividade > 60%",
  "FoodB_score_hdba_rkAT": "Período dos dados",
  "FoodB_v12_yorO_qIQQ": "Há um integrador de pedidos?",
  "FoodC_edit_NwrE_OHgM": "Encontrar o(a) entregador(a) parceiro(a) fora do apartamento",
  "FoodB_data_End_mVwX": "Hora de término",
  "soda-m-i18n---押金收取周期0周": "O depósito é cobrado por 0 semanas",
  "Gattaran_0__NAOt": "Descreva seu problema ou sua sugestão e envie para a caixa de correio abaixo ou fale conosco pelo D-Chat.",
  "FoodB_0327_ZGTe_zcKH": "Toque aqui para trocar a cidade",
  "Gattaran_visit_KjUG_kxHP": "O BD listou ofertas promocionais ou estudou as necessidades da loja",
  "FoodC_education_1_If_iWDm": "1. Se você não conseguir cumprir os requisitos acima, poderá ser responsabilizado no caso de um problema relacionado à entrega. Isso inclui, entre outras, as situações em que:",
  "FoodB_opencheck_Lqbg_GbON": "Ir para {{99app}}",
  "Gattaran_0509_PLgH_VDtS": "Os 10 pratos mais pedidos",
  "Gattaran_optimization_deWd_ffjJ": "Conclusão de desempenho final",
  "Gattaran_0_Decision_makers_uOOG": "DM (representante do estabelecimento)",
  "FoodB_V2_No_legal_QONX": "Sem documento do representante legal",
  "soda-m-i18n---入库已配置": "Check-in efetuado e configurado",
  "FoodB_Commision_Type_of_EIWZ": "Tipo de estabelecimento",
  "Gattaran_mgt_Unqualified_Store_JeWr": "Estabelecimentos com metas não atingidas",
  "FoodB_Overview_AasD_LvfW": "Ver mais",
  "FoodB_NewStore_Status_HphC": "Status",
  "Gattaran_20240401_kuua_DPLO": "Perguntar mais tarde",
  "FoodB_list_Store_Phone_tSWo": "Número de telefone do estabelecimento",
  "FoodB_manager_aCSR_lQaQ": "semana",
  "Gattaran_visit_KNGQ_NwUQ": "O BD listou acordos ou soluções anteriores",
  "Gattaran_opt2_kPIo_ZpuU": "Pedidos com entrega própria / semana",
  "FoodB_communications_mtxm_YcRA": "Estabelecimento(s) não concluiu(íram) tarefas de incentivo de novo estabelecimento",
  "FoodB_V1_zSAb_YlGe": "Resta(m) {{num_days_left}} dia(s)",
  "FoodB_revamp_Ojty_dQGn": "Volume de pedidos da loja",
  "Gattaran_management_Associated_New_iDiy": "Associar novo estabelecimento",
  "Gattaran_202406_HnXs_yYCh": "Status da tarefa",
  "Gattaran_form_wuYy_lqzb": "Informações da plataforma",
  "FoodB_module_gRmW_pNjB": "Tempo dos dados: {{date}}",
  "Gattaran_management_HgTV_cHfW": "Adicionar plano",
  "Gattaran_jumppromo_ONbQ_nOEB": "Portal de dados de oferta",
  "FoodB_420241024_LTYv_GOfN": "Valor real",
  "FoodB_optimization_Label_nzNw": "Tag",
  "FoodB_P0_cNyW_HkyE": "Alteração nos pedidos finalizados",
  "FoodC_edit_OVRs_CzUt": "Hotel",
  "FoodB_2_kFvZ_brOV": "Informações sobre taxas",
  "FoodB_20230410_YNjt_xAWA": "DiDi Top",
  "FoodB_management_sSVO_Bizb": "Tem certeza de que deseja remover o contato?",
  "Gattaran_optimization_MwZK_gJdn": "Bônus de KPI",
  "FoodB_Side_YfKV_vTcN": "Índice de tempo online em horário de pico",
  "Internal_Tools_App_tpZf_wbHM": "Contato principal",
  "soda-m-i18n---非此店领用PAD": "Tablet recebido por outro estabelecimento",
  "FoodOpB_Tool_Visit_szxD": "Abrir link",
  "FoodB_optimization_First_completed_KqBm": "Horário de conclusão da primeira verificação do estabelecimento",
  "FoodC_202408_leda_oOpl": "Acompanhe seus pedidos",
  "FoodB_indicator_HwNu_RoHh": "Taxa de cancelamentos por parte da loja",
  "Internal_Tools_App2_XBvf_vJDB": "Verificar",
  "FoodB_V1_LADl_QUme": "Preencher formulário",
  "FoodB_list_Setting_Up_YlBy": "set_open_duration",
  "Gattaran_check_OJtB_rIyV": "Enviar foto",
  "FoodB_1106_Boir_tlSu": "Falha ao enviar o arquivo de áudio. Verifique se sua conexão está estável, se o arquivo tem menos de 5 MB e tem menos de {{max_record_time}} segundos de duração.",
  "Gattaran_statusbar2_Pfzu_ihne": "Verificando",
  "Gattaran_opt_SsHX_vUuN": "cancelamento por item esgotado",
  "Gattaran_schedule_saMI_wHLe": "Toque aqui para gerar uma rota de visitas presenciais.",
  "FoodB_collection_KQSI_nwHB": "Abertura de conta bancária",
  "sailing.d-api.common.页面获取失败，请稍后重试": "Não foi possível obter a página, tente novamente mais tarde",
  "Gattaran_V2_TtYW_lonJ": "Hora atual dos dados: {{update_time}}. Os dados serão atualizados com um atraso de 1 a 2 horas.",
  "Internal_Tools_App2_bcHq_KppB": "Visitas pendentes",
  "Gattaran_0_Merchant_activities_wwGb": "Flagship",
  "Gattaran_Translation_Alien_ID_IMja": "ID estrangeiro",
  "soda-c-i18n---当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在": "Se um pedido não for entregue até o horário estimado (exceto por pedidos cancelados), a %s dará a você um ou mais cupons como pedido de desculpas. Após a conclusão do pedido, você pode vê-los acessando ",
  "Internal_Tools_App_Prgi_JgdZ": "Confirmar",
  "FoodB_V1_CLCC_nUuk": "Criar visita",
  "FoodB_I_Home_OrRo": "Início",
  "FoodB_collection_Taxpayer_Information_fQid": "Consultar informações do contribuinte",
  "FoodC_202408_GeGr_xwdt": "Facilite a comunicação",
  "Gattaran_202406_cPQJ_uCFE": "Tipo de tarefa",
  "FoodOpB_information_The_selected_LyoI": "A liquidação não é aceita pelo banco selecionado",
  "FoodD_Name_September_Ezci": "Set",
  "FoodC_202408_xwYJ_IzdZ": "Continuar",
  "Gattaran_V2_Vjbt_glNA": "Cadastrar-se para a oferta",
  "FoodC_web_Customer_Service_EBqf": "Atendimento ao Cliente",
  "FoodB_wording_AKPa_CRKd": "Status do documento fiscal",
  "FoodB_opencheck_GlFW_TclW": "Ver",
  "FoodB_0_Mail_SUKZ": "E-mail",
  "Internal_Tools_App_LlZj_XSVI": "Criar visita",
  "Gattaran_202406_ndOn_KPLE": "Detalhes da tarefa:",
  "Gattaran_opt2_Nngy_DhyN": "O status da análise expirou e não pode ser consultado aqui. Entre em contato com o supervisor do produto pertinente para saber mais.",
  "FoodB_accompanyvisit_dhas_ATCp": "O BD usou perguntas investigativas e escuta ativa para entender a situação atual e os desafios do restaurante?",
  "FoodB_calculator_VujK_GJbV": "Lucro",
  "Gattaran_Visit_Accompanied_visitors_ZFNA": "Pessoas acompanhadas",
  "Internal_Tools_App2_BEqX_EVvQ": "Sex",
  "FoodB_calculator_mTaD_pjZv": "Desconto total",
  "Gattaran_0_Improved_Cancellation_KpWF": "Melhorar taxa de cancelamento",
  "Gattaran_V2_nmOG_KwMG": "Requisitos de quantidade de itens para cadastro da oferta",
  "Gattaran_Visit_Before_visiting_VHLe": "Início do dia",
  "Gattaran_mgt_Display_all_Yagb": "Por padrão, todos os estabelecimentos que não atingiram as metas e seus KPIs são exibidos",
  "Gattaran_store_nPds_FcDF": "Esta página não é o portal oficial para a assinatura de contratos. Para seu benefício e para a segurança das suas informações, conclua a assinatura do contrato através do portal oficial.",
  "FoodB_Show_Account_Type_vJvu": "Tipo de conta bancária",
  "FoodC_1_mnqk_AcOb": "Não foi possível copiar",
  "FoodB_in_ZfQl_HqDL": "Check-in feito",
  "FoodB_CL_Amount_CLP_Tmnv": "Valor (CLP)",
  "FoodC_202408_ZOBi_xjfW": "Pesquise por um local ou nome do edifício",
  "FoodOpB_CO_Not_applicable_WuPn": "Não aplicável",
  "FoodC_supplement_Modify_Mobile_ZJkT": "Para modificar seu número de telefone ou senha, adicione um endereço de e-mail ou remova sua conta",
  "FoodC_address_gNYi_HdzX": "Erro ao salvar",
  "FoodD_supplement_Rules_RYAa": "Regras",
  "FoodB_email_qCka_NBMf": "Melhor horário para contato",
  "Internal_Tools_App_qybY_jcAh": "Sistema ERP",
  "FoodB_tagging_You_chose_DSiT": "Você selecionou “Operação encerrada” como motivo de lead inválido. É necessário fornecer foto(s) ou um número de telefone do KP.",
  "Gattaran_opt_cUSL_RSNr": "Navegação do mapa e informações de contato",
  "Gattaran_form_YzJW_ggnb": "Informações de operações do estabelecimento",
  "FoodB_SupportforweeklydimensionindicatorsinKPIspecialrules_stsF_TElv": "Semana {{weeknum}}",
  "FoodB_0919__YKYU": "Nenhuma oferta",
  "FoodB_calculator_mdtN_KpDW": "Desconto total",
  "Gattaran_202406_jIoA_BlIm": "Exibir",
  "FoodB_page_soIL_UjnD": "Tentar novamente",
  "FoodD_up_DiDi_Delivery_FdmM": "99Food Entregador",
  "FoodC_202408_pSzr_CJqz": "Salvar endereço",
  "Gattaran_management_hCqr_uwez": "Editar e-mail",
  "FoodC_202412_JiED_bPrx": "Nenhum resultado. Insira uma rua e número válidos",
  "Gattaran_0_Operating_channels_upHR": "Pedidos diários",
  "Gattaran_AlertV1_FkFa_EQiG": "Nenhum estabelecimento qualificado",
  "FoodB_V1_BEKq_hBNG": "Filtros selecionados: {{tag_name}}",
  "FoodB_accompanyvisit_mOOJ_zFjt": "O BD aceitou ativamente o feedback durante a visita de acompanhamento e demonstrou uma clara vontade de melhorar?",
  "FoodC_1_ScPa_MVPN": "Copiado",
  "FoodB_management_ZwFz_QsoN": "Adicionar contato",
  "Gattaran_management_BjBQ_GVEr": "{{num1}}/{{num2}} visitas feitas · {{month}}",
  "Gattaran_REGULAR_ezuA_ZuBN": "Documento Fiscal",
  "FoodB_in_qJcB_oRfE": "Você acabou de fazer o check-in. Quer mesmo fazer o check-out? Isso não afetará seu desempenho.",
  "FoodC_all_You_haven_lSmt": "Você ainda não convidou nenhum amigo. Convide alguém",
  "FoodB_calculator_rMFF_EMXI": "Dinheiro",
  "Internal_Tools_App2_MoBn_DHqJ": "Deletar",
  "Gattaran_AlertV1_MmvI_acwe": "{{date}} dia(s) restante(s)",
  "Gattaran_Process20250815_enQA_qfXI": "Ver detalhes",
  "FoodB_scenario_PuLv_FhUL": "Cancelamento por parte do comerciante iniciado por terceiros",
  "Gattaran_mgt_Without_search_XVsz": "Nenhum resultado encontrado. Você pode ajustar as condições de filtro e tentar de novo",
  "FoodB_calculator_HfHr_bkLf": "Participação de recompensas da plataforma do desconto",
  "FoodC_education__3_TDsa": "(3) Você se recusa a aceitar o pedido, no todo ou em parte, sem uma justificativa",
  "Internal_Tools_App_GMMl_xksG": "Banco",
  "FoodB_1106_tTbZ_mKRW": "Análise de IA",
  "Gattaran_management_oCmv_JtTy": "Contratos da 99",
  "FoodB_CL_Vista_Account_QcOm": "",
  "Gattaran_BDapp_Rvoe_RUHw": "Portal de BD (normal)",
  "FoodB_revamp_jrcY_dvmZ": "Filtrar por “tempo real”: exibe o número estimado de pedidos finalizados em tempo real (excluindo pedidos cancelados)",
  "FoodB_2_wbni_uePM": "Serviço",
  "FoodB_I_onwf_oaQH": "Vendas",
  "FoodB_indicator_gkdu_HwLc": "Principais métricas da empresa",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上，": "Se o seu pedido for entregue mais de %s minutos após o horário estimado,",
  "soda-c-i18n---取消订单": "Cancelar pedido",
  "请选择支付方式": "Selecionar método de pagamento",
  "Internal_Tools_App_Qgai_eoNp": "Bandeira",
  "Gattaran_KPI_ioIq_fNJB": "Primeira data conectado",
  "Gattaran_Feedback__dWQe": "Responsável pela tarefa",
  "FoodB_2_KsgR_YwjD": "Endereço do contribuinte (nacional)",
  "FoodB_progress_ZdQT_mHfK": "Redefinir",
  "FoodB_calculator_Jryi_aded": "Entidade fiscal",
  "Internal_Tools_App_rOKe_yMwP": "Status do ERP",
  "Gattaran_jumppromo_vqdm_KQKO": "Toque aqui para abrir o Portal de dados de oferta e ver dados mais detalhados",
  "FoodD_Optimization_ppct_mVEc": "Insira seu número de telefone",
  "Gattaran_url20250708_paYw_lmmU": "Referência do link do cardápio",
  "Internal_Tools_App_gUvZ_AiZQ": "Info. da visita",
  "FoodB_0_Please_upload_dcPG": "Envie uma captura de tela do histórico de SMS",
  "Gattaran_visit_lCWG_SqtV": "Recebeu uma visita nos últimos 15 a 30 dias",
  "FoodC_dish_Are_you_TaUN": "Deseja deixar a página da promoção?",
  "Gattaran_Dashboard_kkhw_LpMO": "vs. período anterior:",
  "FoodB_CL_Add_any_egRn": "",
  "FoodB_scenario_FkIm_wbyt": "Loja muito ocupada para preparar o pedido",
  "Internal_Tools_App2_lQcx_yrtq": "Adicionar plano",
  "Gattaran_form_FtqP_caNF": "Objetivo da visita",
  "FoodC_202412_aCvV_UNyj": "Adicione um novo endereço",
  "Gattaran_Visit_Results_ftOU": "Resultado",
  "Gattaran_0_Improvement_of_TPKB": "Melhorar avaliações ruins",
  "FoodC_web_Feedback_on_ookM": "O feedback não pode ser enviado usando a versão web neste momento. Para enviar feedback, use o aplicativo. Se tiver alguma dúvida, entre em contato com o Atendimento ao Cliente.",
  "FoodB_0830__wEQD": "Pedidos finalizados este mês",
  "FoodB_in_mOVo_WHCx": "Você e a placa do estabelecimento devem aparecer na foto de forma clara e sem cortes.",
  "FoodB_1106_OZBo_RTDB": "Intenção do cliente",
  "Gattaran_side__vcvR": "Domingo",
  "Internal_Tools_App_GiyX_Jwmf": "Adic. registro de visita",
  "Gattaran_opt_AGTs_VRUG": "{{change}} mais do que o último período",
  "FoodB_APP_alxj_KuRF": "Ofertas em andamento",
  "Internal_Tools_CRM_qtMC_roJU": "Posto de gasolina",
  "Gattaran_promo_RuGX_dOwC": "Orçamento de anúncios",
  "FoodB_wording_oynB_JehX": "Câmara de comércio",
  "Internal_Tools_App_LMjQ_TQFW": "Distância atual até o posto de gasolina: {{Distance}}",
  "Gattaran_202406_iXbv_CcJq": "Informações básicas da tarefa",
  "Internal_Tools_App2_ZjjL_OoOa": "Detalhes",
  "FoodB_email_FvUP_tJQT": "Nome",
  "FoodB_CL_Maximum_amount_oflZ": "Cobrança única máxima (CLP)",
  "Gattaran_Visit_Date_of_TyAN": "Data da visita de acompanhamento",
  "FoodC_popup_After_closing_ujoW": "Se você sair desta página, os itens selecionados não serão salvos",
  "FoodB_01_Business_Properties_dFox": "Propriedades comerciais",
  "Gattaran_management_nGle_XtpC": "E-mail do estabelecimento",
  "FoodB_opencheck_BEoy_GUyq": "Verifique se o estabelecimento baixou a {{99Store}}",
  "Internal_Tools_App_vJec_vZqL": "Código SWIFT",
  "Internal_Tools_App_VzrE_Uvmn": "Nome do posto",
  "FoodB_task_KKOJ_hjRO": "Modelo de conciliação",
  "Gattaran_Visit_Getting_ready_zDyf": "Preparação",
  "FoodOpB_management_Launching_HwsY": "Ver mais",
  "Gattaran_management_IEaM_OfwD": "Nome do contato",
  "GDriver_trans_seconds_fFsz": "s",
  "FoodB_I_QuSz_HsAZ": "Porcentagem de desconto da oferta",
  "FoodB_sob_dQvJ_WRCM": "Vincular conta SOB",
  "Gattaran_mgt_No_performance_GzjE": "Nenhum dado de desempenho",
  "FoodB_accompanyvisit_WoFg_gLDx": "O BD conseguiu adaptar sua linguagem e estilo de comunicação ao perfil do tomador de decisão para construir uma confiança genuína?",
  "Internal_Tools_App_FiXW_DMEF": "Aquisição",
  "Gattaran_0229_SpOD_JZZs": "Isso pode ser devido a condições de filtragem mutuamente exclusivas selecionadas na Parceria da equipe 99, offline e nas Operações da equipe 99.",
  "FoodB_audit_The_information_jxLV": "As informações que você enviou não atendem aos requisitos",
  "FoodC_Notification_ZawA_BoKt": "Ver pedidos em andamento",
  "FoodB_420241024_TFhQ_lSww": "Rejeitado com sucesso",
  "FoodB_optimizing_Duplicate_Store_aBYS": "ID de estabelecimento duplicado",
  "FoodB_report_DLbK_IWIH": "Endereço incorreto?",
  "Gattaran_202406_QyVz_DlrH": "Prioridade da tarefa",
  "FoodB_order_ncPz_yPAH": "Entregas da plataforma",
  "FoodB_Explorer_First_available_ePZc": "Primeiro horário online válido",
  "FoodC_202412_Afcx_fMwc": "Selecione um endereço",
  "Gattaran_V2_XHhz_OxUM": "Horário da tarefa",
  "Gattaran_Visit_Visit_process_dZws": "Durante a visita",
  "FoodB_1106_Ezht_DXlH": "O tamanho do arquivo não pode exceder 5 MB",
  "FoodB_page_LVCK_ZWBK": "Concluído",
  "Gattaran_visit_otEO_oKJB": "Visitas de hoje",
  "FoodB_process_ziFN_pEHW": "Progresso do RTBO até ontem",
  "Internal_Tools_App2_ALgE_nywC": "Resultado: {{result}}",
  "FoodB_in_HOiz_LgJT": "Enviar",
  "FoodB_V1_vKqg_VkFI": "Lista de projetos",
  "Gattaran_Top_gxPb_uTLM": "3. Quando um estabelecimento se torna DiDi Top, ele recebe vantagens de tráfego que aumentam muito o volume de pedidos. Por isso, tente qualificar seu estabelecimento como DiDi Top",
  "FoodB_email_SHyg_fIzy": "E-mail ausente. Adicione essa informação para enviar o e-mail",
  "FoodC_202412_enwa_nWfu": "Este item está esgotado. Experimente outros itens do cardápio",
  "Internal_Tools_CRM_sYtz_hQDA": "Nome do posto de gasolina",
  "Gattaran_material_javG_HxIv": "Tarefas disponíveis com o método de visita atual",
  "Gattaran_transformation__sLrG": "O signatário tem um lead em análise. O contrato pode ser assinado após a aprovação do lead.",
  "FoodOpB_1_There_may_scoc": "Parece que talvez haja um conflito de agendamento. O plano para a data selecionada é:",
  "FoodB_sob_cDKJ_oFcF": "Vinculado com sucesso",
  "Internal_Tools_App_TDqq_hkdP": "Tipo de combustível",
  "Gattaran_0_Create_new_Faau": "Criar pessoa para contato",
  "FoodOpB_1_Are_you_sLNY": "Tem certeza de que deseja encerrar esta visita? Após o encerramento, a visita será invalidada e não será possível inserir dados.",
  "FoodB_2_WRYW_FUbf": "Cobrança única máxima",
  "FoodC_edit_KDUB_nVRR": "Obrigatório",
  "FoodB_opencheck_XqjA_alBe": "Concluído",
  "Gattaran_V2_DwZk_joic": "Nome da tarefa",
  "Gattaran_management_lLpT_dFdN": "Não visitado",
  "Gattaran_visit_jnPQ_METw": "O proprietário está na loja?",
  "Gattaran_202406_CvwH_Obyc": "Horário de término da tarefa",
  "FoodOpB_results_The_key_HHMa": "KP não estava no estabelecimento",
  "Gattaran_Feedback__WUQR": "Meu Feedback",
  "FoodOpB_1_A_recent_LtIi": "Há um ou mais planos de visitação não concluídos. Deseja inserir dados mesmo assim?",
  "Internal_Tools_App_skNg_IIIe": "Não",
  "Internal_Tools_App_qOUi_WmVg": "Latitude",
  "Gattaran_V20__eJGq": "Potencial",
  "Gattaran_optimization_qReN_wCHB": "As tarefas de visita desse mês foram atualizadas. Ver agora",
  "FoodB_email_Zgsh_mNSy": "KP",
  "Gattaran_form_rWtU_nHko": "Selecione",
  "FoodB_optimization_Special_Meal_YtqD": "Itens promocionais",
  "Gattaran_0_Prices_of_kkXs": "Preços na 99 em relação ao cardápio físico",
  "FoodC_20240607_hfCf_kdpO": "Telefone",
  "Internal_Tools_App_sXad_CZPU": "Região e idioma",
  "Groceries_web__Ovnh": "No momento, os mercados só aparecem no app para celular",
  "FoodB_IGV_WGYF_kfvV": "IGV",
  "FoodD_optimizatio_Tax_information_xHrV": "Informações fiscais",
  "Gattaran_opt_AIBq_AcbH": "Editar informações de lead",
  "Gattaran_status_Ozec_ScYy": "Recusado",
  "FoodB_202410_erZg_Bqks": "Entrega da plataforma",
  "FoodB_1106_dhXS_LAAs": "Falha na geração do resumo por IA",
  "Gattaran_check_XGOT_wibj": "Você está a mais de {{distance}} metros da loja e não pode realizar o check-out. Para concluir, você pode tirar uma foto sua com a fachada da loja. Se a foto não for aprovada, a visita será invalidada e poderá afetar seu desempenho. Tem certeza de que deseja realizar o check-out?",
  "Gattaran_form_MhMj_Wboc": "Adicionar informações da plataforma",
  "已选择": "Selected",
  "FoodC_edit_stZr_IBeA": "Outros",
  "FoodC_edit_AxtX_PAiY": "Exemplo: Edifício C, 1.118",
  "FoodB_202402_sUzf_zwFG": "Nome da marca",
  "FoodOpC_backend_Urban_hhdx": "Cidade",
  "FoodOpB_app_Need_to_XZYr": "Requer presença física",
  "Gattaran_opt_bWcH_ShAH": "Adicionar plano",
  "FoodB_Analysis_Yesterday_nearly_aBCt": "Ontem",
  "FoodB_calculator_ULXU_HjOF": "Taxa de IVA",
  "Internal_Tools_App_cuvl_RIgb": "Confirmar saída?",
  "FoodB_calculator_WKKD_DbHM": "Valor tributável do pagamento eletrônico",
  "FoodB_opencheck_ZCLB_lZeJ": "Cardápio e preços",
  "Gattaran_V2_CRUc_Yeyn": "Detalhes da oferta",
  "FoodB_opencheck_JIkE_hhmG": "Informações de endereço",
  "FoodB_wording_ILbR_KjgC": "Tipo de pessoa",
  "FoodD_Questionnaire_Finished_YvLk": "",
  "FoodB_030_fqBt_uzDV": "Permissões ausentes: {{City}}. Solicite permissões no Gattaran",
  "FoodB_1106_Jvwt_cvqA": "Enviar arquivo de áudio",
  "FoodB_2_bYmN_VbtX": "Documento Fiscal",
  "Gattaran_management_tfXo_jhuS": "Status da tarefa",
  "Gattaran_V2_XzcI_uroK": "Nome da oferta",
  "Gattaran_opt_CjOE_rGuI": "Ver mais informações da visita",
  "Internal_Tools_CRM_lbMF_fwNr": "Nome do contato principal",
  "soda-c-i18n---早间：%s-%s": "Manhã: %s-%s",
  "FoodD_Orders_Can_not_fkHK": "O horário de início não pode ser posterior ou igual ao horário de término.",
  "FoodB_data_Beginning_PbJC": "Hora de início",
  "FoodOpB_Translation_Cash_accounts_fSLJ": "Conta corrente",
  "Fleet_tool_Search_sFMa": "Pesquisar",
  "FoodB_management_diEN_EjtS": "Gerente da loja",
  "FoodC_orderlist_Completed_Xuod": "Concluído",
  "FoodOpB_tagging_Non_retail_JnDS": "Não é um estabelecimento de varejo",
  "FoodB_madero_Store_Delivery_JbdX": "Entrega feita pela loja",
  "FoodB_scenario_DYVH_kYTv": "Cancelamentos por parte do comerciante nos últimos 7 dias",
  "Gattaran_0__diqD": "Nenhum estabelecimento",
  "Internal_Tools_CRM_VRWr_pCnt": "Gerente de vendas",
  "FoodB_2_WbzT_odyB": "Informações de pagamento",
  "FoodB_1106_ZAuG_REFT": "Tem certeza de que deseja fechar e sair? A gravação será interrompida e seu conteúdo não será salvo.",
  "Gattaran_Visit_Empathy_and_CvFh": "Empatia e início da negociação",
  "Gattaran_0_Clerk_call_fhnx": "Número do funcionário",
  "FoodB_scenario_iTKN_qRYT": "O pedido está fora da área de entrega",
  "Gattaran_20240409_JERr_RtyH": "Ver todos os estabelecimentos",
  "Gattaran_AlertV1_MVye_ihrr": "Coeficiente de desempenho atual",
  "FoodB_1106_BLKp_thZN": "Informações de acompanhamento",
  "FoodB_opencheck_kRqA_FpQO": "Impressora e recibo",
  "FoodB_accompanyvisit_lUAu_lYme": "Abordagem de profissionalismo e engajamento",
  "FoodOpC_system_Business_hours_coEs": "Horário de funcionamento",
  "Gattaran_form_TTAw_lJPb": "Insira observações como informações complementares",
  "FoodB_calculator_HXix_qhAK": "Valor do ISR individual",
  "soda-m-i18n---出库未交付": "Check-out efetuado; não entregue",
  "FoodB_page_cium_rzWL": "Toque para gravar e deixe a IA gerar automaticamente um resumo da visita",
  "FoodB_indicator_cGGf_oMTT": "Valor da métrica",
  "FoodC_202408_reKH_lclj": "Adicionar endereço de entrega",
  "Gattaran_cancelation_vqja_qihk": "Selecione",
  "FoodB_scenario_cDgW_SOLZ": "Taxa de cancelamento por parte do comerciante nos últimos 7 dias",
  "Gattaran_mgt_Achievement_GuwU": "Metas atingidas",
  "Gattaran_Visit_Business_feedback_Llza": "Conversa de feedback da empresa",
  "FoodB_phrase__PWcd": "Não há ofertas encerradas para mostrar",
  "GDriver_Rate_Mkpg_QdjY": "Estratégia de taxa de serviço",
  "FoodB_1106_bquQ_ajOd": "Entrada de texto",
  "Gattaran_opt_ZCLf_SEBU": "ID do loja",
  "FoodB_optimization_Not_started_XTpL": "Não iniciada",
  "FoodB_email_wMIf_SGNM": "Nome do contato",
  "Internal_Tools_App2_bbEY_frCr": "Tem certeza de que deseja deletar isso?",
  "Gattaran_20240902_YGUw_avxA": "Recusar",
  "FoodC_replace_Clear_Filter_iwTY": "Limpar filtros",
  "FoodB_030_SQUQ_YDRS": "Não são meus estabelecimentos",
  "Gattaran_add_bXDc_IEuz": "Conectividade (média diária) > 60%",
  "FoodB_management_csuF_MCdo": "Insira um e-mail válido",
  "Gattaran_online_HStX_yFLt": "Primeiro horário online",
  "FoodB_0622_Increase_store_kZfr": "Adicionar comparação de estabelecimentos",
  "FoodB_calculator_GdDU_bFgc": "Recompensas da plataforma",
  "Gattaran_side__nJvf": "Quarta-feira",
  "FoodOpB_CRM_Party_B_BCQp": "CNPJ da empresa",
  "Gattaran_REGULAR_XlOa_yzqB": "Saída",
  "FoodOpB_crm_Business_model_wjXI": "Modo de empresa",
  "FoodB_indicator_nLPV_KIjh": "Pontuação atual",
  "FoodB_calculator_BKfQ_ehtA": "Comissão da plataforma",
  "FoodB_page_YwxF_xrtk": "Não saia desta página durante o envio, ou ele não será salvo.",
  "FoodB_email_SdUD_YAhg": "Informações ausentes. Adicione essas informações para enviar o e-mail",
  "FoodB_1106_XrIH_sjvu": "A análise de IA da sua gravação falhou.",
  "FoodB_process_vjLl_iVPp": "Recusada",
  "FoodB_optimization_PAD_Status_ipTp": "Status do tablet",
  "Internal_Tools_App_xWMr_AnaW": "Ligar",
  "FoodB_accompanyvisit_wQpj_fUwf": "Avalie como o BD conduziu o processo de vendas: ele identificou efetivamente os pontos problemáticos, apresentou a proposta com clareza e orientou com confiança o fechamento do negócio?",
  "FoodB_verification_Amount_BBjJ": "Valor",
  "FoodB_accompanyvisit_eQAg_imAj": "O BD demonstrou confiabilidade, confiança e profissionalismo ao interagir com os parceiros?",
  "FoodC_20240607_Upph_ldoj": "Lembrete de compra",
  "FoodB_calculator_VKAb_KHst": "Taxa de recompensa da plataforma",
  "FoodD_Name_May_zYiz": "Mai",
  "FoodB_list_KP_Name_GQRs": "Nome do representante do estabelecimento",
  "Gattaran_statusbar2_zVad_yPpm": "Recusado",
  "Gattaran_20240409_cmyA_kTJa": "Cadastros abertos ({{num}})",
  "Gattaran_jumpnewstore_kzko_qHFR": "Toque para ver os dados de tráfego",
  "FoodB_communications_APfO_DcRl": "Tarefas de incentivo de novo estabelecimento não concluídas",
  "Gattaran_20240409_krBB_ZQnQ": "Não iniciado ({{num}})",
  "Gattaran_management_HNXE_vNoU": "ID da tarefa",
  "Gattaran_status_pAhA_kENZ": "Verificando",
  "FoodC_edit_JdIz_uKvw": "Encontrar o(a) entregador(a) parceiro(a) do lado de fora",
  "FoodC_education_In_order_SRIb": "Esta política de cancelamento foi elaborada para ajudar todos os usuários a terem uma experiência justa e confiável ao usarem o aplicativo {{brand_name}}.",
  "FoodB_Show_Taxpayer_Document_eadz": "Tipo de documento (local)",
  "Gattaran_visit_Doei_EFIn": "Nenhuma visita nos últimos 30 dias",
  "FoodB_scenario_czrv_MZIJ": "O menu está desatualizado",
  "Gattaran_opt_Qotr_nHZK": "Relatório do estabelecimento",
  "Gattaran_v1_pVFJ_UAfK": "Inscrever o estabelecimento na oferta de campanha",
  "FoodC_202408_LBac_RLgP": "Adicione um endereço para que o(a) entregador(a) parceiro(a) possa entregar o pedido para você",
  "FoodOpB_center_Rejection_FiOu": "Rejeitar",
  "Gattaran_tag_glXW_NBjn": "Gerenciado pela equipe DK?",
  "Gattaran_management_SqSM_FwHJ": "Visitado",
  "Gattaran_feedback_Xihz_dCuZ": "Feedback incompleto",
  "FoodB_202410_piGe_Vcqi": "Imagem do banner",
  "Gattaran_statusbar2_QQFK_mEcw": "Verificar",
  "FoodC_202408_BsWi_bWTi": "Editar endereço",
  "FoodB_1106_hYOE_wfgV": "Visualizar resultado do reconhecimento",
  "FoodC_202408_LtuD_oTxz": "Cancelar",
  "FoodB_V1_hqNE_fQDz": "projetos",
  "FoodC_sales_If_the_TsPm": "Para nos ajudar a verificar o problema com a loja ou com quem fez a entrega, verifique se o pedido estava lacrado adequadamente.",
  "Internal_Tools_App_kPwc_tSpo": "Há informações não salvas.",
  "FoodB_Analysis_Nearly_7_wumh": "Últimos {{day}} dias",
  "FoodB_2_During_the_QHhU": "Período da oferta",
  "Gattaran_202406_ODsG_JrEY": "tarefa(s) a ser(em) concluída(s)",
  "Gattaran_Visit_Formula_item_xqos": "Fórmula = (pontuação da oferta 1 / 4 + pontuação da oferta 2 / 4 +...) / Número de ofertas * 100%",
  "FoodB_2_UZQT_LsHI": "Taxa de serviço mínima de entrega da plataforma",
  "Gattaran_ES_ZfMz_IKyd": "Conectividade",
  "FoodC_education__2_uVUK": "(2) O estabelecimento ao qual você fez o pedido está fechado, um item está esgotado, ocorreu um acidente ou o pedido foi cancelado pelo estabelecimento ou pelo(a) entregador(a) parceiro(a) por outro motivo. Nesse caso, você receberá um reembolso total.",
  "Gattaran_transformation__AByw": "Tipo de signatário",
  "FoodB_V1_VKlO_UPTE": "Descrição do projeto",
  "FoodB_orders_Select_Store_gtmG": "Selecionar lojas",
  "Internal_Tools_App_iieD_DElO": "CNPJ: {{Tax_id}}",
  "FoodB_audit_Suspected_duplicate_ntLx": "Estabelecimento suspeito de duplicidade",
  "Internal_Tools_App_Qhjz_HpXk": "Longitude: {{lat}}",
  "Gattaran_202406_VqOU_hMFa": "Prioridade do tipo de tarefa",
  "Gattaran_202406_CltK_IQGG": "Criadas ({{N}})",
  "FoodB_GTR_Eiwe_KevC": "Nome do Representante 99",
  "Gattaran_AlertV1_yVMN_aZdo": "Alertas do estabelecimento",
  "FoodB_Show_Taxpayer_Document_TFeg": "Tipo de documento (nacional)",
  "Gattaran_0_App_Operator_ikIT": "Operador de aplicativo",
  "Gattaran_202406_ztqf_jOPK": "Não concluído",
  "Gattaran_202406_dDeL_ULkW": "Ver",
  "Gattaran_function__vJQK": "Você está usando a versão mais recente",
  "Gattaran_cancelation_ytQo_VUhl": "{{N}} tarefa(s) executada(s)",
  "FoodB_1106_dvab_aMNJ": "Enviar",
  "FoodB_management_BPgJ_auGY": "Hora da liberação",
  "FoodB_report_CVHi_kjAP": "Localização da loja",
  "FoodB_accompanyvisit_QoJr_HduH": "Avalie como o BD executou o processo de negócio, incluindo sua capacidade de interpretar KPIs, habilidade de negociação e proficiência nas ferramentas.",
  "FoodB_opencheck_pkQS_Jxyo": "Checagem aberta",
  "FoodB_2_UTCg_iJFB": "Nenhum pedido da loja foi detectado. Você ainda quer concluir a verificação em aberto? (Ela será analisada manualmente após o envio.)",
  "Gattaran_visit_hZGE_sfuk": "Feedback geral",
  "Gattaran_Optimization_SGMS_fnOQ": "Para 99Food",
  "FoodB_202410_Cahy_pzlN": "Informações básicas",
  "Gattaran_form_YnWW_YxTG": "Adicionar pessoa para contato",
  "FoodB_2503_JeQk_FWxd": "Carregando…",
  "FoodB_optimization_Buy_gifts_daUI": "Compre X, ganhe Y",
  "Gattaran_material_DYNa_ciax": "Status da análise da tarefa",
  "sailing.crm-intl.乙方联系方式": "Telefone da pessoa que assinará o contrato (sócio administrador ou pessoa com procuração) - Apenas celular com DDD",
  "Gattaran_opt_EFMf_fxMF": "Última visita",
  "FoodB_Show_Delivery_and_UBbK": "Distribuição e comissão",
  "FoodC_update_The_expected_ZzFg": "O horário estimado da entrega tem como base o último horário estimado de entrega.",
  "FoodB_pt1_ofEk_bcpz": "E-mail de contato",
  "FoodC_202408_BTvL_umes": "Tem certeza que deseja sair?",
  "soda-m-i18n---押金$1500": "Depositar R$1500",
  "FoodB_management_BTeP_YljD": "Concluir tarefa",
  "FoodB_v12_XWfx_gGrQ": "Nome do integrador de pedidos",
  "FoodOpB_CRM_Taxpayer_Information_Flde": "Anexo da foto do documento fiscal local",
  "FoodC_202408_ReqK_LVas": "Confirmar",
  "Gattaran_V2_NgaM_BsXe": "Resumo da oferta",
  "Gattaran_opt_QCLu_UWmJ": "Pedidos cancelados",
  "Gattaran_0_Can_t_zMtY": "Não foi encontrado",
  "FoodB_model20250116_HPUj_zcce": "Localização não encontrada. Não é possível fazer check-in ou check-out. Permita os serviços de localização nas configurações do seu telefone e permita que o aplicativo BD acesse os serviços de localização",
  "FoodB_clockin_GfHc_jTsX": "Check-in feito sem preencher os detalhes da visita",
  "FoodB_420241024_rQXh_ONDO": "Alcançado",
  "FoodB_2_R_Burn_CgKc": "R-burn",
  "FoodB_system_Competition_NFPY": "Concorrente",
  "Gattaran_202412_nVQh_JkKC": "Pagamentos da plataforma offline não são obrigatórios",
  "Gattaran_statusbar2_UQFc_DODT": "Acompanhando",
  "Gattaran_0_Publicity_cards_HSYt": "Bloqueios",
  "Gattaran_management_fVhj_uFOo": "Fique à vontade para falar conosco. Ficamos à disposição!",
  "FoodB_management_Untied_tYEF": "Desvincular",
  "Gattaran_form_mvdB_WqwR": "Adicionar próxima ação",
  "Gattaran_visit_kYQA_ZYsK": "O BD resolveu objeções da loja",
  "Gattaran_mgt_System_recommended_AeDM": "Ordenação recomendada",
  "FoodB_opencheck_nxrN_OKDp": "Certifique-se de que o número de telefone do estabelecimento esteja correto e acessível para que os entregadores e clientes possam entrar em contato",
  "Gattaran_status_AuAL_dKPA": "Nenhum registro de visita",
  "FoodC_education__1_qvVC": "(1) Você não retira seu pedido dentro do prazo",
  "soda-c-i18n---请告诉我们，帮助我们一起改善": "Entre em contato e ajude-nos a melhorar",
  "FoodB_calculator_RWNx_Xkrf": "Individual",
  "Gattaran_optimation_QjMB_BOgo": "A página de formulário de visita de acompanhamento fechou inesperadamente. Toque em “Reabrir” para voltar à última página em que você estava.",
  "Gattaran_form_jbbp_rBPM": "Sair",
  "Gattaran_transformation__hYxT": "Associar signatário",
  "FoodB_side_Not_yet_wnPA": "Nenhum",
  "Gattaran_Edition_oXdU_Hnsz": "Não conseguimos encontrar o que você está procurando",
  "Internal_Tools_App_fEpS_WJta": "Longitude",
  "FoodB_V1_zPrX_zWoE": "Alteração no R burn/GMV",
  "FoodB_0905__pNYF": "Os pedidos são sobrepostos. A soma não reflete o total de pedidos finalizados por dia",
  "FoodB_management_Sector_LRtz": "Departamento",
  "FoodB_1106_SvnP_rxzP": "Concluído",
  "FoodC_202408_XlDL_LjiM": "Entendi",
  "Gattaran_0_Price_management_rLvu": "Gerenciamento de preço",
  "FoodB_accompanyvisit_NWZA_xYGO": "Comente como o BD se preparou para a visita de acompanhamento: os objetivos estavam claramente definidos? O sistema de CRM foi usado de forma eficaz? O foco estratégico foi mantido durante a visita?",
  "FoodB_0623_Store_GZFE": "Estabelecimento",
  "Gattaran_opt_BEjW_mzFb": "Os relatórios de dados podem ser vistos depois da primeira vez online",
  "FoodOpB_results_No_store_ZJQG": "Nenhuma informação de contato válida para o estabelecimento",
  "FoodC_Website_DiDi_FoodDiDi_wtqn": "99Food. Coma bem a qualquer hora, em qualquer lugar",
  "Gattaran_0_If_you_xGEs": "Um ou mais campos estão vazios. Verifique e tente de novo",
  "FoodC_edit_dECN_fkIy": "Encontrar o(a) entregador(a) parceiro(a) fora do meu edifício comercial",
  "FoodOpB_crm_Takeaway_mode_UxEG": "Modo de entrega",
  "FoodC_202408_tJIe_WbFo": "Cancelar",
  "Gattaran_workstation_zYPi_OfrB": "Valor alvo",
  "FoodB_2__CkLu": "Mesma cidade",
  "FoodB_opencheck_bGuJ_TIut": "O estabelecimento aceita que entregadores paguem em dinheiro?",
  "FoodB_resivion_Inaccurate_information_dmRA": "Informações incorretas?",
  "FSaaSB_app_Wqoi_tnbw": "Número de mesas",
  "FSaaSB_app_rRsV_HRBt": "Plataforma de entrega utilizada",
  "FoodC_page__KWIm": "Entendi",
  "FoodB_0905__Uuug": "Regras de diagnóstico",
  "FoodC_sidebar_Update_successfully_cuyI": "Atualizado com sucesso",
  "FoodB_list_Business_Category_uDdS": "Categoria da empresa",
  "FoodB_Improvement_ZUzh_lhtC": "Onboarding solicitado para mais de um estabelecimento",
  "Gattaran_visit_TCbI_opYt": "Visitas planejadas",
  "FoodC_20240607_RSyh_XJnN": "Abra o link no dispositivo móvel",
  "Gattaran_Visit_VrZq_Dgvh": "Oportunidades adicionais",
  "Gattaran_feedback_wHFC_wkFP": "Insira o motivo específico",
  "Internal_Tools_App_iCHw_cRVH": "Outro",
  "Gattaran_0_Visit_Registration_AZYL": "Informações coletadas do estabelecimento",
  "Gattaran_0_Increase_social_MxxK": "Adicionar para redes sociais do restaurante",
  "soda-m-i18n---无试用期": "Nenhum período de teste",
  "FoodB_in_KrvJ_sgtQ": "{{storename}} está a mais de {{distance}} metros de você, por isso, não é possível fazer o check-in. Tire uma foto com a placa do estabelecimento para concluir.",
  "FoodB_accompanyvisit_qeYs_vmCH": "Pontos positivos",
  "FoodB_management_YBeV_ZPVJ": "O nome não pode exceder 50 caracteres",
  "Internal_Tools_CRM_jrXd_olfC": "Melhor horário para visita",
  "Internal_Tools_App_mzyX_fryx": "Selecione o intervalo",
  "Gattaran_Optimization_IGsH_WCQM": "Aberto no 99Food",
  "FoodB_V1_toMO_YDdz": "Tarefas regulares",
  "Gattaran_v2_LSlZ_XduF": "Toque para aprender as regras e ajudar o estabelecimento a se tornar um estabelecimento {{DiDi_Top}}",
  "FoodB_0623_Indicators_auar": "KPI",
  "FSaaSB_app_VWgN_QpHO": "Pedidos da loja na {{brand_name}} (média diária)",
  "Gattaran_20250610_poQp_BBLe": "Associação pendente",
  "Gattaran_center__HcEx": "Todas as mensagens foram marcadas como lidas",
  "Gattaran_page_zJGg_ZjcY": "Preencha as informações de credenciais do estabelecimento e solicite a assinatura do contrato",
  "FoodB_model20250116_GjAr_XZPC": "Check-in",
  "FoodB_score_wfAf_crwP": "Lógica de classificação:",
  "Gattaran_0__mpop": "Abra no aplicativo ou procure “Feedback do Gattaran e Explorer” no D-Chat para entrar no grupo de feedback",
  "FoodOpB_Translation_Legal_persons_RduO": "Pessoa jurídica",
  "FoodC_20240607_wWhy_deWR": "Atualize a página e tente novamente",
  "Gattaran_management_WVOf_JOti": "Ver",
  "Gattaran_material_WsIN_lrzh": "Em análise: após a aprovação, a tarefa será concluída automaticamente",
  "FoodB_1106_kpYX_BXVq": "Analisar",
  "Gattaran_optimation_MQrO_OvRt": "Quer recuperar essa página?",
  "Gattaran_change_ioKU_diDR": "Os dados de teste começam com \"Test-\". Por favor, renomeie se a loja for real",
  "Gattaran_resivion_More_KTYU": "Mais",
  "Internal_Tools_App_iRIy_dqLi": "Este mês",
  "FoodB_2_cAcO_mtpN": "Nome do titular do cartão",
  "FoodC_switch_TFwP_lxTd": "Definir gorjeta padrão",
  "FoodOpB_efficiency_Store_UpAc": "Estabelecimentos com assinatura",
  "Gattaran_V1_ZDXa_aTjw": "Lista de ofertas válidas",
  "FoodB_0905__uatF": "Acima de {{number_or_rate}} lojas próximas",
  "Internal_Tools_App2_UCNH_VaOP": "Hoje",
  "Gattaran_202406_IIUg_NlxT": "Informações do estabelecimento",
  "FoodB_management_ouRt_eARK": "Selecione uma função",
  "FoodB_Display_ohOC_SIAy": "Informações para contato",
  "FoodC_edit_wBJW_yfSo": "Apartamento",
  "Internal_Tools_App_BEnH_Yxgl": "O filtro mínimo é de dias",
  "FoodC_20240607_aOOB_RMKm": "O pagamento em dinheiro está temporariamente indisponível",
  "Gattaran_202406_htDL_CJTB": "Criador da tarefa",
  "FoodB_0905__kaPI": "Pontuação de diagnóstico",
  "Gattaran_Picking_QpFi_mWmw": "A forma de pagamento atual do modo de comprador do estabelecimento",
  "FoodB_part3_DIXA_purA": "Extrato bancário",
  "Gattaran_0__tWkQ": "Itens promocionais",
  "FoodB_ads_WAjG_IoqX": "Anúncio",
  "Gattaran_Optimization_cVHJ_PCUb": "Toque para mostrar os detalhes do horário da loja",
  "soda-c-i18n---送您%s张免配送费券；": "daremos a você %s cupom de entrega gratuita.",
  "FoodB_supplement_Network_connection_RVcl": "Falha na conexão. Verifique suas configurações de rede",
  "FoodB_tagging_You_chose_tIKm": "Você optou por invalidar este lead pelo seguinte motivo: “O estabelecimento não existe”. Para fazer isso, você deve estar a {{distance}} de distância do estabelecimento. Verifique e tente novamente.",
  "FoodB_v2_ThsH_hkFm": "Métodos para conectar/desconectar",
  "FoodB_accompanyvisit_qoYF_XrTD": "O BD demonstrou confiança, comunicação corporativa profissional e uma presença humilde e não arrogante?",
  "FoodB_opencheck_HmpM_qXXX": "Para comerciantes que operam vários estabelecimentos em um local, verifique se a integração e a configuração de aceitação de pedidos na {{99store}} estão corretas",
  "Gattaran_add_xwYd_UfEG": "Logotipo",
  "FoodC_20240607_eLRx_hJRj": "Página não disponível no computador",
  "Gattaran_Gattaran_wHVV_MQDY": "Tipo de plano",
  "FoodB_item_qIfj_VfVa": "Informações básicas",
  "Gattaran_0_Contrast_the_YwEa": "Reduzir preços dos concorrentes",
  "FoodB_opencheck_azHm_SBan": "Certifique-se de que o nome do estabelecimento exibido no aplicativo do cliente esteja correto",
  "FoodC_edit_Hxmm_vrkU": "Edifício residencial",
  "Gattaran_V1_gCzF_PJKj": "{{num}} oferta(s) para acompanhar",
  "FoodB_communications_ZlRD_aGjm": "Resta(m) {{task_left_days}} dia(s)",
  "Gattaran_opt_xawD_vBtI": "Horas online diárias",
  "FoodOpB_Translation_Delivery_starting_fbah": "Taxa de entrega mínima da loja",
  "Internal_Tools_App_oOyW_tZKN": "Fora da lista",
  "FoodB_management_JCLV_lXux": "Informações de contato",
  "FoodOpB_1_Visit_dXVU": "Visita",
  "Internal_Tools_CRM_ZxcL_MqnG": "Valor da compra",
  "FoodB_leads_The_relationship_jkYA": "Melhor horário para contato",
  "FoodB_accompanyvisit_GMeg_eJaf": "Durante a visita de acompanhamento, o BD manteve consistentemente uma postura de trabalho proativa e organizada, utilizando o tempo de forma eficaz para maximizar a performance geral?",
  "FoodB_Tracking_VElw_nkCE": "Versão do contrato",
  "Gattaran_form_KjAJ_bymE": "Detalhes do plano de visita",
  "FoodB_page_Sbrx_Otpv": "Tem certeza de que deseja sair? Se você sair, os resultados da análise ficarão disponíveis apenas por meio de mensagens no aplicativo.",
  "FoodB_2_cggC_JRRZ": "Foto do documento de identidade",
  "Gattaran_BDapp_Pder_myCx": "Portal de BD (CKA)",
  "Gattaran_feedback_tOgJ_GxDc": "Enviar imagem (opcional)",
  "FoodD_suspensionpage_In_the_zGEU": "Sem mais resultados",
  "FoodC_202408_AFKG_hWIj": "Fora da área de entrega. Selecione outro endereço",
  "FoodB_page_Ejhz_BIgP": "Quero me cadastrar",
  "FoodOpB_StoreInput_Store_Information_mIjy": "Informações do representante do estabelecimento",
  "FoodB_202410_XLby_OmOV": "Endereço do estabelecimento",
  "FoodB_APP_hvLT_iISi": "Valor máximo diário de investimento",
  "FoodC_perception_Tip_exceeds_VSFf": "O valor da gorjeta excede o limite",
  "FoodB_V2_Satisfied_with_YFEM": "Satisfeito com a operação atual",
  "FoodB_revamp_JrnZ_UzZC": "Fórmula",
  "Gattaran_V2_tHSp_MfFU": "Dias com meta atingida ≥",
  "FoodB_accompanyvisit_csKl_ZhaN": "Atitude e desempenho",
  "Gattaran_0915__UZgP": "Período de cálculo: {{date1_date2}}",
  "Gattaran_change_NaqO_dYRO": "Observação: as lojas cujos nomes começam com Teste- serão automaticamente identificadas como lojas de teste",
  "FoodB_email_AhaC_FOft": "Outro contato",
  "FoodB_requirement_aAaC_nmQK": "Conectado nos horários de alta demanda",
  "FoodB_Side_JVcJ_wJec": "Horário de funcionamento",
  "FoodB_tagging_You_chose_lWSH": "Você optou por invalidar este lead pelo seguinte motivo: “Não é um estabelecimento de varejo”. Para fazer isso, você deve estar a {{distance}} de distância do estabelecimento. Verifique e tente novamente.",
  "Gattaran_202406_JIgY_duWs": "Recebido",
  "FoodB_pt1_KFvg_Iavt": "Nº de CPF",
  "FoodB_1106_UjEj_dsYG": "Cancelar",
  "Gattaran_0_Not_willing_JFcK": "Não quer",
  "Internal_Tools_App_kYus_Rwmo": "Telefone",
  "FoodB_model20250116_PRsL_yJEl": "Selecione pelo menos {{num_required_fields}}",
  "FoodB_v12_zpim_qhxP": "Nome do integrador",
  "Gattaran_0__sDLK": "Clique no botão “Carregar” para ver mais estabelecimentos",
  "Gattaran_visit_MlQG_hbNY": "Visita planejada: {{planned_visit_date}}",
  "FoodB_calculator_QGtY_JOsw": "Participação de investimento da loja do desconto",
  "Internal_Tools_App_giWs_FLQG": "Insira observações adicionais aqui",
  "Internal_Tools_App2_HKlO_Ulnq": "Percentual",
  "FoodB_page_VcqY_DnGG": "A análise semântica deverá demorar entre 1 e 5 minutos. Permaneça nesta página. Se sair, você poderá consultar as mensagens no aplicativo para ver o resultado da análise.",
  "FoodC_education_Basic_requirements_hIbv": "Regras básicas de entrega para clientes",
  "支付方式": "Payment Method",
  "Gattaran_202311_WXzo_Yqns": "Adicionar lead válido",
  "FoodOpB_Translation_Tax_ID_yEbh": "Documento Fiscal",
  "Gattaran_form_HuGK_YufB": "Editar plano de visita",
  "FoodB_Bill_nfFF_FDip": "Taxa de entrega da loja",
  "FoodB_scenario_TNIB_LZav": "Loja fechada hoje",
  "Gattaran_Collection__kwys": "A página de mapa agora permite navegação aos estabelecimentos",
  "FoodB_accompanyvisit_sotp_ppjT": "Áreas para melhoria",
  "FoodD_Name_November_BcWL": "Nov",
  "FoodB_GTR_MOcd_Ludv": "KA",
  "soda-m-i18n---追加门店协议v2.0": "adicionar contrato do estabelecimento v2.0",
  "Internal_Tools_CRM_zbxK_LqJo": "CNPJ",
  "FoodB_sob_rSPd_SAxs": "SOB vinculado",
  "FoodB_1106_ocKT_vZHR": "A gravação não pode exceder 2 minutos",
  "Gattaran_0_No_contacts_EeBR": "Nenhuma pessoa para contato",
  "Internal_Tools_CRM_LzIy_MlTO": "Bandeira",
  "FoodB_accompanyvisit_HBWN_qmUt": "Abordagem de engajamento e construção de confiança",
  "FoodB_Wordings_MYHl_FXti": "Selecione um motivo",
  "Gattaran_opt_FWKd_AEaY": "Clique aqui para inserir informações de operações offline",
  "FoodD_Incentive_In_progress_GNvs": "Em andamento",
  "FoodB_2_Visit_Records_LiJy": "Registro de visitas",
  "FoodC_edit_fLUx_wHAP": "Exemplo: estou usando uma camisa estampada. Você também pode carregar fotos dos arredores para ajudar o(a) entregador(a) parceiro(a) a entregar seu pedido no local correto.",
  "Internal_Tools_App_pcBI_HhnE": "Redefinir",
  "FoodB_202204_Order_eJXF": "Pedidos",
  "Gattaran_Visit_Fill_in_aFuS": "Inserir uma visita de acompanhamento",
  "FoodC_202408_KYqe_yVZD": "Agora não",
  "FoodB_250430_kaeY_cgas": "Nível da visita",
  "FoodC_edit_kzdk_yzVc": "Encontrar o(a) entregador(a) parceiro(a) na porta da sala",
  "FoodC_edit_HEFc_Dppo": "Encontrar o(a) entregador(a) parceiro(a) fora do meu edifício residencial",
  "FoodB_store_Order_Coupon_zpSY": "Cupom de desconto do pedido",
  "FoodB_1106_fIyR_ECeB": "Insira o conteúdo",
  "Gattaran_visit_opSF_XPmM": "O BD tinha um objetivo claro para a visita",
  "FoodB_report_nayE_PYlR": "Selecione a localização correta da loja",
  "FoodB_calculator_Vzvw_WmgN": "Forma de pagamento",
  "Gattaran_20240409_JmCU_vNnz": "dias depois, o cadastro começará",
  "FoodC_202408_IDjR_CbbT": "OK",
  "FoodB_2_Call_visit_NGFu": "Telefone",
  "FoodB_I_Cancelled_orders_XeVk": "Pedidos cancelados",
  "FoodC_education_2_Receiving_gFZl": "2. Verifique se o endereço de entrega e a forma de contato fornecidos estão corretos.",
  "FoodB_1__GxZN": "Dados dos últimos 30 dias",
  "FSaaSB_app_Qqfu_vMaO": "Pedidos para entrega da loja (média diária)",
  "FoodC_202412_AIDx_XZgz": "Editar endereço",
  "Gattaran_Feedback__amKQ": "Alto",
  "Gattaran_0_Is_it_uBZs": "É uma cozinha exclusiva para entregas?",
  "Gattaran_0_Price_of_cdsJ": "Preços na 99 em relação a outros aplicativos",
  "Gattaran_V2_hSoR_bteQ": "O BD pode se registrar para lojas",
  "FoodB_APP_oNMt_RYzY": "Configurar agora",
  "Gattaran_optimization__HjAa": "Clique no botão “Voltar” de novo para sair do Explorer",
  "Internal_Tools_App2_zKCw_IMpc": "Sáb",
  "Internal_Tools_CRM_CqzP_fbCc": "Cidade",
  "Gattaran_form_MglG_FNNK": "Hora da visita",
  "soda-m-i18n---试用时间0个月": "Tempo de teste 0 meses",
  "FoodOpB_Translation_ID_Card_jQZG": "Documento de identidade",
  "Gattaran_management_JcWN_FRMj": "Contrato com o estabelecimento",
  "FoodB_report_iSNH_AOiz": "Forneça o endereço ou as coordenadas corretas da loja e envie novamente",
  "FoodC_cash_WQNI_uYzC": "Adicionar",
  "FoodB_opencheck_EgVo_aDIk": "Verifique se o estabelecimento tem um pedido de teste",
  "FoodB_collection_625_System_iWnH": "625 - Regime de ganhos das atividades de negócios de plataformas tecnológicas",
  "FoodOpB_Org_Edit_Gphm": "Editar",
  "Gattaran_Optimization_ZhGy_ZlOk": "Adicionar detalhes do horário de funcionamento",
  "FoodB_0919__CONM": "Itens indisponíveis",
  "FoodB_1106_CBkZ_uDVO": "Quais são os próximos passos?",
  "FoodB_scenario_HbKA_WhYt": "Cancelado devido a um problema do cliente",
  "FoodB_GTR_nRcI_TMWR": "CKA",
  "Gattaran_202406_EMkK_osti": "Estabelecimento",
  "Internal_Tools_App_fJQz_FBzw": "Últimos {{month}} meses",
  "Internal_Tools_App_XqAW_HtbS": "Preço em tempo real",
  "FoodOpB_1_Plan_Nfsn": "Em planejamento",
  "FoodB_V1_GLnG_kpoL": "Tarefas de projeto",
  "FoodB_II_jpUD_hKgG": "Operações",
  "FoodB_2_KsDS_jToj": "Recompensas da Tarifa 99",
  "Internal_Tools_CRM_nvDw_fHdG": "CEP",
  "Gattaran_form_HWQO_aSuK": "Toque para preencher o formulário",
  "FoodB_Commision_Cancel_wbtQ": "Cancelar",
  "FoodC_education_4_Customers_laxR": "4. Retire seu pedido em até 10 minutos após a chegada do(a) entregador(a) parceiro(a) ao local de entrega.",
  "FoodOpB_Management_You_can_aDLi": "Para criar seu novo estabelecimento mesmo assim, clique em Contestar. Lembre-se de que a análise de uma contestação pode levar até 2 dias.",
  "FoodC_shop__MWyO": "Limite de compra: {{num}}",
  "FoodB_in_nOzs_ZRGC": "Check-in concluído",
  "FoodOpB_Org_Can_not_swrB": "Tem certeza de que deseja remover? Esta ação não poderá ser desfeita.",
  "FoodC_2022__SEQk": "Insira a gorjeta",
  "FoodB_opencheck_fpzY_bDWB": "Confirme o método de entrega e a forma de pagamento",
  "FoodB_0622_The_statistical_NUCJ": "Os dados são calculados com base em T+1 e classificados de acordo com o volume de vendas do item nos últimos 30 dias",
  "Gattaran_opt_OIIn_XXkw": "Rever auditoria",
  "Gattaran_form_KvgC_Afkb": "Confirmar saída",
  "FoodB_Management_fzrt_bjhW": "Tipo de loja",
  "soda-m-i18n---免费使用": "Uso gratuito",
  "Gattaran_V1_ZkCf_UOay": "Limpar",
  "FoodC_202410_OFhs_UnlA": "Explorar",
  "Gattaran_Edition_mvmO_sigb": "A data selecionada está em conflito com um plano de visita que já existe. Se você enviar, o plano de visita anterior será substituído.",
  "FoodB_Explorer_between_the_BtbJ": "Horário da primeira assinatura",
  "FoodB_0921__iLXg": "Quantidade",
  "Gattaran_20240401_iQeT_rFly": "Agradecemos seu comentário!",
  "Internal_Tools_App_Bufi_ZBrZ": "Navegar",
  "soda-c-i18n---送您1张%s折扣券；": "daremos a você 1 cupom de %s de desconto.",
  "FoodB_0919__etPs": "Várias ofertas",
  "FoodB_indicator_ONJL_riny": "Pontuação",
  "FoodC_edit_EqUG_FRvo": "Nome do apartamento/Andar/Sala nº",
  "FoodB_calculator_lSyU_ySZI": "Loja em Guanajuato?",
  "Gattaran_material_GlUh_BTci": "Formulário de tarefa",
  "FoodB_feedback_uLgw_xDsP": "Feedback enviado com sucesso",
  "FoodOpB_management_Actual_value_dSKC": "Valor real",
  "FoodB_202207_Default_BQmA": "Padrão",
  "Gattaran_add_pxre_uOHq": "Cidade",
  "FoodOpB_app_Collecting_documents_wTBe": "Enviando documentos",
  "FoodB_V2_DQvR_Redp": "Use a função de compartilhamento no aplicativo BD.",
  "FoodC_optimization_knQx_VpIr": "Adicionar",
  "Gattaran_V2_RfQR_GPmX": "Descrição da métrica da tarefa",
  "FoodB_up20241218_dJSA_yyZX": "Confirmar",
  "Gattaran_202406_Rqhc_vORg": "Tarefas do estabelecimento",
  "FoodB_scenario_cPkp_BcjZ": "O entregador parceiro nunca chegou à loja",
  "Gattaran_optimation_uLZP_VtyM": "Reabrir",
  "FoodB_page_ckUV_pmrw": "Gerando seu resumo",
  "Gattaran_mgt_All_SSzR": "Tudo",
  "Gattaran_202406_ObEK_ztcK": "O cálculo de dados deste KPI não foi concluído. Verifique novamente amanhã",
  "Gattaran_form_pQiE_NLFe": "Objetivos da visita recomendados com base nos resultados de diagnóstico do estabelecimento",
  "Gattaran_page_kbBm_zDwh": "Se você assinar o contrato aqui, um novo signatário será criado para esse estabelecimento como padrão, e você não receberá uma cópia física do contrato. Se precisar de uma cópia física ou quiser vincular um signatário existente para assinatura de rede, acesse GTR > Gerenciamento de cliente > Gerenciamento de signatário, em vez de assinar o contrato. Quer mesmo assinar o contrato aqui?",
  "支付": "Pagar",
  "Gattaran_REGULAR_KZHa_qJOa": "Insira um número inteiro",
  "FoodB_IV_Tips_DFOG": "Alertar",
  "FoodB_V1_baBa_ZZGt": "Pesquisa do estabelecimento",
  "Gattaran_202406_kjmQ_Epeu": "Criada",
  "Gattaran_0_What_are_AWJz": "Qual é a principal oportunidade identificada na zona?",
  "FoodB_2_SwSw_VDmW": "Nº do cartão do banco",
  "FoodB_msg_Bank_FoeY": "Banco",
  "FoodB_model20250116_pAHl_Vjqs": "Não aprovado",
  "FoodB_management_Exlz_JjpO": "Algum suprimento a ser emitido?",
  "Gattaran_202406_NOiB_wJYW": "Criar tarefa",
  "FoodB_Analysis_Rise_decline_dZnP": "Para cima",
  "Gattaran_jumpnewstore_FJjw_JHRB": "Tarefas do novo incentivo do estabelecimento concluídas",
  "FoodB_management_tvNC_ULVM": "Número de WhatsApp",
  "FoodB_2_unai_MAXI": "Endereço registrado da outra parte",
  "Gattaran_Visit_Advantages_CSEp": "Intensidade",
  "FoodC_Storefront_Fzba_uHgH": "Não é possível participar",
  "FoodC_education_In_the_MKeB": "Você não será responsabilizado por um cancelamento nas seguintes situações:",
  "FoodC_improve__ovBF": "Porções pequenas",
  "FoodB_accompanyvisit_ebrS_uKVQ": "Detalhes da pontuação",
  "Gattaran_0__ytbk": "Prioridade",
  "FoodB_audit_New_and_yYux": "Diferença entre nomes dos estabelecimentos novos e antigos",
  "Gattaran_Visit_Related_Visit_RGas": "Registro de visitas associado",
  "Gattaran_side__OvkZ": "Quinta-feira",
  "FoodOpB_tagging_Store_does_sduq": "O estabelecimento não existe",
  "FoodC_education_In_order_AZCw": "Estas regras de entrega foram elaboradas para ajudar todos os usuários a terem uma experiência justa e confiável ao usarem o aplicativo {{brand_name}}. No caso de um conflito relacionado à entrega, serão aplicadas as regras a seguir",
  "FoodB_2_RPYQ_YKTN": "",
  "FoodOpB_Gattaran_Reset_ILVf": "Redefinir",
  "FoodB_1106_ZsZM_gMYt": "Resuma usando a estrutura abaixo",
  "Gattaran_transformation__QWlQ": "Preencha todos os itens obrigatórios",
  "Gattaran_0__jRoM": "Abrir D-Chat",
  "FoodB_time_Business_hours_kRTs": "Horário de funcionamento nos feriados",
  "Gattaran_cancelation_Rcqm_Vawt": "Registro de visitas relacionadas a tarefas",
  "Gattaran_20250610_swWp_JIQH": "RTBO concluído. Entre em contato com o estabelecimento para confirmar o contrato",
  "FoodB_1106_vIQn_DUwT": "Você atingiu o tempo máximo de gravação de {{max_record_time}} segundos. Deseja iniciar a análise dos dados?",
  "Internal_Tools_App_phGO_IYRt": "Classificar",
  "FoodB_management_zycc_XYgy": "Entrada inválida",
  "FoodB_0921__kEaD": "Burn%",
  "FoodC_education_Cancellation_Policy_fxrl": "Política de cancelamento",
  "FoodB_email_Cebi_VpDl": "Telefone",
  "FoodB_Analysis_New_customers_vYDl": "Novos clientes",
  "FoodB_up250108_UapS_ZXgM": "Ver agora",
  "Gattaran_202406_UOFx_ekzp": "Cancelar",
  "FoodB_resivion_Overdue_visit_jTHW": "Visitas expiradas",
  "FoodB_calculator_TJJY_SkoH": "Investimento da loja",
  "FoodOpB_CRM_Taxpayer_Address_EBwy": "Endereço do contribuinte nacional",
  "FoodC_202408_YjqN_Yvyz": "Adicione o endereço para ver a taxa e o prazo de entrega",
  "FoodOpB_analysis_Performance_analysis_NMbA": "Insights de desempenho",
  "FoodOpB_set_Determination_wYFG": "OK",
  "Gattaran_contract20250806_cBZW_LivD": "Contrato não padrão",
  "FoodC_202408_IMjl_ywFc": "Atualizar",
  "Gattaran_System_wrVY_PjDQ": "Nome do plano",
  "FoodC_202410_pHYX_VjbD": "Fechar",
  "FoodB_calculator_ydSg_ejbp": "IVA",
  "FoodB_2__FNaI": "Mesma região-alvo",
  "请输入XXXXX-XXX": "Insira XXXXX-XXX",
  "合同类型": "Tipo do contrato",
  "回收完成": "Devolvido",
  "签约状态": "Status da assinatura",
  "正常经营": "Online",
  "合作拜访结果": "Resultado da visita de parceria",
  "执照照片": "Foto de documento com CNPJ da empresa",
  "重复门店电话": "Telefone de estabelecimento duplicado",
  "暂无合作意愿": "Não há intenção de cooperação",
  "日常维护信息": "Informações de manutenção de rotina",
  "签字": "Assinatura",
  "请选择不合作原因": "Selecionar motivo para não realizar parceria",
  "首次完单时间": "Horário da conclusão do primeiro pedido",
  "支行号": "Código da agência",
  "暂无": "Nenhum",
  "获取商圈中...": "Obtendo dados de região-alvo...",
  "周四": "Qui",
  "请在Gattaran上完成撤销申请！": "Conclua a solicitação de cancelamento no Gattaran.",
  "输入有误": "Inserido incorretamente",
  "设备信息": "Informação do dispositivo",
  "申诉通道": "Arquivar recurso",
  "目前营业中门店": "Aberto no momento",
  "店主（法人）": "Proprietário (representante legal)",
  "未达到任务完成的标准": "Requisitos de conclusão de tarefas não atendidos",
  "授权书照片": "Foto da procuração",
  "证号": "Nº do certificado",
  "法人CPF": "CPF do representante legal (sócio administrador da empresa)",
  "工具": "Ferramentas",
  "工商登记时间": "Horário de registro da empresa",
  "未确定合作": "Cooperação não confirmada",
  "Curp号必须为18位字符": "O CPF deve conter 11 caracteres",
  "提交成功": "Envio concluído",
  "公司": "A empresa",
  "驳回原因": "Motivos para recusa",
  "城市": "Cidade",
  "发放时间": "Atribuído em",
  "商机转交": "Atribuir para outra equipe",
  "保存并发邮件&短信": "Salvar e enviar e-mail e SMS",
  "签约授权书": "Autorização de assinatura",
  "信息已完善": "Informações completas",
  "上拉加载更多": "Puxe para cima para ver mais",
  "支付验证未通过": "Falha na verificação de pagamento",
  "等待原因": "Motivo da espera",
  "平台配送及自配送不允许同时选择不支持": "\"Entrega da plataforma\" e \"Entrega própria\" não podem ser selecionadas ao mesmo tempo",
  "平台管控中": "Estabelecimento fechado pela plataforma",
  "信心度A": "Nível de confiança A",
  "信心度B": "Nível de confiança B",
  "信心度C": "Nível de confiança C",
  "是": "Sim",
  "同意上线": "Concordou em se conectar",
  "查看更多": "Mais",
  "KP CPF": "CPF da pessoa responsável pela operação do estabelecimento",
  "评分": "Avaliação",
  "法人名片假名": "Pessoa coletiva Primeiro nome Katakana",
  "我的拜访": "Minhas visitas",
  "居民证明": "Certificado de residente",
  "确认签章": "Solicitar assinatura",
  "合作拜访": "Visita de parceria",
  "拜访记录": "Informações da visita",
  "无合作意向": "Não tem interesse na parceria",
  "PAD型号": "Modelo do tablet",
  "乙方名称片假名": "Razão Social Katakana",
  "开户行": "Banco emissor",
  "点击收起": "Ver menos",
  "暂停营业中": "Estabelecimento fechado temporariamente",
  "周日": "Dom",
  "已关闭": "Encerrado",
  "CNPJ": "CNPJ",
  "KP姓片假名": "KP sobrenome Katakana",
  "有效": "Sim",
  "CKA BD": "BD do time de CKA",
  "确定删除吗？": "Confirmar exclusão?",
  "日常工具": "Ferramentas diárias",
  "正常": "Normal",
  "掉线中": "Estabelecimento sem conexão",
  "沟通经营问题（服务管控+店铺装修）": "Discutir problemas operacionais (controle de serviços + decoração do estabelecimento)",
  "梅斯卡尔酒": "Mescal",
  "帐户持有人CPF": "CPF do titular da conta",
  "商户运营": "Engajamento",
  "菜单照片": "Fotos do Cardápio",
  "去设置": "Configuração",
  "跟进中": "Acompanhar",
  "销量(单/周)：": "Vendas (pedidos/semana): ",
  "支持以下哪种支付方式": "Quais formas de pagamento são aceitas no estabelecimento?",
  "失败号": "Nº da recusa",
  "谷歌地图": "mapa do google",
  "打开浏览器失败": "Não foi possível abrir o navegador",
  "银行卡号仅支持数字输入": "O nº do cartão do banco deve conter apenas números",
  "佣金补贴周期": "Ciclo de recompensa da Tarifa 99",
  "沟通新店保护设置": "Explicar como configurar um incentivo de novo estabelecimento",
  "公共契约编号": "Nº do contrato público",
  "首次完成开店检查时间": "Horário de conclusão da verificação do primeiro estabelecimento",
  "已签约": "Assinado",
  "商家概况": "Visão geral do estabelecimento",
  "执行团队": "Equipe responsável",
  "未连接到服务器": "Não é possível conectar o servidor",
  "KP CPF照片": "Foto do CPF com Data de Nascimento da pessoa responsável pela operação do estabelecimento",
  "自配送起送费": "Taxa mínima de entrega feita pela loja",
  "电话号码不对": "Número de telefone incorreto",
  "我知道了": "Entendi",
  "考虑中": "Considerando",
  "Curp号": "CPF",
  "已归档": "Arquivado",
  "是否需要pad": "Precisa de tablet? ",
  "点击校准": "Calibrar coordenadas",
  "附件照片": "Fotos anexas",
  "%s级": "Categoria %s",
  "人工标记平台：": "Anual: ",
  "审核通过商户数": "Verificando estabelecimento",
  "老版无Curp": "Versão antiga sem CPF",
  "首页": "Início",
  "商机无效": "Lead inválido",
  "未完成": "Não concluído",
  "支付验证": "Verificação de pagamento",
  "返回": "Voltar",
  "账号无法登陆": "Não consigo acessar",
  "纳税照片": "Anexo de foto",
  "建议拍摄店面照片": "Recomendamos fotos da fachada do estabelecimento",
  "标题": "Título",
  "不承诺": "Sem garantias",
  "不能超过%d字": "Não pode exceder %s caracteres",
  "佣金补贴比例": "Porcentagem de recompensa da Tarifa 99",
  "放弃": "Desistir",
  "请选择营业天数": "Selecionar dias de funcionamento",
  "KP名": "Nome KP",
  "单次最大扣费金额": "Cobrança máxima por pedido",
  "持卡人姓": "Sobrenome do beneficiário",
  "请输入门店ID": "Por favor, insira o ID da loja",
  "售卖时间": "Horário de funcionamento",
  "是否有异常标签": "Com etiquetas erradas",
  "是否有违规记录": "Existem registros de violação",
  "审批通过": "Verificado",
  "上传最大数量为%d张，图片上限为5MB": "Enviar até %d imagens com tamanho máximo de 5 MB",
  "银行代理number": "Agência",
  "地区": "Região",
  "门店logo": "Logotipo do estabelecimento",
  "商家不愿培训": "A loja não deseja receber treinamento",
  "审核中商户数": "Estabelecimento aprovado",
  "银行": "Banco",
  "已完成设置": "Configuração concluída",
  "已添加": "Adicionado",
  "复制成功": "Copiar bem sucedido",
  "愿意改善": "Deseja fazer melhorias",
  "首次有效上线时间": "Primeiro horário online válido",
  "My Number卡": "My Number Card",
  "设备回收": "Devolução do dispositivo",
  "补充照片": "Outras fotos de referência",
  "再次尝试电话联系": "Tente entrar em contato com o estabelecimento novamente",
  "填写拜访": "Inserir detalhes da visitação",
  "门店POI不能为空": "Local do estabelecimento não pode ser deixado em branco",
  "商机信息": "Informações do lead",
  "Pad": "Tablet",
  "经营状态": "Horário de funcionamento",
  "与KP完成沟通即视为有效拜访": "Visitar e falar com o representante do estabelecimento foi produtivo",
  "快速拍摄": "Captura de tela",
  "设备故障": "Dispositivo com problemas",
  "菜单信息": "Informações do Cardápio",
  "出生日期": "Data de nascimento",
  "自配送费": "Taxa de entrega do estabelecimento",
  "（创建超级管理员账号）": "（Criar conta de superadministrador）",
  "请输入": "Especifique",
  "法人姓": "Pessoa coletiva Sobrenome",
  "朗姆酒": "Rum",
  "合同记录": "Registros do contrato",
  "待办任务": "Tarefas Pendentes",
  "（商家接收邮件）": "（Endereço de e-mail da loja）",
  "已首次上线商户数": "Número de comerciantes de Primeira vez online",
  "不想使用外卖模式": "Não deseja utilizar o modo de entrega",
  "一般酒精产品贩卖准证": "Licença geral de venda de álcool",
  "请选择": "Selecione",
  "营业时间段不能重叠": "Não se pode definir o mesmo horário comercial",
  "有特殊情况不能上线": "Não consegue se conectar devido a circunstâncias especiais",
  "门店PAD信息": "Informações do tablet do estabelecimento",
  "商户调研": "Pesquisa do estabelecimento",
  "葡萄酒": "Vinho",
  "推迟": "Pendente",
  "再次申请": "Aplicar novamente",
  "自配送佣金比例": "Taxa de serviço de entrega própria",
  "门店地址": "Endereço do estabelecimento",
  "推荐完成": "Sugestão de tarefas a serem concluídas",
  "拜访内容": "Tipo de visita",
  "活期": "Conta Corrente",
  "创建时间": "Criado em",
  "过期拜访": "Visitas após a expiração",
  "刷新成功": "Atualização concluída",
  "解约": "Rescindir contrato",
  "价格承诺": "Compromisso de preço",
  "电子合同": "Contrato eletrônico",
  "KP电话": "Telefone do representante do estabelecimento",
  "不愿配合": "Não disposto a cooperar",
  "银行流水单": "Extrato bancário",
  "是否需要拍照": "É necessário tirar uma foto?",
  "请输入13位有效数字": "Insira um número válido de 13 dígitos",
  "LTE": "LTE",
  "PAD领取人": "Destinatário do tablet",
  "银行名称": "Nome do banco",
  "确定": "Confirmar",
  "金额": "Total",
  "待领取": "Não reivindicada",
  "停止营业": "Interromper operações",
  "合作谈判": "Negociações comerciais",
  "KP姓名:": "Nome responsável pela operação do estabelecimento",
  "商机详情": "Detalhes do lead",
  "信息未完善": "Informações incompletas",
  "CPF": "CPF",
  "查看": "Ver",
  "证件照片": "Foto da identidade",
  "税号": "IE",
  "促进商户首次上线": "Incentivar a loja a se conectar pela primeira vez",
  "语言": "Idioma",
  "登录商户账号": "Acessar a conta do estabelecimento",
  "未联系到关键目标": "Falha ao entrar em contato com os pontos de contato",
  "任务类型": "Tipo de tarefa",
  "打款授权书": "Autorização do pagamento",
  "营业时间": "Horário de funcionamento",
  "电话培训": "Treinamento por telefone",
  "联系不上": "Não foi encontrado",
  "编辑商机": "Editar leads",
  "拜访时间": "Data",
  "纸质合同": "Cópia impressa",
  "保存草稿": "Salvar rascunho",
  "账号": "Número da conta",
  "接收人": "Destinatário",
  "円": "円",
  "无多余人力(过于繁忙)": "Quantidade insuficiente de funcionários (muito ocupado)",
  "预计参加：店铺配置": "Planejando participar: configurado pelo estabelecimento",
  "WIFI": "WIFI",
  "无效": "Não está em vigor",
  "应上线商户数": "Deve ser um estabelecimento online",
  "结算信息": "Informações de pagamento",
  "(R$)": "(R$)",
  "关于": "Sobre",
  "设置": "Configurações",
  "担心配送质量": "Preocupação sobre a qualidade da entrega",
  "数值只能是%s位小数": "Deve ser arredondado para %s casa(s) decimal(is)",
  "CKA": "CKA",
  "录入合同基础信息": "Insira informações básicas do contrato",
  "未见KP": "Não foi possível contatar KP",
  "不参加": "Não participará",
  "不保存": "Descartar",
  "酒精销售许可证": "Licença para venda de bebidas alcoólicas",
  "手机号": "Número de telefone",
  "疑似KA": "KA previsto",
  "是否有效拜访": "A visita foi produtiva?",
  "完成培训": "Treinamento concluído",
  "请输入有效的门店id": "Insira um shopid válido",
  "持卡人姓名": "Nome do titular",
  "系统标记平台：": "Auto: ",
  "其他": "Outro",
  "人工标记平台": "Anual",
  "品牌名称": "Nome da marca",
  "选择日期": "Selecionar data",
  "必须为%d或%d字": "Deve ter %d ou %d caracteres",
  "重复门店ID": "ID de estabelecimento duplicado",
  "工商登记注册地": "Inclusão de registro da empresa",
  "白兰地": "Conhaque",
  "数据": "Dados",
  "复制": "Copiar",
  "商户签约": "Funil",
  "乙方邮箱": "Email do estabelecimento",
  "无营业资质": "Qualificações comerciais ausentes",
  "活跃程度": "nível ativo",
  "找不到店": "Não foi possível localizar o estabelecimento",
  "提交开店申请商户数": "Estabelecimentos aguardando assinatura",
  "不合作原因": "Motivo para não realizar parceria",
  "关联品牌名称": "Nome da marca relacionada",
  "门店距离": "Distância do estabelecimento",
  "门店名称": "Nome fantasia do estabelecimento",
  "陪访人": "Pessoas que acompanharam o representante 99 na visita",
  "银行账户digit": "Conta dígito",
  "营业时间不能重复设置": "Não se pode repetir as configurações do horário comercial",
  "纳税信息": "Informações fiscais",
  "完善以下": "Finalize o seguinte",
  "乙方联系人手机": "Telefone da segunda parte",
  "30天后解约": "Contrato rescindido após 30 dias",
  "上传照片不能超过%dMB，请重新上传": "O tamanho do arquivo de imagem não pode exceder %dMB. Envie novamente",
  "电话支持字符：数字、英文逗号，录入其他符号，不允许提交": "Caracteres aceitos para números de telefone: números e vírgulas (qualquer outro caractere impedirá o envio)",
  "您当前的网络环境不太好": "Seu ambiente de rede atual não é muito bom",
  "审核失败": "Negado",
  "模式选择": "Selecionar formato de contrato",
  "商圈": "Região-alvo",
  "类型": "Tipo",
  "启动费太高": "A taxa de implementação é muito alta",
  "加价限制": "Teto máx.",
  "获得初步意向": "Demonstrou interesse inicial",
  "任务ID": "ID da tarefa",
  "不确定合作意向": "O interesse na cooperação não foi confirmado",
  "添加营业时间": "Adicionar horário de funcionamento",
  "CNPJ号必须为14位数字": "O CNPJ deve ser um número de 14 dígitos",
  "请输入半角片假，不能超过48个字符": "Digite katakana de meia largura, não pode exceder 48 caracteres",
  "回收pad": "Devolver tablet",
  "商家信息": "Informação do estabelecimento",
  "自配送范围及时长": "Horário e área de entrega do estabelecimento",
  "市政经营许可证": "Licença municipal de funcionamento",
  "至": "a",
  "图片": "Imagem",
  "未完善": "Não concluído",
  "打烊中": "Estabelecimento fechado",
  "菜单": "Menu",
  "下一步": "Avançar",
  "正式拜访": "Visita combinada previamente",
  "具备上线能力": "Pronta para lançamento",
  "金额(MX$)": "Total (R$)",
  "平台配送最低服务费": "Taxa de serviço mínimo por pedido da plataforma (valor absoluto)",
  "系统标记平台": "Auto",
  "请选择无效拜访原因": "Por que a visita não foi produtiva?",
  "过于繁忙": "Muito ocupado",
  "日本": "Japão",
  "若证件类型选择“老版无Curp”，需上传补充附件": "Se o tipo de documento “Versão antiga sem CPF” for selecionado",
  "拜访方式": "Método de visitação",
  "选择城市": "Selecione a cidade",
  "退出登录": "Sair",
  "日常提醒商家上线": "Lembrete de rotina para o estabelecimento se conectar",
  "回收未完成": "Não devolvido",
  "上传最大数量为1张，图片上限为5M": "Enviar até 1 imagem com tamanho máximo de 5 MB",
  "千": "mil",
  "签约%d周后": "%d semana(s) após a assinatura",
  "乙方联系人CPF": "CPF do contato do restaurante",
  "照片": "Foto",
  "法人姓名": "Representante Legal",
  "营业信息": "Informações comerciais",
  "添加电话": "Adicionar número de telefone",
  "打开地图失败": "Não foi possível abrir o mapa",
  "商家位置": "Localização do estabelecimento",
  "开始扣费时间": "Quando iniciar a cobrança",
  "我负责的": "Supervisionado por mim",
  "平台配送": "Modelo Full Service - plataforma é responsável pela entrega",
  "KP邮箱": "Email da pessoa responsável pela operação do estabelecimento",
  "封禁": "Suspensão",
  "合同信息": "Informações do contrato",
  "卫生安全通知": "Vigilância sanitária (licença)",
  "账号名称": "Nome da conta",
  "现金支付": "Pagamento em dinheiro",
  "座机": "Telefone fixo",
  "乙方联系人CPF照片": "Foto do CPF com Data de Nascimento da pessoa que assinará o contrato (sócio administrador ou pessoa com procuração)",
  "许可证有效期": "Período de validade da permissão",
  "还在考虑，需要追客": "Ainda considerando, é necessário fazer um acompanhamento com o cliente",
  "支行名称": "Nome da agência bancária",
  "门店ID": "ID do loja",
  "提交材料": "Enviar documentos",
  "失败原因": "Motivo para recusa",
  "无法联系到KP": "Não foi possível entrar em contato com KP",
  "授权人": "Nome do diretor",
  "手机": "Telefone",
  "请输入XXX-XXXX": "EspecifiqueXXX-XXXX",
  "我的新增": "Recente",
  "KP名片假名": "Nome KP Katakana",
  "没联系到": "Não foi encontrado",
  "不需要": "Não",
  "已拜访商机数": "Estabelecimento visitado",
  "仅支持数字输入": "Só pode conter números",
  "铺设失败": "Erro",
  "任务完成": "Tarefa concluída",
  "复制链接": "Copiar link",
  "已完成": "Concluído",
  "草稿中": "Rascunho",
  "否": "Não",
  "商户主体类型": "Informações da empresa",
  "经营品类": "Tipo de item",
  "待定": "Indefinido",
  "完单量": "Pedido concluído",
  "担心外卖模式(不想使用外卖模式)": "Com receio de utilizar o modo de entrega (não deseja utilizar o modo de entrega)",
  "乙方注册地址邮编": "Endereço registrado da Parte B",
  "营业执照": "Licença comercial",
  "账户余额：": "Valor da conta: ",
  "结算信息照片": "Foto do pagamento",
  "价格信息": "Informações de preços",
  "证件类型": "INE/INF",
  "威士忌": "Whisky",
  "在线": "Online",
  "销售姓名": "Representante 99",
  "合同照片": "Foto do contrato",
  "龙舌兰酒": "Tequila",
  "编辑商机成功": "Dados do lead editados",
  "拜访对象": "Pessoa a ser visitada",
  "营业中": "Estabelecimento aberto",
  "请输入数字": "Só pode conter números",
  "全部": "Tudo",
  "取消订单量": "Pedido cancelado",
  "电话": "Ligar",
  "请输入门店名称搜索": "Insira o nome do estabelecimento",
  "当前门店总数": "Total de representantes do estabelecimento",
  "已签约商户数": "Estabelecimento assinou o contrato",
  "日常维护": "Suporte de rotina",
  "合同版本": "Versão do contrato",
  "商机价值": "Classificação de leads",
  "联系方式": "Informação de contato",
  "管控状态：": "Status do controle: ",
  "审批中": "Verificando",
  "拜访目标": "Finalidade da visita",
  "门店类型": "Tipo de estabelecimento",
  "创建成功": "Adicionado corretamente",
  "账户类型": "Tipo de conta",
  "KA BD": "BD do time de KA",
  "门店名称片假名": "Nome fantasia do estabelecimento Katakana",
  "乙方注册地址片假名": "Endereço registrado do estabelecimento Katakana",
  "对私": "Pessoa Física",
  "个人企业": "Empresário Individual",
  "订单均价": "Preço médio dos pedidos",
  "需要完善": "Formulário incompleto",
  "撤销申请": "Solicitar cancelamento",
  "请先输入门店地址": "Insira primeiro o endereço do estabelecimento",
  "默认": "Padrão",
  "请补全营业时间": "Adicionar horário de atendimento",
  "校准POI": "Calibrar coordenadas",
  "全部门店": "Todos os estabelecimentos",
  "不支持": "Não",
  "暂停经营": "Temporariamente encerrada",
  "添加营业时间段": "Adicionar horários",
  "合同基础信息": "Informações básicas do contrato",
  "请输入5位有效数字": "Insira um número válido de 5 dígitos",
  "提交审批后，在审批过程中信息不可修改，是否确认提交？": "Não é possível modificar informações após o envio para aprovação. Continuar com o envio?",
  "证件号": "Nº do documento",
  "有限责任公司": "Sociedade Limitada",
  "长期有效": "longo prazo eficaz",
  "乙方注册地址": "Endereço registrado do estabelecimento",
  "饮料店期间限定酒品贩卖准证": "Licença limitada de venda de bebidas alcoólicas durante a loja de bebidas",
  "请录入关闭原因": "Por favor, digite o motivo do fechamento",
  "土地使用许可证": "Viabilidade de uso de terreno",
  "重复门店": "Duplicado",
  "普通商家": "Estabelecimento Normal",
  "距离": "Distância",
  "不小于%d": "não menor que %d",
  "不愿完成": "Não deseja concluir",
  "推迟发放": "Liberação adiada",
  "必须为%d字": "Deve ter %d caracteres",
  "担心外卖模式": "Sem confiança na entrega",
  "当该餐厅存在多个经营者时，此处必须填写合同签署人或授权合同签署人姓名": "Se um restaurante tiver vários operadores, o nome de todos os signatários do contrato ou agentes autorizados deve ser incluído aqui.",
  "提交成功！": "Envio concluído!",
  "未完成PAD发放": "Liberação de tablet(s) não concluída",
  "有效商机数": "Leads efetivos",
  "无相关信息": "Não há dados disponíveis",
  "查看拜访记录": "Ver histórico de visitas",
  "抽佣：": "Tarifa 99: ",
  "删除": "Excluir",
  "银行卡号": "Nº da conta bancária",
  "其他信息": "Outras informações",
  "起始时间": "Data de início",
  "预计进行改善": "Planejando fazer melhorias",
  "不愿改善": "Não deseja fazer melhorias",
  "签约数据": "Dados de Inscrição",
  "登记簿照片": "Foto do registro",
  "电销团队": "Equipe de telemarketing",
  "完成时间": "Concluído em",
  "放弃原因": "Motivo da desistência",
  "KP电话:": "Telefone do representante do estabelecimento",
  "完成PAD发放": "Liberação de tablet(s) concluída",
  "完成工作": "Concluir trabalho",
  "提交中": "Em andamento",
  "营业时间段": "Horário de funcionamento",
  "任务完成标准": "Requisitos de conclusão de tarefas",
  "商户官网": "Site oficial do comerciante",
  "门脸照片": "Foto da entrada do estabelecimento",
  "门店电话:": "Nº de telefone do estabelecimento",
  "新建商机成功": "Novo lead adicionado",
  "添加拜访计划": "Acrescentar calendário de visitas",
  "营业执照照片": "Foto do alvará de funcionamento",
  "驾照": "Carteira de motorista",
  "个人信息": "Meu perfil",
  "订单量": "Pedido iniciado",
  "董事": "Diretor",
  "有效期": "Período de validade",
  "周三": "Qua",
  "高端饭店": "Conceito",
  "是否已经加入其他外卖平台？": "O estabelecimento funciona com outra plataforma de entrega?",
  "周一": "Seg",
  "点击查看原因": "Ver detalhes",
  "去修改": "Modificar",
  "KP电话是店长账户": "O telefone KP é a conta do gerente",
  "确认要清空搜索记录吗？": "Apagar histórico de pesquisa?",
  "状态机": "Máquina de status",
  "暂无数据": "Sem dados",
  "拜访详情": "Visita",
  "启动费": "Taxa de ativação",
  "疑似CKA": "CKA previsto",
  "选择职位": "Selecionar cargo",
  "提交人": "Remetente",
  "签约信息": "Detalhes do contrato",
  "审核中": "Verificando",
  "请输入半角片假名": "Digite katakana de meia largura",
  "请选择无意愿原因": "Especificar motivo da falta de interesse",
  "（多选）": "(selecionar vários)",
  "上一步": "Anterior",
  "周五": "Sex",
  "执行人": "Atribuído a",
  "填写拜访备注可供后续跟进参考": "Adicione observações; pode incluir pontos de acompanhamento da visita",
  "扣费次数大于等于1": "Número de deduções maior ou igual a 1",
  "线下": "Pessoalmente",
  "效率": "Eficiência",
  "无效商机": "Lead inválido",
  "拜访历史": "Registros de visita",
  "封禁中": "Suspenso pela plataforma",
  "原因": "Motivo",
  "CPF号必须为11位数字": "O CPF deve ser um número de 11 dígitos",
  "周二": "Ter",
  "保存": "Salvar",
  "商户号": "Número do comerciante",
  "参加": "Participará",
  "万": "Dez mil",
  "乙方联系方式": "Telefone da outra parte",
  "加价限制（%）": "Teto máx.",
  "上传交付照片": "Enviar foto da entrega do tablet",
  "商户主体类型为公司时需提供此项内容": "Obrigatório se o tipo de entidade do estabelecimento for empresa",
  "编辑经营信息": "Editar dados operacionais",
  "开户公司CNPJ": "CNPJ da conta de abertura da empresa",
  "门店信息": "Informações do estabelecimento",
  "当前数据计算至:": "Dados atuais atualizados para: ",
  "店长": "Gerente da loja",
  "已完成培训": "Treinamento concluído",
  "不限": "Sem limites",
  "品牌授权书": "Autorização da marca",
  "P1": "P1",
  "请输入3位有效数字": "Insira um número válido de 3 dígitos",
  "P0": "P0",
  "P2": "P2",
  "转让": "Vendido / Novo dono",
  "自入驻": "Configuração da",
  "老版有Curp": "Versão antiga com CPF",
  "店内环境": "Foto do interior",
  "详细原因": "Motivo detalhado",
  "金酒": "Gin",
  "请输入7位有效数字": "Insira um número válido de 7 dígitos",
  "签字授权书": "Autorização de assinatura",
  "无效原因": "Motivo para ser inválido",
  "持卡人地址": "Endereço do titular",
  "拜访备注": "Observações sobre a visita",
  "标记问题门店": "Reportar problema do estabelecimento",
  "已完善": "Concluído",
  "指定": "Especificar",
  "发起者": "Iniciador",
  "抽佣问题": "Avaliar problemas na Tarifa 99",
  "合法代表": "Representante legal",
  "自定义": "Personalizar",
  "店铺主体类型是法人时必填（13位数，国税厅公布的法人号码）": "Necessário se o tipo de corpo principal da loja for uma pessoa coletiva (13 dígitos, número da pessoa coletiva anunciada pela Agência Tributária Nacional)",
  "单次最大扣费金额(MX$)": "Cobrança máxima por pedido (R$)",
  "重复门店名称": "Nome de estabelecimento duplicado",
  "KP姓名": "Nome responsável pela operação do estabelecimento",
  "IMEI": "IMEI",
  "负责人表示不合作": "Pessoa responsável não demonstrou interesse em cooperar",
  "去升级": "Atualizar agora",
  "将本页截图发送至didi@didichuxing.com;总部进行人工线下校验，并在7日内反馈申诉结果;": "Envie uma captura de tela desta página para didi@didichuxing.com; a sede realizará uma inspeção manual e responderá às reclamações em até 7 dias.",
  "银行代理digit": "Agência dígito",
  "巴西": "Brasil",
  "捡入": "Solicitar",
  "线上支付": "Pagamento online",
  "竞品独家签约": "Contrato exclusivo com um concorrente",
  "总评价人数": "Número de avaliadores",
  "周六": "Sáb",
  "门店电话": "Telefone do estabelecimento com DDD",
  "标红信息即可完成添加": "Preencha todos os campos marcados em vermelho",
  "疑似CKA/KA": "CKA/KA previsto",
  "执行者": "Atribuído a",
  "法人CPF照片": "Foto do CPF com Data de Nascimento do representante legal (sócio administrador da empresa)  ",
  "待办事项": "Tarefas restantes",
  "预计休业": "Planejando encerrar as operações comerciais",
  "其他筛选": "Outros filtros",
  "是否自配送：": "Modelo Marketplace - restaurante é responsável pela entrega: ",
  "当前定位失败": "Erro no posicionamento",
  "优先级": "Prioridade",
  "任务来源": "Fonte da tarefa",
  "可提现金额：": "Valor para saque (BR): ",
  "自配送订单量（单/周）": "Quantidade vendida via entrega própria por dia (pedidos/semana)",
  "审核完成": "Verificação concluída",
  "店员": "Funcionário",
  "冻结金额：": "Valor bloqueado (BR):",
  "签约状态：": "Status da assinatura: ",
  "时间格式错误": "Erro no formato do horário",
  "审批失败": "Negado",
  "确定合作": "Cooperação confirmada",
  "啤酒": "Cerveja",
  "接收电子合同的邮箱": "Caixa de correio para receber contrato eletrônico",
  "门店照片": "Foto do estabelecimento",
  "电话预约": "Agendar uma visita",
  "选择商圈": "Selecione a região-alvo",
  "KA": "KA",
  "结束时间": "Horário de término",
  "确认银行卡号": "Confirmar nº do cartão do banco",
  "在留卡": "Cartão de residência",
  "访谈&调研": "Entrevista e pesquisa",
  "承诺": "Garantia",
  "实际上线商户数": "Estabelecimentos online",
  "暂不支持复制功能": "Recurso de cópia indisponível",
  "不能为空": "não pode ser deixado em branco",
  "暂停营业": "Fechada temporariamente",
  "提案失败": "Estratégia malsucedida",
  "经营信息": "Dados operacionais",
  "依据门店POI反解": "Com base nas coordenadas do estabelecimento",
  "拜访结果": "Resultado da visita",
  "乙方联系人姓": "Informações de contato do assinante Sobrenome",
  "银行卡号必须为18位": "O nº do cartão do banco deve ter 18 dígitos",
  "储蓄": "Conta Poupança",
  "首位必须是1，必须输入11位": "O primeiro dígito deve ser 1 e deve conter 11 dígitos",
  "无银行账号": "Sem conta bancária",
  "KP所属部门": "departamento de kp",
  "成功留存": "Retido com sucesso",
  "伏特加": "Vodka",
  "暂时不愿上线": "Não deseja se conectar neste momento",
  "沟通经营问题": "Discutir problemas operacionais",
  "支持": "Sim",
  "请输入正确的邮箱地址": "Insira um e-mail válido",
  "确认要退出吗？": "Tem certeza de que deseja sair?",
  "乙方联系人": "Nome da pessoa que assinará o contrato (sócio administrador ou pessoa com procuração)",
  "公证编号和地区": "Número do cartório e região",
  "后续陌拜": "Chamada fria subsequente",
  "持卡人名": "Nome do beneficiário",
  "通过时间": "Aprovado em",
  "请输入银行名称或五十音": "Insira Banco beneficiário",
  "指已签约并且上线接单的门店": "Refere-se a estabelecimentos que assinaram um contrato e estão atualmente aceitando pedidos",
  "线下店铺菜单": "Fotos do cardápio",
  "无多余人力": "Não consegue atender",
  "格式错误": "Erro de formato",
  "合同生效日期": "Data de validade do contrato",
  "分发失败": "não foi possível atribuir",
  "使用此功能需升级至最新版本": "Para acessar esse recurso, você precisa fazer a atualização para a versão mais recente.",
  "任务分发": "Atribuir tarefa",
  "乙方联系人名片假名": "Informações de contato do assinante Primeiro nome Katakana",
  "ESC": "ESC",
  "无法获取手机定位，请检查": "Não foi possível recuperar a localização do telefone. Verifique",
  "上传最大数量为3张，图片上限为5M": "Enviar até 3 imagens com tamanho máximo de 5 MB",
  "佣金审核证明": "Certificado de análise da recompensa",
  "范围": "Região",
  "公司公证": "Certificados da empresa",
  "审核通过": "Verificado",
  "查看申请": "Ver inscrição",
  "未签约": "Contrato não assinado",
  "申请签约": "Solicitar assinatura",
  "已校准": "Coordenadas salvas",
  "审核结束": "Resultados da verificação",
  "具备上线能力商户数": "Estabelecimento pronto para lançamento",
  "邮编": "CEP",
  "手机和座机都只支持10位数字": "O número de telefones fixos deve ter 10 dígitos, e o de celulares, 11 dígitos",
  "不允许特殊字符": "Não pode conter caracteres especiais",
  "KP姓": "KP sobrenome",
  "店内桌数（桌）": "Número de mesas",
  "待提交": "A ser enviado",
  "附件说明": "Descrição dos anexos",
  "查看示例": "Ver exemplo",
  "工商登记号码": "Nº de registro da empresa",
  "去填写": "Adicionar informações",
  "待办理": "Não finalizada",
  "账户状态：": "Status da conta: ",
  "设备铺设结果": "Resultado de configuração do dispositivo",
  "上传失败，请重新上传": "Falha no envio, tente novamente",
  "支持上传附件，含关键信息页需单独拍照上传至【执照照片】": "Pode enviar anexos. A página de informações principais deve ser fotografada separadamente e enviada para [Foto da Licença].",
  "签约中": "Em andamento",
  "不需要pad": "Tablet não obrigatório",
  "高端饭店不做外卖": "Restaurante de alto nível sem serviço de entrega",
  "最多%d个": "Máx. de %d",
  "合同编号": "Nº do contrato",
  "门店POI": "Localização do estabelecimento",
  "开店信息": "Informações de abertura do estabelecimento",
  "商家开店检查": "Inspeção do estabelecimento",
  "KP电话（仅支持手机）": "Telefone da pessoa responsável pela operação do estabelecimento com DDD (somente celular)",
  "关联签约主体名称": "Nome do signatário relacionado",
  "法人姓片假名": "Pessoa coletiva Sobrenome Katakana",
  "成功": "OK",
  "开始时间": "Horário de início",
  "审批邮件": "E-mail de aprovação",
  "门店品类": "Categorias do estabelecimento",
  "运营数据": "Dados operacionais",
  "新建商机": "Adicionar novo lead",
  "任务基础信息": "Informações da tarefa",
  "食堂订单量（单/周）": "Volume de refeições no local (Volume de refeições no local)",
  "新版": "Nova versão",
  "需要": "Sim",
  "佣金策略合同模板": "Contrato com subsídio da Tarifa 99",
  "任务详情": "Detalhes da tarefa",
  "预计参加：DiDi配置": "Planejando participar: configurado pela 99",
  "请选择等待原因": "Selecionar motivo da espera",
  "信息尚未保存，是否保存？": "Você tem alterações não salvas. Salvar agora?",
  "请选择接收人": "Selecionar destinatário",
  "股份有限公司": "Sociedade Anônima",
  "乙方联系人头衔": "Cargo",
  "处理时间": "Processado em",
  "打款": "Pagamento",
  "资质类型": "Tipo de qualificação",
  "门店价值": "Categoria do estabelecimento",
  "编辑": "Editar",
  "当前位置距商家": "A localização atual está a",
  "商家是否在线：": "Status online: ",
  "护照": "Passaporte",
  "发起验证申请": "Verificar conta de pagamento",
  "银行账户number": "Conta bancária",
  "请填写真实原因": "Especifique o motivo",
  "不能超过%d": "Não pode exceder %d",
  "公证日期": "Data de autenticação",
  "已签章": "Contrato assinado",
  "商户留存措施": "Medidas de retenção da loja",
  "自配送": "Modelo Marketplace - restaurante é responsável pela entrega",
  "失败原因详情": "Motivo para recusa",
  "金额(円)": "Total(円)",
  "土地使用许可证执照照片": "Foto de documento com CNPJ da empresa",
  "签约": "Assinar contrato",
  "任务": "Tarefa",
  "首次完成签约时间": "Horário da primeira assinatura",
  "当前门店总数=未签约门店+签约中门店+已签约门店": "Número total de estabelecimentos = estabelecimentos ainda sem assinatura + estabelecimentos em processo de assinatura + estabelecimentos com contratos assinados",
  "上传最大数量为%d张，图片上限为%dM": "Enviar até %d imagem(ns), tamanho máximo do arquivo de %dMB",
  "法人名": "Pessoa coletiva Primeiro nome",
  "个人": "EIRELI",
  "确定合作，准备收集资料": "Cooperação confirmada, preparar para coletar informações",
  "上传最大数量为1张，图片上限为5MB": "Enviar até 1 imagem com tamanho máximo de 5 MB",
  "乙方联系方式是超级管理员账户": "As informações de contato da Parte B são uma conta de superadministrador",
  "乙方联系人名": "Informações de contato do assinante Primeiro nome",
  "乙方联系人姓片假名": "Informações de contato do assinante Sobrenome Katakana",
  "有效在线商户数": "Estabelecimentos online ativos",
  "歇业中": "Estabelecimento suspenso",
  "基础信息": "Informações básicas",
  "销售电话": "Telefone do Representante 99",
  "重复门店与创建门店的距离": "Distância entre estabelecimento duplicado e novo",
  "门店": "Estabelecimento",
  "全部区域": "Todas as regiões",
  "拆迁": "Não foi possível localizar",
  "请选择失败原因": "Especificar o motivo do erro",
  "搜索记录": "Histórico de busca",
  "门店地址片假名": "Endereço do estabelecimento Katakana",
  "未添加": "Não adicionado",
  "加载中": "carregando",
  "请输入12位有效数字": "Insira um número válido de 12 dígitos",
  "不愿上线": "Não deseja se conectar",
  "CKA/KA BD": "CKA/KA BD",
  "完成电话": "Chamada concluída",
  "乙方名称": "Razão Social",
  "更新时间": "Tempo de atualização",
  "标准合同模板": "Contrato de modelo padrão",
  "签约状态（多选）": "Status do contrato (selecionar vários)",
  "12位数，法人登记簿上的号码": "12 dígitos, o número no registro da pessoa coletiva",
  "请在Gattaran查看": "Ver mais informações no Gattaran",
  "被授权人证件照片": "Foto de documento de identificação da pessoa que assinará o contrato",
  "希望解约/回收pad": "Deseja rescindir contrato/devolver tablet",
  "乙方联系方式（仅支持手机）": "Telefone da pessoa que assinará o contrato (sócio administrador ou pessoa com procuração) - Apenas Celular com DDD",
  "附件类型": "Tipo de anexo",
  "计划完成设置": "Planejando concluir a configuração",
  "有合作意向": "Há interesse na parceria",
  "非餐饮": "Não presta serviços de A&B",
  "附件文件": "Documentos complementares",
  "法人信息": "Informações da empresa",
  "点击上传": "Subir",
  "扣费次数": "Deduções",
  "培训使用方法": "Treinamento do sistema",
  "陌拜": "Chamada fria",
  "已完成改善": "Melhorias concluídas",
  "扣费比例": "Valor da dedução",
  "预定上线": "Planejando se conectar",
  "没有更多数据了": "Não há mais dados disponíveis",
  "未知": "desconhecido",
  "提交": "Subir",
  "填写拜访信息": "Descreva resumidamente a visita",
  "新功能培训": "Treinamento para novos recursos/funções",
  "详细录入规则": "Ver regras de formato",
  "不再发放": "Não haverá nova liberação",
  "门店详情": "Detalhes do estabelecimento",
  "提交时间": "Enviado em",
  "登记簿": "Registre-se",
  "备注": "Observações",
  "不在线": "Offline",
  "提交后将无法正常签约": "O processo de assinatura normal não estará disponível após o envio",
  "铺设成功": "OK",
  "催促商家首次上线": "Lembrar a loja de se conectar pela primeira vez",
  "对公": "Pessoa Jurídica",
  "商户运营价值": "Classificação da loja",
  "米": "m do estabelecimento",
  "创建失败": "Erro",
  "已核准": "Aprovado",
  "确认签章时需上传合同附件，请在Gattaran完成确认！": "Ao verificar uma assinatura, você deve enviar os apêndices do contrato. Conclua a verificação no Gattaran.",
  "提交至审批": "Enviar para aprovação",
  "在线状态：": "Status online:",
  "资质信息": "Documentação",
  "物料发放": "Liberação de suprimentos",
  "姓名": "Nome",
  "Opening Call": "Fazendo chamada",
  "两次银行卡号不一致！": "Os números dos cartões bancários não conferem",
  "取消": "Cancelar",
  "法人证件": "Foto de INE/IFE da empresa",
  "门店营业时间": "Horário do estabelecimento",
  "无法获取应用版本信息": "Não foi possível recuperar as informações de versão do aplicativo",
  "商家位置为": "Localização do estabelecimento",
  "Curp号必须为大写字母": "O CPF deve conter apenas números",
  "活动招商": "Promoções de evento",
  "墨西哥": "México",
  "资料录入": "Dados de entrada",
  "地区与语言": "Região e idioma",
  "平台配送佣金比例": "Taxa de serviço da plataforma",
  "待完成": "Em andamento",
  "开户公司名": "Nome da conta de abertura da empresa",
  "选项和输入框不能为空": "Preencha todos os campos obrigatórios",
  "邮件&短信已发送给商家": "E-mail e SMS enviados à loja",
  "您提交的无效原因有误，请检查": "O motivo inválido que você enviou está errado, verifique",
  "本模块支持上传文件，可至PC端操作": "Os documentos podem ser enviados via PC",
  "确定要验证当前店铺的银行卡号？点击【确定】发起【支付验证】申请": "Tem certeza de que deseja verificar a conta bancária do estabelecimento atual? Toque em 'OK' para verificar",
  "发送邮件&短信": "Enviar e-mail e SMS",
  "正常门店": "Estabelecimento normal",
  "设备铺设": "Configuração de dispositivo",
  "销售数据": "Dados de venda",
  "请选择无效原因": "Selecionar motivo para ser inválido"
}